(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~timePicker"],{

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__(5);
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/vnode.js
var vnode = __webpack_require__(7);

// EXTERNAL MODULE: ./src/base/vc-trigger/index.js + 9 modules
var vc_trigger = __webpack_require__(25);

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// CONCATENATED MODULE: ./src/base/vc-time-picker/Header.jsx




var Header = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    format: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string,
    disabledDate: vue_types["a" /* default */].func,
    placeholder: vue_types["a" /* default */].string,
    clearText: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].object,
    inputReadOnly: vue_types["a" /* default */].bool.def(false),
    hourOptions: vue_types["a" /* default */].array,
    minuteOptions: vue_types["a" /* default */].array,
    secondOptions: vue_types["a" /* default */].array,
    disabledHours: vue_types["a" /* default */].func,
    disabledMinutes: vue_types["a" /* default */].func,
    disabledSeconds: vue_types["a" /* default */].func,
    // onChange: PropTypes.func,
    // onClear: PropTypes.func,
    // onEsc: PropTypes.func,
    allowEmpty: vue_types["a" /* default */].bool,
    defaultOpenValue: vue_types["a" /* default */].object,
    currentSelectPanel: vue_types["a" /* default */].string,
    focusOnOpen: vue_types["a" /* default */].bool,
    // onKeyDown: PropTypes.func,
    clearIcon: vue_types["a" /* default */].any
  },
  data: function data() {
    var value = this.value,
        format = this.format;
    return {
      str: value && value.format(format) || '',
      invalid: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.focusOnOpen) {
      // Wait one frame for the panel to be positioned before focusing
      var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
      requestAnimationFrame(function () {
        _this.$refs.input.focus();

        _this.$refs.input.select();
      });
    }
  },
  watch: {
    value: function value(val) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.setState({
          str: val && val.format(_this2.format) || '',
          invalid: false
        });
      });
    }
  },
  methods: {
    onInputChange: function onInputChange(e) {
      var _e$target = e.target,
          str = _e$target.value,
          composing = _e$target.composing;
      var _this$str = this.str,
          oldStr = _this$str === void 0 ? '' : _this$str;
      if (e.isComposing || composing || oldStr === str) return;
      this.setState({
        str: str
      });
      var format = this.format,
          hourOptions = this.hourOptions,
          minuteOptions = this.minuteOptions,
          secondOptions = this.secondOptions,
          disabledHours = this.disabledHours,
          disabledMinutes = this.disabledMinutes,
          disabledSeconds = this.disabledSeconds,
          originalValue = this.value;

      if (str) {
        var value = this.getProtoValue().clone();
        var parsed = external_moment_default()(str, format, true);

        if (!parsed.isValid()) {
          this.setState({
            invalid: true
          });
          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          this.setState({
            invalid: true
          });
          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          this.setState({
            invalid: true
          });
          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());

            this.__emit('change', changedValue);
          }
        } else if (originalValue !== value) {
          this.__emit('change', value);
        }
      } else {
        this.__emit('change', null);
      }

      this.setState({
        invalid: false
      });
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 27) {
        this.__emit('esc');
      }

      this.__emit('keydown', e);
    },
    getProtoValue: function getProtoValue() {
      return this.value || this.defaultOpenValue;
    },
    getInput: function getInput() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          placeholder = this.placeholder,
          inputReadOnly = this.inputReadOnly,
          invalid = this.invalid,
          str = this.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return h("input", babel_helper_vue_jsx_merge_props_default()([{
        "class": "".concat(prefixCls, "-input ").concat(invalidClass),
        ref: "input",
        on: {
          "keydown": this.onKeyDown,
          "input": this.onInputChange
        },
        domProps: {
          "value": str
        },
        attrs: {
          placeholder: placeholder,
          readOnly: !!inputReadOnly
        }
      }, {
        directives: [{
          name: 'ant-input'
        }]
      }]));
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls;
    return h("div", {
      "class": "".concat(prefixCls, "-input-wrap")
    }, [this.getInput()]);
  }
};
/* harmony default export */ var vc_time_picker_Header = (Header);
// EXTERNAL MODULE: ./node_modules/raf/index.js
var raf = __webpack_require__(14);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: ./src/base/vc-time-picker/Select.jsx
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function noop() {}

var Select_scrollTo = function scrollTo(element, to, duration) {
  // jump to target if duration zero
  if (duration <= 0) {
    raf_default()(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  raf_default()(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    prefixCls: vue_types["a" /* default */].string,
    options: vue_types["a" /* default */].array,
    selectedIndex: vue_types["a" /* default */].number,
    type: vue_types["a" /* default */].string // onSelect: PropTypes.func,
    // onMouseEnter: PropTypes.func,

  },
  data: function data() {
    return {
      active: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // jump to selected option
      _this.scrollToSelected(0);
    });
  },
  watch: {
    selectedIndex: function selectedIndex() {
      var _this2 = this;

      this.$nextTick(function () {
        // smooth scroll to selected option
        _this2.scrollToSelected(120);
      });
    }
  },
  methods: {
    onSelect: function onSelect(value) {
      var type = this.type;

      this.__emit('select', type, value);
    },
    onEsc: function onEsc(e) {
      this.__emit('esc', e);
    },
    getOptions: function getOptions() {
      var _this3 = this;

      var h = this.$createElement;
      var options = this.options,
          selectedIndex = this.selectedIndex,
          prefixCls = this.prefixCls;
      return options.map(function (item, index) {
        var _classnames;

        var cls = external_classnames_default()((_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classnames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classnames));
        var onClick = item.disabled ? noop : function () {
          _this3.onSelect(item.value);
        };

        var onKeyDown = function onKeyDown(e) {
          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) _this3.onEsc();
        };

        return h("li", {
          attrs: {
            role: "button",
            disabled: item.disabled,
            tabIndex: "0"
          },
          on: {
            "click": onClick,
            "keydown": onKeyDown
          },
          "class": cls,
          key: index
        }, [item.value]);
      });
    },
    handleMouseEnter: function handleMouseEnter(e) {
      this.setState({
        active: true
      });

      this.__emit('mouseenter', e);
    },
    handleMouseLeave: function handleMouseLeave() {
      this.setState({
        active: false
      });
    },
    scrollToSelected: function scrollToSelected(duration) {
      // move to selected item
      var select = this.$el;
      var list = this.$refs.list;

      if (!list) {
        return;
      }

      var index = this.selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      Select_scrollTo(select, to, duration);
    }
  },
  render: function render() {
    var _cls;

    var h = arguments[0];
    var prefixCls = this.prefixCls,
        options = this.options,
        active = this.active;

    if (options.length === 0) {
      return null;
    }

    var cls = (_cls = {}, _defineProperty(_cls, "".concat(prefixCls, "-select"), 1), _defineProperty(_cls, "".concat(prefixCls, "-select-active"), active), _cls);
    return h("div", {
      "class": cls,
      on: {
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave
      }
    }, [h("ul", {
      ref: "list"
    }, [this.getOptions()])]);
  }
};
/* harmony default export */ var vc_time_picker_Select = (Select);
// CONCATENATED MODULE: ./src/base/vc-time-picker/Combobox.jsx




var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox = {
  mixins: [BaseMixin["a" /* default */]],
  name: 'Combobox',
  props: {
    format: vue_types["a" /* default */].string,
    defaultOpenValue: vue_types["a" /* default */].object,
    prefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].object,
    // onChange: PropTypes.func,
    // onAmPmChange: PropTypes.func,
    showHour: vue_types["a" /* default */].bool,
    showMinute: vue_types["a" /* default */].bool,
    showSecond: vue_types["a" /* default */].bool,
    hourOptions: vue_types["a" /* default */].array,
    minuteOptions: vue_types["a" /* default */].array,
    secondOptions: vue_types["a" /* default */].array,
    disabledHours: vue_types["a" /* default */].func,
    disabledMinutes: vue_types["a" /* default */].func,
    disabledSeconds: vue_types["a" /* default */].func,
    // onCurrentSelectPanelChange: PropTypes.func,
    use12Hours: vue_types["a" /* default */].bool,
    isAM: vue_types["a" /* default */].bool
  },
  methods: {
    onItemChange: function onItemChange(type, itemValue) {
      var defaultOpenValue = this.defaultOpenValue,
          use12Hours = this.use12Hours,
          propValue = this.value,
          isAM = this.isAM;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        this.__emit('amPmChange', ampm);
      } else {
        value.second(+itemValue);
      }

      this.__emit('change', value);
    },
    onEnterSelectPanel: function onEnterSelectPanel(range) {
      this.__emit('currentSelectPanelChange', range);
    },
    onEsc: function onEsc(e) {
      this.__emit('esc', e);
    },
    getHourSelect: function getHourSelect(hour) {
      var _this = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          hourOptions = this.hourOptions,
          disabledHours = this.disabledHours,
          showHour = this.showHour,
          use12Hours = this.use12Hours;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return h(vc_time_picker_Select, {
        attrs: {
          prefixCls: prefixCls,
          options: hourOptionsAdj.map(function (option) {
            return formatOption(option, disabledOptions);
          }),
          selectedIndex: hourOptionsAdj.indexOf(hourAdj),
          type: "hour"
        },
        on: {
          "select": this.onItemChange,
          "mouseenter": function mouseenter() {
            return _this.onEnterSelectPanel('hour');
          },
          "esc": this.onEsc
        }
      });
    },
    getMinuteSelect: function getMinuteSelect(minute) {
      var _this2 = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          minuteOptions = this.minuteOptions,
          disabledMinutes = this.disabledMinutes,
          defaultOpenValue = this.defaultOpenValue,
          showMinute = this.showMinute,
          propValue = this.value;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return h(vc_time_picker_Select, {
        attrs: {
          prefixCls: prefixCls,
          options: minuteOptions.map(function (option) {
            return formatOption(option, disabledOptions);
          }),
          selectedIndex: minuteOptions.indexOf(minute),
          type: "minute"
        },
        on: {
          "select": this.onItemChange,
          "mouseenter": function mouseenter() {
            return _this2.onEnterSelectPanel('minute');
          },
          "esc": this.onEsc
        }
      });
    },
    getSecondSelect: function getSecondSelect(second) {
      var _this3 = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          secondOptions = this.secondOptions,
          disabledSeconds = this.disabledSeconds,
          showSecond = this.showSecond,
          defaultOpenValue = this.defaultOpenValue,
          propValue = this.value;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return h(vc_time_picker_Select, {
        attrs: {
          prefixCls: prefixCls,
          options: secondOptions.map(function (option) {
            return formatOption(option, disabledOptions);
          }),
          selectedIndex: secondOptions.indexOf(second),
          type: "second"
        },
        on: {
          "select": this.onItemChange,
          "mouseenter": function mouseenter() {
            return _this3.onEnterSelectPanel('second');
          },
          "esc": this.onEsc
        }
      });
    },
    getAMPMSelect: function getAMPMSelect() {
      var _this4 = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          use12Hours = this.use12Hours,
          format = this.format,
          isAM = this.isAM;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return h(vc_time_picker_Select, {
        attrs: {
          prefixCls: prefixCls,
          options: AMPMOptions,
          selectedIndex: selected,
          type: "ampm"
        },
        on: {
          "select": this.onItemChange,
          "mouseenter": function mouseenter() {
            return _this4.onEnterSelectPanel('ampm');
          },
          "esc": this.onEsc
        }
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        defaultOpenValue = this.defaultOpenValue,
        propValue = this.value;
    var value = propValue || defaultOpenValue;
    return h("div", {
      "class": "".concat(prefixCls, "-combobox")
    }, [this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour())]);
  }
};
/* harmony default export */ var vc_time_picker_Combobox = (Combobox);
// CONCATENATED MODULE: ./src/base/vc-time-picker/Panel.jsx







function Panel_noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return external_moment_default()("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    clearText: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string.def('rc-time-picker-panel'),
    defaultOpenValue: {
      type: Object,
      default: function _default() {
        return external_moment_default()();
      }
    },
    value: vue_types["a" /* default */].any,
    defaultValue: vue_types["a" /* default */].any,
    placeholder: vue_types["a" /* default */].string,
    format: vue_types["a" /* default */].string,
    inputReadOnly: vue_types["a" /* default */].bool.def(false),
    disabledHours: vue_types["a" /* default */].func.def(Panel_noop),
    disabledMinutes: vue_types["a" /* default */].func.def(Panel_noop),
    disabledSeconds: vue_types["a" /* default */].func.def(Panel_noop),
    hideDisabledOptions: vue_types["a" /* default */].bool,
    // onChange: PropTypes.func,
    // onEsc: PropTypes.func,
    allowEmpty: vue_types["a" /* default */].bool,
    showHour: vue_types["a" /* default */].bool,
    showMinute: vue_types["a" /* default */].bool,
    showSecond: vue_types["a" /* default */].bool,
    // onClear: PropTypes.func,
    use12Hours: vue_types["a" /* default */].bool.def(false),
    hourStep: vue_types["a" /* default */].number,
    minuteStep: vue_types["a" /* default */].number,
    secondStep: vue_types["a" /* default */].number,
    addon: vue_types["a" /* default */].func.def(Panel_noop),
    focusOnOpen: vue_types["a" /* default */].bool,
    // onKeydown: PropTypes.func,
    clearIcon: vue_types["a" /* default */].any
  },
  data: function data() {
    return {
      sValue: this.value,
      selectionRange: [],
      currentSelectPanel: ''
    };
  },
  watch: {
    value: function value(val) {
      this.setState({
        sValue: val
      });
    }
  },
  methods: {
    onChange: function onChange(newValue) {
      this.setState({
        sValue: newValue
      });

      this.__emit('change', newValue);
    },
    onAmPmChange: function onAmPmChange(ampm) {
      this.__emit('amPmChange', ampm);
    },
    onCurrentSelectPanelChange: function onCurrentSelectPanelChange(currentSelectPanel) {
      this.setState({
        currentSelectPanel: currentSelectPanel
      });
    },
    // https://github.com/ant-design/ant-design/issues/5829
    close: function close() {
      this.__emit('esc');
    },
    onEsc: function onEsc(e) {
      this.__emit('esc', e);
    },
    disabledHours2: function disabledHours2() {
      var use12Hours = this.use12Hours,
          disabledHours = this.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    },
    isAM: function isAM() {
      var value = this.sValue || this.defaultOpenValue;
      return value.hour() >= 0 && value.hour() < 12;
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        placeholder = this.placeholder,
        disabledMinutes = this.disabledMinutes,
        addon = this.addon,
        disabledSeconds = this.disabledSeconds,
        hideDisabledOptions = this.hideDisabledOptions,
        showHour = this.showHour,
        showMinute = this.showMinute,
        showSecond = this.showSecond,
        format = this.format,
        defaultOpenValue = this.defaultOpenValue,
        clearText = this.clearText,
        use12Hours = this.use12Hours,
        focusOnOpen = this.focusOnOpen,
        hourStep = this.hourStep,
        minuteStep = this.minuteStep,
        secondStep = this.secondStep,
        inputReadOnly = this.inputReadOnly,
        sValue = this.sValue,
        currentSelectPanel = this.currentSelectPanel;
    var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');

    var _getListeners = Object(props_util["getListeners"])(this),
        _getListeners$esc = _getListeners.esc,
        esc = _getListeners$esc === void 0 ? Panel_noop : _getListeners$esc,
        _getListeners$keydown = _getListeners.keydown,
        keydown = _getListeners$keydown === void 0 ? Panel_noop : _getListeners$keydown;

    var disabledHourOptions = this.disabledHours2();
    var disabledMinuteOptions = disabledMinutes(sValue ? sValue.hour() : null);
    var disabledSecondOptions = disabledSeconds(sValue ? sValue.hour() : null, sValue ? sValue.minute() : null);
    var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
    var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
    var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
    var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
    return h("div", {
      "class": "".concat(prefixCls, "-inner")
    }, [h(vc_time_picker_Combobox, {
      attrs: {
        prefixCls: prefixCls,
        value: sValue,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours2,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        use12Hours: use12Hours,
        isAM: this.isAM()
      },
      on: {
        "change": this.onChange,
        "amPmChange": this.onAmPmChange,
        "currentSelectPanelChange": this.onCurrentSelectPanelChange,
        "esc": this.onEsc
      }
    }), addon(this)]);
  }
};
/* harmony default export */ var vc_time_picker_Panel = (Panel);
// CONCATENATED MODULE: ./src/base/vc-time-picker/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, -40];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
/* harmony default export */ var vc_time_picker_placements = (placements);
// CONCATENATED MODULE: ./src/base/vc-time-picker/TimePicker.jsx
function TimePicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











function TimePicker_noop() {}

/* harmony default export */ var TimePicker = ({
  name: 'VcTimePicker',
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])({
    prefixCls: vue_types["a" /* default */].string,
    clearText: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].any,
    defaultOpenValue: {
      type: Object,
      default: function _default() {
        return external_moment_default()();
      }
    },
    inputReadOnly: vue_types["a" /* default */].bool,
    disabled: vue_types["a" /* default */].bool,
    allowEmpty: vue_types["a" /* default */].bool,
    defaultValue: vue_types["a" /* default */].any,
    open: vue_types["a" /* default */].bool,
    defaultOpen: vue_types["a" /* default */].bool,
    align: vue_types["a" /* default */].object,
    placement: vue_types["a" /* default */].any,
    transitionName: vue_types["a" /* default */].string,
    getPopupContainer: vue_types["a" /* default */].func,
    placeholder: vue_types["a" /* default */].string,
    format: vue_types["a" /* default */].string,
    showHour: vue_types["a" /* default */].bool,
    showMinute: vue_types["a" /* default */].bool,
    showSecond: vue_types["a" /* default */].bool,
    popupClassName: vue_types["a" /* default */].string,
    popupStyle: vue_types["a" /* default */].object,
    disabledHours: vue_types["a" /* default */].func,
    disabledMinutes: vue_types["a" /* default */].func,
    disabledSeconds: vue_types["a" /* default */].func,
    hideDisabledOptions: vue_types["a" /* default */].bool,
    // onChange: PropTypes.func,
    // onAmPmChange: PropTypes.func,
    // onOpen: PropTypes.func,
    // onClose: PropTypes.func,
    // onFocus: PropTypes.func,
    // onBlur: PropTypes.func,
    name: vue_types["a" /* default */].string,
    autoComplete: vue_types["a" /* default */].string,
    use12Hours: vue_types["a" /* default */].bool,
    hourStep: vue_types["a" /* default */].number,
    minuteStep: vue_types["a" /* default */].number,
    secondStep: vue_types["a" /* default */].number,
    focusOnOpen: vue_types["a" /* default */].bool,
    // onKeyDown: PropTypes.func,
    autoFocus: vue_types["a" /* default */].bool,
    id: vue_types["a" /* default */].string,
    inputIcon: vue_types["a" /* default */].any,
    clearIcon: vue_types["a" /* default */].any,
    addon: vue_types["a" /* default */].func
  }, {
    clearText: 'clear',
    prefixCls: 'rc-time-picker',
    defaultOpen: false,
    inputReadOnly: true,
    popupClassName: '',
    popupStyle: {},
    align: {},
    allowEmpty: true,
    showHour: true,
    showMinute: true,
    showSecond: true,
    disabledHours: TimePicker_noop,
    disabledMinutes: TimePicker_noop,
    disabledSeconds: TimePicker_noop,
    hideDisabledOptions: false,
    placement: 'bottomLeft',
    use12Hours: false,
    focusOnOpen: false
  }),
  data: function data() {
    var defaultOpen = this.defaultOpen,
        defaultValue = this.defaultValue,
        _this$open = this.open,
        open = _this$open === void 0 ? defaultOpen : _this$open,
        _this$value = this.value,
        value = _this$value === void 0 ? defaultValue : _this$value;
    return {
      sOpen: open,
      sValue: value
    };
  },
  watch: {
    value: function value(val) {
      this.setState({
        sValue: val
      });
    },
    open: function open(val) {
      if (val !== undefined) {
        this.setState({
          sOpen: val
        });
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.autoFocus) {
        _this.focus();
      }
    });
  },
  methods: {
    onPanelChange: function onPanelChange(value) {
      this.setValue(value);
    },
    onAmPmChange: function onAmPmChange(ampm) {
      this.__emit('amPmChange', ampm);
    },
    onClear: function onClear(event) {
      event.stopPropagation();
      this.setValue(null);
      this.setOpen(false);
    },
    onVisibleChange: function onVisibleChange(open) {
      this.setOpen(open);
    },
    onEsc: function onEsc() {
      this.setOpen(false);
      this.focus();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 40) {
        this.setOpen(true);
      }
    },
    onKeyDown2: function onKeyDown2(e) {
      this.__emit('keydown', e);
    },
    setValue: function setValue(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }

      this.__emit('change', value);
    },
    getFormat: function getFormat() {
      var format = this.format,
          showHour = this.showHour,
          showMinute = this.showMinute,
          showSecond = this.showSecond,
          use12Hours = this.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    },
    getPanelElement: function getPanelElement() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          placeholder = this.placeholder,
          disabledHours = this.disabledHours,
          addon = this.addon,
          disabledMinutes = this.disabledMinutes,
          disabledSeconds = this.disabledSeconds,
          hideDisabledOptions = this.hideDisabledOptions,
          inputReadOnly = this.inputReadOnly,
          showHour = this.showHour,
          showMinute = this.showMinute,
          showSecond = this.showSecond,
          defaultOpenValue = this.defaultOpenValue,
          clearText = this.clearText,
          use12Hours = this.use12Hours,
          focusOnOpen = this.focusOnOpen,
          onKeyDown2 = this.onKeyDown2,
          hourStep = this.hourStep,
          minuteStep = this.minuteStep,
          secondStep = this.secondStep,
          sValue = this.sValue;
      var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
      return h(vc_time_picker_Panel, {
        attrs: {
          clearText: clearText,
          prefixCls: "".concat(prefixCls, "-panel"),
          value: sValue,
          inputReadOnly: inputReadOnly,
          defaultOpenValue: defaultOpenValue,
          showHour: showHour,
          showMinute: showMinute,
          showSecond: showSecond,
          format: this.getFormat(),
          placeholder: placeholder,
          disabledHours: disabledHours,
          disabledMinutes: disabledMinutes,
          disabledSeconds: disabledSeconds,
          hideDisabledOptions: hideDisabledOptions,
          use12Hours: use12Hours,
          hourStep: hourStep,
          minuteStep: minuteStep,
          secondStep: secondStep,
          focusOnOpen: focusOnOpen,
          clearIcon: clearIcon,
          addon: addon
        },
        ref: "panel",
        on: {
          "change": this.onPanelChange,
          "amPmChange": this.onAmPmChange,
          "esc": this.onEsc,
          "keydown": onKeyDown2
        }
      });
    },
    getPopupClassName: function getPopupClassName() {
      var showHour = this.showHour,
          showMinute = this.showMinute,
          showSecond = this.showSecond,
          use12Hours = this.use12Hours,
          prefixCls = this.prefixCls,
          popupClassName = this.popupClassName;
      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      } // Keep it for old compatibility


      return external_classnames_default()(popupClassName, TimePicker_defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
    },
    setOpen: function setOpen(open) {
      if (this.sOpen !== open) {
        if (!Object(props_util["hasProp"])(this, 'open')) {
          this.setState({
            sOpen: open
          });
        }

        if (open) {
          this.__emit('open', {
            open: open
          });
        } else {
          this.__emit('close', {
            open: open
          });
        }
      }
    },
    focus: function focus() {
      this.$refs.picker.focus();
    },
    blur: function blur() {
      this.$refs.picker.blur();
    },
    onFocus: function onFocus(e) {
      this.__emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.__emit('blur', e);
    },
    renderClearButton: function renderClearButton() {
      var _this2 = this;

      var h = this.$createElement;
      var sValue = this.sValue;
      var _this$$props = this.$props,
          prefixCls = _this$$props.prefixCls,
          allowEmpty = _this$$props.allowEmpty,
          clearText = _this$$props.clearText,
          disabled = _this$$props.disabled;

      if (!allowEmpty || !sValue || disabled) {
        return null;
      }

      var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');

      if (Object(props_util["isValidElement"])(clearIcon)) {
        var _ref = Object(props_util["getEvents"])(clearIcon) || {},
            _click = _ref.click;

        return Object(vnode["a" /* cloneElement */])(clearIcon, {
          on: {
            click: function click() {
              if (_click) _click.apply(void 0, arguments);

              _this2.onClear.apply(_this2, arguments);
            }
          }
        });
      }

      return h("a", {
        attrs: {
          role: "button",
          title: clearText,
          tabIndex: 0
        },
        "class": "".concat(prefixCls, "-clear"),
        on: {
          "click": this.onClear
        }
      }, [clearIcon || h("i", {
        "class": "".concat(prefixCls, "-clear-icon")
      })]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        placeholder = this.placeholder,
        placement = this.placement,
        align = this.align,
        id = this.id,
        disabled = this.disabled,
        transitionName = this.transitionName,
        getPopupContainer = this.getPopupContainer,
        name = this.name,
        autoComplete = this.autoComplete,
        autoFocus = this.autoFocus,
        inputReadOnly = this.inputReadOnly,
        sOpen = this.sOpen,
        sValue = this.sValue,
        onFocus = this.onFocus,
        onBlur = this.onBlur,
        popupStyle = this.popupStyle;
    var popupClassName = this.getPopupClassName();
    var inputIcon = Object(props_util["getComponentFromProp"])(this, 'inputIcon');
    return h(vc_trigger["a" /* default */], {
      attrs: {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popupAlign: align,
        builtinPlacements: vc_time_picker_placements,
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: sOpen
      },
      on: {
        "popupVisibleChange": this.onVisibleChange
      }
    }, [h("template", {
      slot: "popup"
    }, [this.getPanelElement()]), h("span", {
      "class": "".concat(prefixCls, " ").concat(sValue ? 'has-value' : '', " ").concat(disabled ? 'disabled-wrapper' : '', " ").concat(sOpen ? 'opened' : '', " ").concat(this.allowEmpty ? 'can-delete' : '')
    }, [h("meg-input", {
      "class": "".concat(prefixCls, "-input"),
      ref: "picker",
      attrs: {
        type: "text",
        placeholder: placeholder,
        name: name,
        disabled: disabled,
        value: sValue && sValue.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        readOnly: !!inputReadOnly,
        id: id
      },
      on: {
        "keydown": this.onKeyDown,
        "focus": onFocus,
        "blur": onBlur
      }
    }), inputIcon || h("span", {
      "class": "".concat(prefixCls, "-icon")
    }), this.renderClearButton()])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-time-picker/index.js
// based on rc-time-picker 3.7.3

// EXTERNAL MODULE: ./src/base/locale-provider/LocaleReceiver.jsx
var LocaleReceiver = __webpack_require__(15);

// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var warning = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/timePicker/time-picker/locale/zh_CN.js
var zh_CN_locale = {
  placeholder: '请选择时间'
};
/* harmony default export */ var zh_CN = (zh_CN_locale);
// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/timePicker/time-picker/common.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { common_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function common_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

 // import {
//     TimeOrTimesType,
// } from 'utils/moment-util';

var common_TimePickerProps = function TimePickerProps() {
  return {
    size: vue_types["a" /* default */].oneOf(['large', 'default', 'small']),
    value: vue_types["a" /* default */].number || vue_types["a" /* default */].string || undefined || null,
    defaultValue: vue_types["a" /* default */].number || undefined || null,
    open: vue_types["a" /* default */].bool,
    format: vue_types["a" /* default */].string,
    disabled: vue_types["a" /* default */].bool,
    placeholder: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string,
    hideDisabledOptions: vue_types["a" /* default */].bool,
    disabledHours: vue_types["a" /* default */].func,
    disabledMinutes: vue_types["a" /* default */].func,
    disabledSeconds: vue_types["a" /* default */].func,
    getPopupContainer: vue_types["a" /* default */].func,
    use12Hours: vue_types["a" /* default */].bool,
    focusOnOpen: vue_types["a" /* default */].bool,
    hourStep: vue_types["a" /* default */].number,
    minuteStep: vue_types["a" /* default */].number,
    secondStep: vue_types["a" /* default */].number,
    allowEmpty: vue_types["a" /* default */].bool,
    allowClear: vue_types["a" /* default */].bool,
    inputReadOnly: vue_types["a" /* default */].bool,
    clearText: vue_types["a" /* default */].string,
    defaultOpenValue: vue_types["a" /* default */].object,
    popupClassName: vue_types["a" /* default */].string,
    popupStyle: vue_types["a" /* default */].object,
    suffixIcon: vue_types["a" /* default */].any,
    align: vue_types["a" /* default */].object,
    placement: vue_types["a" /* default */].any,
    transitionName: vue_types["a" /* default */].string,
    autoFocus: vue_types["a" /* default */].bool,
    addon: vue_types["a" /* default */].any,
    clearIcon: vue_types["a" /* default */].any,
    locale: vue_types["a" /* default */].object,
    valueFormat: vue_types["a" /* default */].string
  };
};
var common_RangeTimePickerProps = function RangeTimePickerProps() {
  return _objectSpread(_objectSpread({}, common_TimePickerProps()), {}, {
    value: vue_types["a" /* default */].any,
    defaultValue: vue_types["a" /* default */].any,
    defaultPickerValue: vue_types["a" /* default */].any,
    placeholder: vue_types["a" /* default */].arrayOf(String)
  });
};
// CONCATENATED MODULE: ./src/components/timePicker/time-picker/range.jsx
function range_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 时间范围选择器
 */






var TimeRangePicker = {
  name: 'MegTimeRangePicker',
  model: {
    props: 'value',
    event: 'change'
  },
  props: Object(props_util["initDefaultProps"])(common_RangeTimePickerProps(), {
    align: {
      offset: [0, -2]
    },
    disabled: false,
    disabledHours: undefined,
    disabledMinutes: undefined,
    disabledSeconds: undefined,
    hideDisabledOptions: false,
    placement: 'bottomLeft',
    transitionName: 'slide-up',
    focusOnOpen: true,
    allowClear: true,
    value: [],
    format: "HH:mm:ss",
    placeholder: ['开始时间', '结束时间']
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    return {
      startStamp: this.value[0],
      endStamp: this.value[1],
      startTime: '',
      endTime: '',
      startOpen: false,
      endOpen: false
    };
  },
  computed: {
    checkOpen: function checkOpen() {
      return this.startOpen || this.endOpen;
    }
  },
  watch: {
    value: function value(val) {
      this.startStamp = val[0];
      this.endStamp = val[1];
    }
  },
  methods: {
    moment: external_moment_default.a,
    changeTime: function changeTime(val, dateStrings, type) {
      if (type === 'startTime') {
        this.startStamp = val;
        this.startTime = dateStrings;
      } else {
        this.endStamp = val;
        this.endTime = dateStrings;
      }

      this.$emit('change', [this.startStamp, this.endStamp]); // 将值返回给调用组件的地方
    },
    getDisabledHours: function getDisabledHours() {
      var hours = [];
      var time = this.startTime;
      var timeArr = time.split(':');
      var len = parseInt(timeArr[0], 10);

      for (var i = 0; i < len; i++) {
        hours.push(i);
      }

      return hours;
    },
    getDisabledMinutes: function getDisabledMinutes(selectedHour) {
      var minutes = [];
      var time = this.startTime;
      var timeArr = time.split(':');
      var len = parseInt(timeArr[1], 10);

      if (selectedHour === parseInt(timeArr[0], 10)) {
        for (var i = 0; i < len; i++) {
          minutes.push(i);
        }
      }

      return minutes;
    },
    getDisabledSeconds: function getDisabledSeconds(selectedHour, selectedMinute) {
      var seconds = [];
      var time = this.startTime;
      var timeArr = time.split(':');
      var len = parseInt(timeArr[2], 10);

      if (selectedHour === parseInt(timeArr[0], 10) && selectedMinute === parseInt(timeArr[1], 10)) {
        for (var i = 0; i <= len; i++) {
          seconds.push(i);
        }
      }

      return seconds;
    },
    renderIcon: function renderIcon(prefixCls) {
      var _this = this,
          _attrs;

      var h = this.$createElement;
      return h("div", {
        "class": "".concat(prefixCls, "-range-icon")
      }, [this.startStamp && this.endStamp && h("div", {
        "class": "".concat(prefixCls, "-range-icon-clear")
      }, [h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-fill-close-circle",
          width: "12px",
          height: "12px"
        },
        on: {
          "click": function click() {
            _this.changeTime('', '', 'startTime');

            _this.changeTime('', '', 'endTime');
          }
        }
      })]), h("div", {
        "class": "".concat(prefixCls, "-range-icon-default")
      }, [h("meg-icon", {
        attrs: (_attrs = {
          original: true,
          name: "time"
        }, range_defineProperty(_attrs, "original", true), range_defineProperty(_attrs, "width", "12px"), range_defineProperty(_attrs, "height", "12px"), _attrs)
      })])]);
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    props = Object(es["a" /* default */])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
    var _props = props,
        customizePrefixCls = _props.prefixCls,
        getPopupContainer = _props.getPopupContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
    return h("div", {
      "class": "".concat(prefixCls, "-range ").concat(this.startStamp && this.endStamp ? 'has-value' : '', " ").concat(props.disabled ? 'disabled-wrapper' : '', " ").concat(this.checkOpen ? 'opened' : '')
    }, [h(time_picker, {
      attrs: {
        placeholder: this.placeholder[0],
        value: this.startStamp ? this.startStamp : 0 // defaultValue={this.startStamp ? this.moment(this.startStamp, 'HH:mm:ss') : ''}
        ,
        format: this.format,
        disabled: props.disabled,
        allowClear: false,
        getPopupContainer: getPopupContainer,
        align: props.align,
        placement: props.placement
      },
      on: {
        "change": function change(val, dateStrings) {
          return _this2.changeTime(val, dateStrings, 'startTime');
        },
        "openChange": function openChange(open) {
          return _this2.startOpen = open;
        }
      },
      "class": "meg-time-picker-left"
    }), h("span", {
      "class": "".concat(prefixCls, "-range-picker-separator")
    }, ["\u2192"]), h(time_picker, {
      attrs: {
        placeholder: this.placeholder[1],
        value: this.endStamp ? this.endStamp : 0,
        disabledHours: this.getDisabledHours,
        disabledMinutes: this.getDisabledMinutes,
        disabledSeconds: this.getDisabledSeconds // defaultValue={this.endStamp ? this.moment(this.endStamp, 'HH:mm:ss') : ''}
        ,
        format: this.format,
        disabled: props.disabled,
        allowClear: false,
        getPopupContainer: getPopupContainer,
        align: props.align,
        placement: props.placement
      },
      on: {
        "change": function change(val, dateStrings) {
          return _this2.changeTime(val, dateStrings, 'endTime');
        },
        "openChange": function openChange(open) {
          return _this2.endOpen = open;
        }
      },
      "class": "meg-time-picker-right"
    }), this.renderIcon(prefixCls)]);
  }
};
/* harmony default export */ var range = (TimeRangePicker);
// EXTERNAL MODULE: ./src/utils/interopDefault.js
var interopDefault = __webpack_require__(21);

// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(50);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);

// CONCATENATED MODULE: ./src/utils/moment-util.js




var TimeType = {
  validator: function validator(value) {
    return typeof value === 'string' || typeof value === 'number' || isNil_default()(value) || external_moment_["isMoment"](value);
  }
};
var TimesType = {
  validator: function validator(value) {
    if (Array.isArray(value)) {
      return value.length === 0 || value.findIndex(function (val) {
        return typeof val !== 'string';
      }) === -1 || value.findIndex(function (val) {
        return typeof val !== 'number';
      }) === -1 || value.findIndex(function (val) {
        return !isNil_default()(val) && !external_moment_["isMoment"](val);
      }) === -1;
    }

    return false;
  }
};
var TimeOrTimesType = {
  validator: function validator(value) {
    if (Array.isArray(value)) {
      return value.length === 0 || value.findIndex(function (val) {
        return typeof val !== 'string';
      }) === -1 || value.findIndex(function (val) {
        return !isNil_default()(val) && !external_moment_["isMoment"](val);
      }) === -1;
    } else {
      return typeof value === 'string' || isNil_default()(value) || external_moment_["isMoment"](value);
    }
  }
};
function checkValidate(componentName, value, propName, valueFormat) {
  var values = Array.isArray(value) ? value : [value];
  values.forEach(function (val) {
    if (!val) return;
    valueFormat && Object(warning["a" /* default */])(Object(interopDefault["a" /* default */])(external_moment_)(val, valueFormat).isValid(), componentName, "When set `valueFormat`, `".concat(propName, "` should provides invalidate string time. "));
    !valueFormat && Object(warning["a" /* default */])(Object(interopDefault["a" /* default */])(external_moment_).isMoment(val) && val.isValid(), componentName, "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
  });
}
var moment_util_stringToMoment = function stringToMoment(value, valueFormat) {
  if (Array.isArray(value)) {
    return value.map(function (val) {
      return (typeof val === 'string' || typeof val === 'number') && val ? Object(interopDefault["a" /* default */])(external_moment_)(val, valueFormat) : val || null;
    });
  } else {
    return (typeof value === 'string' || typeof value === 'number') && value ? Object(interopDefault["a" /* default */])(external_moment_)(value, valueFormat) : value || null;
  }
};
var moment_util_momentToString = function momentToString(value, valueFormat) {
  if (Array.isArray(value)) {
    return value.map(function (val) {
      return Object(interopDefault["a" /* default */])(external_moment_).isMoment(val) ? val.format(valueFormat) : val;
    });
  } else {
    return Object(interopDefault["a" /* default */])(external_moment_).isMoment(value) ? value.format(valueFormat) : value;
  }
};
// CONCATENATED MODULE: ./src/components/timePicker/time-picker/index.jsx
function time_picker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function time_picker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { time_picker_ownKeys(Object(source), true).forEach(function (key) { time_picker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { time_picker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function time_picker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












 // import './style/index.scss';


function generateShowHourMinuteSecond(format) {
  // Ref: http://momentjs.com/docs/#/parsing/string-format/
  return {
    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
    showMinute: format.indexOf('m') > -1,
    showSecond: format.indexOf('s') > -1
  };
}
var time_picker_TimePicker = {
  name: 'MegTimePicker',
  mixins: [BaseMixin["a" /* default */]],
  props: Object(props_util["initDefaultProps"])(common_TimePickerProps(), {
    align: {
      offset: [0, -2]
    },
    disabled: false,
    disabledHours: undefined,
    disabledMinutes: undefined,
    disabledSeconds: undefined,
    hideDisabledOptions: false,
    placement: 'bottomLeft',
    transitionName: 'slide-up',
    focusOnOpen: true,
    allowClear: true
  }),
  model: {
    prop: 'value',
    event: 'change'
  },
  provide: function provide() {
    return {
      savePopupRef: this.savePopupRef
    };
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var value = this.value,
        defaultValue = this.defaultValue,
        valueFormat = this.valueFormat; // props传进来的

    var momentDefaultValue = defaultValue && external_moment_(defaultValue);
    var momentValue = value && external_moment_(value);
    checkValidate('TimePicker', momentDefaultValue, 'defaultValue', valueFormat);
    checkValidate('TimePicker', momentValue, 'value', valueFormat);
    Object(warning["a" /* default */])(!Object(props_util["hasProp"])(this, 'allowEmpty'), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
    return {
      sValue: moment_util_stringToMoment(momentValue || momentDefaultValue, valueFormat)
    };
  },
  watch: {
    value: function value(val) {
      var momentVal = val && external_moment_(val);
      checkValidate('TimePicker', momentVal, 'value', this.valueFormat);
      this.setState({
        sValue: moment_util_stringToMoment(momentVal, this.valueFormat)
      });
    }
  },
  methods: {
    getDefaultFormat: function getDefaultFormat() {
      // 输入框中展示的时间格式
      var format = this.format,
          use12Hours = this.use12Hours;

      if (format) {
        return format;
      } else if (use12Hours) {
        return 'h:mm:ss a';
      }

      return 'HH:mm:ss';
    },
    getAllowClear: function getAllowClear() {
      var _this$$props = this.$props,
          allowClear = _this$$props.allowClear,
          allowEmpty = _this$$props.allowEmpty;

      if (Object(props_util["hasProp"])(this, 'allowClear')) {
        return allowClear;
      }

      return allowEmpty;
    },
    getDefaultLocale: function getDefaultLocale() {
      var defaultLocale = time_picker_objectSpread(time_picker_objectSpread({}, zh_CN), this.$props.locale);

      return defaultLocale;
    },
    savePopupRef: function savePopupRef(ref) {
      this.popupRef = ref;
    },
    handleChange: function handleChange(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }

      var _this$format = this.format,
          format = _this$format === void 0 ? 'HH:mm:ss' : _this$format;
      this.$emit('change', value && Number(value.format('x')) || null, // 返回时间戳
      // this.valueFormat ? momentToString(value, this.valueFormat) : value, // ant-design原来自己的逻辑
      value && value.format(format) || null);
    },
    handleOpenClose: function handleOpenClose(_ref) {
      var open = _ref.open;
      this.$emit('openChange', open);
      this.$emit('update:open', open);
    },
    focus: function focus() {
      this.$refs.timePicker.focus();
    },
    blur: function blur() {
      this.$refs.timePicker.blur();
    },
    renderInputIcon: function renderInputIcon(prefixCls) {
      var h = this.$createElement;
      var suffixIcon = Object(props_util["getComponentFromProp"])(this, 'suffixIcon');
      suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;
      var clockIcon = suffixIcon && Object(props_util["isValidElement"])(suffixIcon) && Object(vnode["a" /* cloneElement */])(suffixIcon, {
        class: "".concat(prefixCls, "-clock-icon")
      }) || h("span", {
        attrs: {
          type: "clock-circle"
        },
        "class": "".concat(prefixCls, "-clock-icon")
      }, [h("meg-icon", {
        attrs: {
          original: true,
          name: "time",
          width: "12px",
          height: "12px"
        }
      })]);
      return h("span", {
        "class": "".concat(prefixCls, "-icon")
      }, [clockIcon]);
    },
    renderClearIcon: function renderClearIcon(prefixCls) {
      var h = this.$createElement;
      var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
      var clearIconPrefixCls = "".concat(prefixCls, "-clear");

      if (clearIcon && Object(props_util["isValidElement"])(clearIcon)) {
        return Object(vnode["a" /* cloneElement */])(clearIcon, {
          class: clearIconPrefixCls
        });
      }

      return h("span", {
        "class": clearIconPrefixCls
      }, [h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-fill-close-circle",
          width: "12px",
          height: "12px"
        },
        "class": "".concat(prefixCls, "-clear-icon")
      })]);
    },
    renderTimePicker: function renderTimePicker(locale) {
      var h = this.$createElement;
      var props = Object(props_util["getOptionProps"])(this);
      props = Object(es["a" /* default */])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
      var _props = props,
          customizePrefixCls = _props.prefixCls,
          getPopupContainer = _props.getPopupContainer,
          placeholder = _props.placeholder,
          size = _props.size;
      var getPrefixCls = this.configProvider.getPrefixCls;
      var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
      var format = this.getDefaultFormat();

      var pickerClassName = time_picker_defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size);

      var tempAddon = Object(props_util["getComponentFromProp"])(this, 'addon', {}, false);

      var pickerAddon = function pickerAddon(panel) {
        return tempAddon ? h("div", {
          "class": "".concat(prefixCls, "-panel-addon")
        }, [typeof tempAddon === 'function' ? tempAddon(panel) : tempAddon]) : null;
      };

      var inputIcon = this.renderInputIcon(prefixCls);
      var clearIcon = this.renderClearIcon(prefixCls);
      var getContextPopupContainer = this.configProvider.getPopupContainer;
      var timeProps = {
        props: time_picker_objectSpread(time_picker_objectSpread(time_picker_objectSpread({}, generateShowHourMinuteSecond(format)), props), {}, {
          allowEmpty: this.getAllowClear(),
          prefixCls: prefixCls,
          getPopupContainer: getPopupContainer || getContextPopupContainer,
          format: format,
          value: this.sValue,
          placeholder: placeholder === undefined ? locale.placeholder : placeholder,
          addon: pickerAddon,
          inputIcon: inputIcon,
          clearIcon: clearIcon
        }),
        class: pickerClassName,
        ref: 'timePicker',
        on: time_picker_objectSpread(time_picker_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
          change: this.handleChange,
          open: this.handleOpenClose,
          close: this.handleOpenClose
        })
      };
      return h(TimePicker, timeProps);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(LocaleReceiver["a" /* default */], {
      attrs: {
        componentName: "TimePicker",
        defaultLocale: this.getDefaultLocale()
      },
      scopedSlots: {
        default: this.renderTimePicker
      }
    });
  }
};
/* istanbul ignore next */

time_picker_TimePicker.install = function (Vue) {
  Vue.component(time_picker_TimePicker.name, time_picker_TimePicker);
  Vue.component(range.name, range);
};

/* harmony default export */ var time_picker = (time_picker_TimePicker);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(10);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./node_modules/vue-ref/index.js
var vue_ref = __webpack_require__(24);
var vue_ref_default = /*#__PURE__*/__webpack_require__.n(vue_ref);

// EXTERNAL MODULE: ./src/utils/key_code.js
var key_code = __webpack_require__(9);

// CONCATENATED MODULE: ./src/base/vc-calendar/src/date/DateConstants.js
/* harmony default export */ var DateConstants = ({
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/date/DateTHead.jsx


/* harmony default export */ var DateTHead = ({
  functional: true,
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props;
    var value = props.value;
    var localeData = value.localeData();
    var prefixCls = props.prefixCls;
    var veryShortWeekdays = [];
    var weekDays = [];
    var firstDayOfWeek = localeData.firstDayOfWeek();
    var showWeekNumberEl;
    var now = external_moment_default()();

    for (var dateColIndex = 0; dateColIndex < DateConstants.DATE_COL_COUNT; dateColIndex++) {
      var index = (firstDayOfWeek + dateColIndex) % DateConstants.DATE_COL_COUNT;
      now.day(index);
      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
      weekDays[dateColIndex] = localeData.weekdaysShort(now);
    }

    if (props.showWeekNumber) {
      showWeekNumberEl = h("th", {
        attrs: {
          role: "columnheader"
        },
        "class": "".concat(prefixCls, "-column-header ").concat(prefixCls, "-week-number-header")
      }, [h("span", {
        "class": "".concat(prefixCls, "-column-header-inner")
      }, ["x"])]);
    }

    var weekDaysEls = weekDays.map(function (day, xindex) {
      return h("th", {
        key: xindex,
        attrs: {
          role: "columnheader",
          title: day
        },
        "class": "".concat(prefixCls, "-column-header")
      }, [h("span", {
        "class": "".concat(prefixCls, "-column-header-inner")
      }, [veryShortWeekdays[xindex]])]);
    });
    return h("thead", [h("tr", {
      attrs: {
        role: "row"
      }
    }, [showWeekNumberEl, weekDaysEls])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/util/index.js
function util_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function util_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { util_ownKeys(Object(source), true).forEach(function (key) { util_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { util_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function util_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var defaultDisabledTime = {
  disabledHours: function disabledHours() {
    return [];
  },
  disabledMinutes: function disabledMinutes() {
    return [];
  },
  disabledSeconds: function disabledSeconds() {
    return [];
  }
};
function getTodayTime(value) {
  var today = external_moment_default()();
  today.locale(value.locale()).utcOffset(value.utcOffset());
  return today;
}
function getTitleString(value) {
  return value.format('LL');
}
function getTodayTimeStr(value) {
  var today = getTodayTime(value);
  return getTitleString(today);
}
function getMonthName(month) {
  var map = {
    'Jan': '1月',
    'Feb': '2月',
    'Mar': '3月',
    'Apr': '4月',
    'May': '5月',
    'Jun': '6月',
    'Jul': '7月',
    'Aug': '8月',
    'Sep': '9月',
    'Oct': '10月',
    'Nov': '11月',
    'Dec': '12月'
  };
  var locale = month.locale();
  var localeData = month.localeData();
  return map[localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month)];
}
function syncTime(from, to) {
  if (!external_moment_default.a.isMoment(from) || !external_moment_default.a.isMoment(to)) return;
  to.hour(from.hour());
  to.minute(from.minute());
  to.second(from.second());
  to.millisecond(from.millisecond());
}
function getTimeConfig(value, disabledTime) {
  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
  disabledTimeConfig = util_objectSpread(util_objectSpread({}, defaultDisabledTime), disabledTimeConfig);
  return disabledTimeConfig;
}
function isTimeValidByConfig(value, disabledTimeConfig) {
  var invalidTime = false;

  if (value) {
    var hour = value.hour();
    var minutes = value.minute();
    var seconds = value.second();
    var disabledHours = disabledTimeConfig.disabledHours();

    if (disabledHours.indexOf(hour) === -1) {
      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);

      if (disabledMinutes.indexOf(minutes) === -1) {
        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
      } else {
        invalidTime = true;
      }
    } else {
      invalidTime = true;
    }
  }

  return !invalidTime;
}
function isTimeValid(value, disabledTime) {
  var disabledTimeConfig = getTimeConfig(value, disabledTime);
  return isTimeValidByConfig(value, disabledTimeConfig);
}
function util_isAllowedDate(value, disabledDate, disabledTime) {
  if (disabledDate) {
    if (disabledDate(value)) {
      return false;
    }
  }

  if (disabledTime) {
    if (!isTimeValid(value, disabledTime)) {
      return false;
    }
  }

  return true;
}
function formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  if (typeof format === 'function') {
    var result = format(value);

    if (typeof result === 'string') {
      return result;
    } else {
      throw new Error('The function of format does not return a string');
    }
  }

  return value.format(format);
}
// CONCATENATED MODULE: ./src/base/vc-calendar/src/date/DateTBody.jsx
function DateTBody_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function DateTBody_noop() {}

function isSameDay(one, two) {
  return one && two && one.isSame(two, 'day');
}

function beforeCurrentMonthYear(current, today) {
  if (current.year() < today.year()) {
    return 1;
  }

  return current.year() === today.year() && current.month() < today.month();
}

function afterCurrentMonthYear(current, today) {
  if (current.year() > today.year()) {
    return 1;
  }

  return current.year() === today.year() && current.month() > today.month();
}

function getIdFromDate(date) {
  return "rc-calendar-".concat(date.year(), "-").concat(date.month(), "-").concat(date.date());
}

var DateTBody = {
  props: {
    contentRender: vue_types["a" /* default */].func,
    dateRender: vue_types["a" /* default */].func,
    disabledDate: vue_types["a" /* default */].func,
    prefixCls: vue_types["a" /* default */].string,
    selectedValue: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].any, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].any)]),
    value: vue_types["a" /* default */].object,
    hoverValue: vue_types["a" /* default */].any.def([]),
    showWeekNumber: vue_types["a" /* default */].bool
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var contentRender = props.contentRender,
        prefixCls = props.prefixCls,
        selectedValue = props.selectedValue,
        value = props.value,
        showWeekNumber = props.showWeekNumber,
        dateRender = props.dateRender,
        disabledDate = props.disabledDate,
        hoverValue = props.hoverValue;

    var _getListeners = Object(props_util["getListeners"])(this),
        _getListeners$select = _getListeners.select,
        select = _getListeners$select === void 0 ? DateTBody_noop : _getListeners$select,
        _getListeners$dayHove = _getListeners.dayHover,
        dayHover = _getListeners$dayHove === void 0 ? DateTBody_noop : _getListeners$dayHove;

    var iIndex;
    var jIndex;
    var current;
    var dateTable = [];
    var today = getTodayTime(value);
    var cellClass = "".concat(prefixCls, "-cell");
    var weekNumberCellClass = "".concat(prefixCls, "-week-number-cell");
    var dateClass = "".concat(prefixCls, "-date");
    var todayClass = "".concat(prefixCls, "-today");
    var selectedClass = "".concat(prefixCls, "-selected-day");
    var selectedDateClass = "".concat(prefixCls, "-selected-date"); // do not move with mouse operation

    var selectedStartDateClass = "".concat(prefixCls, "-selected-start-date");
    var selectedEndDateClass = "".concat(prefixCls, "-selected-end-date");
    var inRangeClass = "".concat(prefixCls, "-in-range-cell");
    var lastMonthDayClass = "".concat(prefixCls, "-last-month-cell");
    var nextMonthDayClass = "".concat(prefixCls, "-next-month-btn-day");
    var disabledClass = "".concat(prefixCls, "-disabled-cell");
    var firstDisableClass = "".concat(prefixCls, "-disabled-cell-first-of-row");
    var lastDisableClass = "".concat(prefixCls, "-disabled-cell-last-of-row");
    var lastDayOfMonthClass = "".concat(prefixCls, "-last-day-of-month");
    var month1 = value.clone(); // month1.date(1); // 原来的代码是选择的日期加此刻时间

    month1.date(1).startOf('day').valueOf(); // 改为选择的日期加零点

    var day = month1.day();
    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7; // calculate last month

    var lastMonth1 = month1.clone();
    lastMonth1.add(0 - lastMonthDiffDay, 'days');
    var passed = 0;

    for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
      for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        current = lastMonth1;

        if (passed) {
          current = current.clone();
          current.add(passed, 'days');
        }

        dateTable.push(current);
        passed++;
      }
    }

    var tableHtml = [];
    passed = 0;

    for (iIndex = 0; iIndex < DateConstants.DATE_ROW_COUNT; iIndex++) {
      var _cx;

      var isCurrentWeek = void 0;
      var weekNumberCell = void 0;
      var isActiveWeek = false;
      var dateCells = [];

      if (showWeekNumber) {
        weekNumberCell = h("td", {
          key: "week-".concat(dateTable[passed].week()),
          attrs: {
            role: "gridcell"
          },
          "class": weekNumberCellClass
        });
      }

      for (jIndex = 0; jIndex < DateConstants.DATE_COL_COUNT; jIndex++) {
        var next = null;
        var last = null;
        current = dateTable[passed];

        if (jIndex < DateConstants.DATE_COL_COUNT - 1) {
          next = dateTable[passed + 1];
        }

        if (jIndex > 0) {
          last = dateTable[passed - 1];
        }

        var cls = cellClass;
        var disabled = false;
        var selected = false;

        if (isSameDay(current, today)) {
          cls += " ".concat(todayClass);
          isCurrentWeek = true;
        }

        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);

        if (selectedValue && Array.isArray(selectedValue)) {
          var rangeValue = hoverValue.length ? hoverValue : selectedValue;

          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
            var startValue = rangeValue[0];
            var endValue = rangeValue[1];

            if (startValue) {
              if (isSameDay(current, startValue)) {
                selected = true;
                isActiveWeek = true;
                cls += " ".concat(selectedStartDateClass);
              }
            }

            if (startValue || endValue) {
              if (isSameDay(current, endValue)) {
                selected = true;
                isActiveWeek = true;
                cls += " ".concat(selectedEndDateClass);
              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
                cls += " ".concat(inRangeClass);
              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
                cls += " ".concat(inRangeClass);
              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
                cls += " ".concat(inRangeClass);
              }
            }
          }
        } else if (isSameDay(current, value)) {
          // keyboard change value, highlight works
          selected = true;
          isActiveWeek = true;
        }

        if (isSameDay(current, selectedValue)) {
          cls += " ".concat(selectedDateClass);
        }

        if (isBeforeCurrentMonthYear) {
          cls += " ".concat(lastMonthDayClass);
        }

        if (isAfterCurrentMonthYear) {
          cls += " ".concat(nextMonthDayClass);
        }

        if (current.clone().endOf('month').date() === current.date()) {
          cls += " ".concat(lastDayOfMonthClass);
        }

        if (disabledDate) {
          if (disabledDate(current, value)) {
            disabled = true;

            if (!last || !disabledDate(last, value)) {
              cls += " ".concat(firstDisableClass);
            }

            if (!next || !disabledDate(next, value)) {
              cls += " ".concat(lastDisableClass);
            }
          }
        }

        if (selected) {
          cls += " ".concat(selectedClass);
        }

        if (disabled) {
          cls += " ".concat(disabledClass);
        }

        var dateHtml = void 0;

        if (dateRender) {
          dateHtml = dateRender(current, value);
        } else {
          var content = contentRender ? contentRender(current, value) : current.date();
          dateHtml = h("div", {
            key: getIdFromDate(current),
            "class": dateClass,
            attrs: {
              "aria-selected": selected,
              "aria-disabled": disabled
            }
          }, [content]);
        }

        dateCells.push(h("td", {
          key: passed,
          on: {
            "click": disabled ? DateTBody_noop : select.bind(null, current),
            "mouseenter": disabled ? DateTBody_noop : dayHover.bind(null, current)
          },
          attrs: {
            role: "gridcell",
            title: getTitleString(current)
          },
          "class": cls
        }, [dateHtml]));
        passed++;
      }

      tableHtml.push(h("tr", {
        key: iIndex,
        attrs: {
          role: "row"
        },
        "class": external_classnames_default()((_cx = {}, DateTBody_defineProperty(_cx, "".concat(prefixCls, "-current-week"), isCurrentWeek), DateTBody_defineProperty(_cx, "".concat(prefixCls, "-active-week"), isActiveWeek), _cx))
      }, [weekNumberCell, dateCells]));
    }

    return h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [tableHtml]);
  }
};
/* harmony default export */ var date_DateTBody = (DateTBody);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/date/DateTable.jsx


/* harmony default export */ var DateTable = ({
  functional: true,
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props,
        _context$listeners = context.listeners,
        listeners = _context$listeners === void 0 ? {} : _context$listeners;
    var prefixCls = props.prefixCls;
    var bodyProps = {
      props: props,
      on: listeners
    };
    return h("table", {
      "class": "".concat(prefixCls, "-table"),
      attrs: {
        cellSpacing: "0",
        role: "grid"
      }
    }, [h(DateTHead, bodyProps), h(date_DateTBody, bodyProps)]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/month/MonthTable.jsx
function MonthTable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var ROW = 4;
var COL = 3;

function MonthTable_noop() {}

var MonthTable = {
  name: 'MonthTable',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    cellRender: vue_types["a" /* default */].func,
    prefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].object,
    locale: vue_types["a" /* default */].any,
    contentRender: vue_types["a" /* default */].any,
    disabledDate: vue_types["a" /* default */].func
  },
  data: function data() {
    return {
      sValue: this.value
    };
  },
  watch: {
    value: function value(val) {
      this.setState({
        sValue: val
      });
    }
  },
  methods: {
    setAndSelectValue: function setAndSelectValue(value) {
      this.setState({
        sValue: value
      });

      this.__emit('select', value);
    },
    chooseMonth: function chooseMonth(month) {
      var next = this.sValue.clone();
      next.month(month);
      this.setAndSelectValue(next);
    },
    months: function months() {
      var value = this.sValue;
      var current = value.clone();
      var months = [];
      var index = 0;

      for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
        months[rowIndex] = [];

        for (var colIndex = 0; colIndex < COL; colIndex++) {
          current.month(index);
          var content = current.localeData().monthsShort(current);
          months[rowIndex][colIndex] = {
            value: index,
            content: content,
            title: content
          };
          index++;
        }
      }

      return months;
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var props = this.$props;
    var value = this.sValue;
    var today = getTodayTime(value);
    var months = this.months();
    var currentMonth = value.month();
    var prefixCls = props.prefixCls,
        locale = props.locale,
        contentRender = props.contentRender,
        cellRender = props.cellRender,
        disabledDate = props.disabledDate;
    var monthsEls = months.map(function (month, index) {
      var tds = month.map(function (monthData) {
        var _classNameMap;

        var disabled = false;

        if (disabledDate) {
          var testValue = value.clone();
          testValue.month(monthData.value);
          disabled = disabledDate(testValue);
        }

        var classNameMap = (_classNameMap = {}, MonthTable_defineProperty(_classNameMap, "".concat(prefixCls, "-cell"), 1), MonthTable_defineProperty(_classNameMap, "".concat(prefixCls, "-cell-disabled"), disabled), MonthTable_defineProperty(_classNameMap, "".concat(prefixCls, "-selected-cell"), monthData.value === currentMonth), MonthTable_defineProperty(_classNameMap, "".concat(prefixCls, "-current-cell"), today.year() === value.year() && monthData.value === today.month()), _classNameMap);
        var cellEl;

        if (cellRender) {
          var currentValue = value.clone();
          currentValue.month(monthData.value);
          cellEl = cellRender(currentValue, locale);
        } else {
          var content;

          if (contentRender) {
            var _currentValue = value.clone();

            _currentValue.month(monthData.value);

            content = contentRender(_currentValue, locale);
          } else {
            content = monthData.content;
          }

          cellEl = h("a", {
            "class": "".concat(prefixCls, "-month")
          }, [content]);
        }

        return h("td", {
          attrs: {
            role: "gridcell",
            title: monthData.title
          },
          key: monthData.value,
          on: {
            "click": disabled ? MonthTable_noop : function () {
              return _this.chooseMonth(monthData.value);
            }
          },
          "class": classNameMap
        }, [cellEl]);
      });
      return h("tr", {
        key: index,
        attrs: {
          role: "row"
        }
      }, [tds]);
    });
    return h("table", {
      "class": "".concat(prefixCls, "-table"),
      attrs: {
        cellSpacing: "0",
        role: "grid"
      }
    }, [h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [monthsEls])]);
  }
};
/* harmony default export */ var month_MonthTable = (MonthTable);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/month/MonthPanel.jsx






function goYear(direction) {
  this.changeYear(direction);
}

function MonthPanel_noop() {}

var MonthPanel = {
  name: 'MonthPanel',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    value: vue_types["a" /* default */].any,
    defaultValue: vue_types["a" /* default */].any,
    cellRender: vue_types["a" /* default */].any,
    contentRender: vue_types["a" /* default */].any,
    locale: vue_types["a" /* default */].any,
    rootPrefixCls: vue_types["a" /* default */].string,
    // onChange: PropTypes.func,
    disabledDate: vue_types["a" /* default */].func,
    // onSelect: PropTypes.func,
    renderFooter: vue_types["a" /* default */].func,
    changeYear: vue_types["a" /* default */].func.def(MonthPanel_noop)
  },
  data: function data() {
    var value = this.value,
        defaultValue = this.defaultValue; // bind methods

    this.nextYear = goYear.bind(this, 1);
    this.previousYear = goYear.bind(this, -1);
    return {
      sValue: value || defaultValue
    };
  },
  watch: {
    value: function value(val) {
      this.setState({
        sValue: val
      });
    }
  },
  methods: {
    setAndSelectValue: function setAndSelectValue(value) {
      this.setValue(value);

      this.__emit('select', value);
    },
    setValue: function setValue(value) {
      if (Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }
    },
    renderMonthPanel: function renderMonthPanel(locale) {
      var h = this.$createElement;
      var sValue = this.sValue,
          cellRender = this.cellRender,
          contentRender = this.contentRender,
          rootPrefixCls = this.rootPrefixCls,
          disabledDate = this.disabledDate,
          renderFooter = this.renderFooter;
      var year = sValue.year();
      var prefixCls = "".concat(rootPrefixCls, "-month-panel");
      var footer = renderFooter && renderFooter('month');
      return h("div", {
        "class": prefixCls
      }, [h("div", [h("div", {
        "class": "".concat(prefixCls, "-header")
      }, [h("a", {
        "class": "".concat(prefixCls, "-prev-year-btn"),
        attrs: {
          role: "button",
          title: locale.previousYear
        },
        on: {
          "click": this.previousYear
        }
      }), h("a", {
        "class": "".concat(prefixCls, "-year-select"),
        attrs: {
          role: "button",
          title: locale.yearSelect
        },
        on: {
          "click": Object(props_util["getListeners"])(this).yearPanelShow || MonthPanel_noop
        }
      }, [h("span", {
        "class": "".concat(prefixCls, "-year-select-content")
      }, [year, "\u5E74"]), h("span", {
        "class": "".concat(prefixCls, "-year-select-arrow")
      }, ["x"])]), h("a", {
        "class": "".concat(prefixCls, "-next-year-btn"),
        attrs: {
          role: "button",
          title: locale.nextYear
        },
        on: {
          "click": this.nextYear
        }
      })]), h("div", {
        "class": "".concat(prefixCls, "-body")
      }, [h(month_MonthTable, {
        attrs: {
          disabledDate: disabledDate,
          locale: locale,
          value: sValue,
          cellRender: cellRender,
          contentRender: contentRender,
          prefixCls: prefixCls
        },
        on: {
          "select": this.setAndSelectValue
        }
      })]), footer && h("div", {
        "class": "".concat(prefixCls, "-footer")
      }, [footer])])]);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(LocaleReceiver["a" /* default */], {
      attrs: {
        componentName: "TimePicker"
      },
      scopedSlots: {
        default: this.renderMonthPanel
      }
    });
  }
};
/* harmony default export */ var month_MonthPanel = (MonthPanel);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/year/YearPanel.jsx
function YearPanel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var YearPanel_ROW = 4;
var YearPanel_COL = 3;

function YearPanel_noop() {}

function YearPanel_goYear(direction) {
  var value = this.sValue.clone();
  value.add(direction, 'year');
  this.setState({
    sValue: value
  });
}

function chooseYear(year) {
  var value = this.sValue.clone();
  value.year(year);
  value.month(this.sValue.month());
  this.sValue = value;

  this.__emit('select', value);
}

/* harmony default export */ var YearPanel = ({
  mixins: [BaseMixin["a" /* default */]],
  props: {
    rootPrefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].object,
    defaultValue: vue_types["a" /* default */].object,
    locale: vue_types["a" /* default */].object,
    renderFooter: vue_types["a" /* default */].func
  },
  data: function data() {
    this.nextDecade = YearPanel_goYear.bind(this, 10);
    this.previousDecade = YearPanel_goYear.bind(this, -10);
    return {
      sValue: this.value || this.defaultValue
    };
  },
  watch: {
    value: function value(val) {
      this.sValue = val;
    }
  },
  methods: {
    years: function years() {
      var value = this.sValue;
      var currentYear = value.year();
      var startYear = parseInt(currentYear / 10, 10) * 10;
      var previousYear = startYear - 1;
      var years = [];
      var index = 0;

      for (var rowIndex = 0; rowIndex < YearPanel_ROW; rowIndex++) {
        years[rowIndex] = [];

        for (var colIndex = 0; colIndex < YearPanel_COL; colIndex++) {
          var year = previousYear + index;
          var content = String(year);
          years[rowIndex][colIndex] = {
            content: content,
            year: year,
            title: content
          };
          index++;
        }
      }

      return years;
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var value = this.sValue,
        locale = this.locale,
        renderFooter = this.renderFooter;
    var decadePanelShow = Object(props_util["getListeners"])(this).decadePanelShow || YearPanel_noop;
    var years = this.years();
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 10, 10) * 10;
    var endYear = startYear + 9;
    var prefixCls = "".concat(this.rootPrefixCls, "-year-panel");
    var yeasEls = years.map(function (row, index) {
      var tds = row.map(function (yearData) {
        var _classNameMap;

        var classNameMap = (_classNameMap = {}, YearPanel_defineProperty(_classNameMap, "".concat(prefixCls, "-cell"), 1), YearPanel_defineProperty(_classNameMap, "".concat(prefixCls, "-selected-cell"), yearData.year === currentYear), YearPanel_defineProperty(_classNameMap, "".concat(prefixCls, "-last-decade-cell"), yearData.year < startYear), YearPanel_defineProperty(_classNameMap, "".concat(prefixCls, "-next-decade-cell"), yearData.year > endYear), _classNameMap);
        var clickHandler = YearPanel_noop;

        if (yearData.year < startYear) {
          clickHandler = _this.previousDecade;
        } else if (yearData.year > endYear) {
          clickHandler = _this.nextDecade;
        } else {
          clickHandler = chooseYear.bind(_this, yearData.year);
        }

        return h("td", {
          attrs: {
            role: "gridcell",
            title: yearData.title
          },
          key: yearData.content,
          on: {
            "click": clickHandler
          },
          "class": classNameMap
        }, [h("a", {
          "class": "".concat(prefixCls, "-year")
        }, [yearData.content])]);
      });
      return h("tr", {
        key: index,
        attrs: {
          role: "row"
        }
      }, [tds]);
    });
    var footer = renderFooter && renderFooter('year');
    return h("div", {
      "class": prefixCls
    }, [h("div", [h("div", {
      "class": "".concat(prefixCls, "-header")
    }, [h("a", {
      "class": "".concat(prefixCls, "-prev-decade-btn"),
      attrs: {
        role: "button",
        title: locale.previousDecade
      },
      on: {
        "click": this.previousDecade
      }
    }), h("a", {
      "class": "".concat(prefixCls, "-decade-select"),
      attrs: {
        role: "button",
        title: locale.decadeSelect
      },
      on: {
        "click": decadePanelShow
      }
    }, [h("span", {
      "class": "".concat(prefixCls, "-decade-select-content")
    }, [startYear, "-", endYear]), h("span", {
      "class": "".concat(prefixCls, "-decade-select-arrow")
    }, ["x"])]), h("a", {
      "class": "".concat(prefixCls, "-next-decade-btn"),
      attrs: {
        role: "button",
        title: locale.nextDecade
      },
      on: {
        "click": this.nextDecade
      }
    })]), h("div", {
      "class": "".concat(prefixCls, "-body")
    }, [h("table", {
      "class": "".concat(prefixCls, "-table"),
      attrs: {
        cellSpacing: "0",
        role: "grid"
      }
    }, [h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [yeasEls])])]), footer && h("div", {
      "class": "".concat(prefixCls, "-footer")
    }, [footer])])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/decade/DecadePanel.jsx
function DecadePanel_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var DecadePanel_ROW = 4;
var DecadePanel_COL = 3;

function DecadePanel_noop() {}

function DecadePanel_goYear(direction) {
  var next = this.sValue.clone();
  next.add(direction, 'years');
  this.setState({
    sValue: next
  });
}

function chooseDecade(year, event) {
  var next = this.sValue.clone();
  next.year(year);
  next.month(this.sValue.month());

  this.__emit('select', next);

  event.preventDefault();
}

/* harmony default export */ var DecadePanel = ({
  mixins: [BaseMixin["a" /* default */]],
  props: {
    locale: vue_types["a" /* default */].object,
    value: vue_types["a" /* default */].object,
    defaultValue: vue_types["a" /* default */].object,
    rootPrefixCls: vue_types["a" /* default */].string,
    renderFooter: vue_types["a" /* default */].func
  },
  data: function data() {
    this.nextCentury = DecadePanel_goYear.bind(this, 100);
    this.previousCentury = DecadePanel_goYear.bind(this, -100);
    return {
      sValue: this.value || this.defaultValue
    };
  },
  watch: {
    value: function value(val) {
      this.sValue = val;
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var value = this.sValue;
    var _this$$props = this.$props,
        locale = _this$$props.locale,
        renderFooter = _this$$props.renderFooter;
    var currentYear = value.year();
    var startYear = parseInt(currentYear / 100, 10) * 100;
    var preYear = startYear - 10;
    var endYear = startYear + 99;
    var decades = [];
    var index = 0;
    var prefixCls = "".concat(this.rootPrefixCls, "-decade-panel");

    for (var rowIndex = 0; rowIndex < DecadePanel_ROW; rowIndex++) {
      decades[rowIndex] = [];

      for (var colIndex = 0; colIndex < DecadePanel_COL; colIndex++) {
        var startDecade = preYear + index * 10;
        var endDecade = preYear + index * 10 + 9;
        decades[rowIndex][colIndex] = {
          startDecade: startDecade,
          endDecade: endDecade
        };
        index++;
      }
    }

    var footer = renderFooter && renderFooter('decade');
    var decadesEls = decades.map(function (row, decadeIndex) {
      var tds = row.map(function (decadeData) {
        var _classNameMap;

        var dStartDecade = decadeData.startDecade;
        var dEndDecade = decadeData.endDecade;
        var isLast = dStartDecade < startYear;
        var isNext = dEndDecade > endYear;
        var classNameMap = (_classNameMap = {}, DecadePanel_defineProperty(_classNameMap, "".concat(prefixCls, "-cell"), 1), DecadePanel_defineProperty(_classNameMap, "".concat(prefixCls, "-selected-cell"), dStartDecade <= currentYear && currentYear <= dEndDecade), DecadePanel_defineProperty(_classNameMap, "".concat(prefixCls, "-last-century-cell"), isLast), DecadePanel_defineProperty(_classNameMap, "".concat(prefixCls, "-next-century-cell"), isNext), _classNameMap);
        var content = "".concat(dStartDecade, "-").concat(dEndDecade);
        var clickHandler = DecadePanel_noop;

        if (isLast) {
          clickHandler = _this.previousCentury;
        } else if (isNext) {
          clickHandler = _this.nextCentury;
        } else {
          clickHandler = chooseDecade.bind(_this, dStartDecade);
        }

        return h("td", {
          key: dStartDecade,
          on: {
            "click": clickHandler
          },
          attrs: {
            role: "gridcell"
          },
          "class": classNameMap
        }, [h("a", {
          "class": "".concat(prefixCls, "-decade")
        }, [content])]);
      });
      return h("tr", {
        key: decadeIndex,
        attrs: {
          role: "row"
        }
      }, [tds]);
    });
    return h("div", {
      "class": prefixCls
    }, [h("div", {
      "class": "".concat(prefixCls, "-header")
    }, [h("a", {
      "class": "".concat(prefixCls, "-prev-century-btn"),
      attrs: {
        role: "button",
        title: locale.previousCentury
      },
      on: {
        "click": this.previousCentury
      }
    }), h("div", {
      "class": "".concat(prefixCls, "-century")
    }, [startYear, "-", endYear]), h("a", {
      "class": "".concat(prefixCls, "-next-century-btn"),
      attrs: {
        role: "button",
        title: locale.nextCentury
      },
      on: {
        "click": this.nextCentury
      }
    })]), h("div", {
      "class": "".concat(prefixCls, "-body")
    }, [h("table", {
      "class": "".concat(prefixCls, "-table"),
      attrs: {
        cellSpacing: "0",
        role: "grid"
      }
    }, [h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [decadesEls])])]), footer && h("div", {
      "class": "".concat(prefixCls, "-footer")
    }, [footer])]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/calendar/CalendarHeader.jsx







function CalendarHeader_noop() {}

function goMonth(direction) {
  var next = this.value.clone();
  next.add(direction, 'months');

  this.__emit('valueChange', next);
}

function CalendarHeader_goYear(direction) {
  var next = this.value.clone();
  next.add(direction, 'years');

  this.__emit('valueChange', next);
}

function showIf(condition, el) {
  return condition ? el : null;
}

var CalendarHeader = {
  name: 'CalendarHeader',
  mixins: [BaseMixin["a" /* default */]],
  props: {
    prefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].object,
    // onValueChange: PropTypes.func,
    showTimePicker: vue_types["a" /* default */].bool,
    // onPanelChange: PropTypes.func,
    locale: vue_types["a" /* default */].object,
    enablePrev: vue_types["a" /* default */].any.def(1),
    enableNext: vue_types["a" /* default */].any.def(1),
    disabledMonth: vue_types["a" /* default */].func,
    mode: vue_types["a" /* default */].any,
    monthCellRender: vue_types["a" /* default */].func,
    monthCellContentRender: vue_types["a" /* default */].func,
    renderFooter: vue_types["a" /* default */].func
  },
  data: function data() {
    this.nextMonth = goMonth.bind(this, 1);
    this.previousMonth = goMonth.bind(this, -1);
    this.nextYear = CalendarHeader_goYear.bind(this, 1);
    this.previousYear = CalendarHeader_goYear.bind(this, -1);
    return {
      yearPanelReferer: null
    };
  },
  methods: {
    onMonthSelect: function onMonthSelect(value) {
      this.__emit('panelChange', value, 'date');

      if (Object(props_util["getListeners"])(this).monthSelect) {
        this.__emit('monthSelect', value);
      } else {
        this.__emit('valueChange', value);
      }
    },
    onYearSelect: function onYearSelect(value) {
      var referer = this.yearPanelReferer;
      this.setState({
        yearPanelReferer: null
      });

      this.__emit('panelChange', value, referer);

      this.__emit('valueChange', value);
    },
    onDecadeSelect: function onDecadeSelect(value) {
      this.__emit('panelChange', value, 'year');

      this.__emit('valueChange', value);
    },
    changeYear: function changeYear(direction) {
      if (direction > 0) {
        this.nextYear();
      } else {
        this.previousYear();
      }
    },
    monthYearElement: function monthYearElement(showTimePicker) {
      var _this = this;

      var h = this.$createElement;
      var props = this.$props;
      var prefixCls = props.prefixCls;
      var locale = props.locale;
      var value = props.value;
      var localeData = value.localeData();
      var monthBeforeYear = locale.monthBeforeYear;
      var selectClassName = "".concat(prefixCls, "-").concat(monthBeforeYear ? 'my-select' : 'ym-select');
      var timeClassName = showTimePicker ? " ".concat(prefixCls, "-time-status") : '';
      var year = h("a", {
        "class": "".concat(prefixCls, "-year-select").concat(timeClassName),
        attrs: {
          role: "button",
          title: showTimePicker ? null : locale.yearSelect
        },
        on: {
          "click": showTimePicker ? CalendarHeader_noop : function () {
            return _this.showYearPanel('date');
          }
        }
      }, [value.format(locale.yearFormat)]);
      var month = h("a", {
        "class": "".concat(prefixCls, "-month-select").concat(timeClassName),
        attrs: {
          role: "button",
          title: showTimePicker ? null : locale.monthSelect
        },
        on: {
          "click": showTimePicker ? CalendarHeader_noop : this.showMonthPanel
        }
      }, [locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)]);
      var day;

      if (showTimePicker) {
        day = h("a", {
          "class": "".concat(prefixCls, "-day-select").concat(timeClassName),
          attrs: {
            role: "button"
          }
        }, [value.format(locale.dayFormat)]);
      }

      var my = [];

      if (monthBeforeYear) {
        my = [month, day, year];
      } else {
        my = [year, month, day];
      }

      return h("span", {
        "class": selectClassName
      }, [my]);
    },
    showMonthPanel: function showMonthPanel() {
      // null means that users' interaction doesn't change value
      this.__emit('panelChange', null, 'month');
    },
    showYearPanel: function showYearPanel(referer) {
      this.setState({
        yearPanelReferer: referer
      });

      this.__emit('panelChange', null, 'year');
    },
    showDecadePanel: function showDecadePanel() {
      this.__emit('panelChange', null, 'decade');
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var prefixCls = props.prefixCls,
        locale = props.locale,
        mode = props.mode,
        value = props.value,
        showTimePicker = props.showTimePicker,
        enableNext = props.enableNext,
        enablePrev = props.enablePrev,
        disabledMonth = props.disabledMonth,
        renderFooter = props.renderFooter;
    var panel = null;

    if (mode === 'month') {
      panel = h(month_MonthPanel, {
        attrs: {
          locale: locale,
          value: value,
          rootPrefixCls: prefixCls,
          disabledDate: disabledMonth,
          cellRender: props.monthCellRender,
          contentRender: props.monthCellContentRender,
          renderFooter: renderFooter,
          changeYear: this.changeYear
        },
        on: {
          "select": this.onMonthSelect,
          "yearPanelShow": function yearPanelShow() {
            return _this2.showYearPanel('month');
          }
        }
      });
    }

    if (mode === 'year') {
      panel = h(YearPanel, {
        attrs: {
          locale: locale,
          value: value,
          rootPrefixCls: prefixCls,
          renderFooter: renderFooter
        },
        on: {
          "select": this.onYearSelect,
          "decadePanelShow": this.showDecadePanel
        }
      });
    }

    if (mode === 'decade') {
      panel = h(DecadePanel, {
        attrs: {
          locale: locale,
          value: value,
          rootPrefixCls: prefixCls,
          renderFooter: renderFooter
        },
        on: {
          "select": this.onDecadeSelect
        }
      });
    }

    return h("div", {
      "class": "".concat(prefixCls, "-header")
    }, [h("div", {
      style: {
        position: 'relative'
      }
    }, [showIf(enablePrev && !showTimePicker, h("a", {
      "class": "".concat(prefixCls, "-prev-year-btn"),
      attrs: {
        role: "button",
        title: locale.previousYear
      },
      on: {
        "click": this.previousYear
      }
    })), showIf(enablePrev && !showTimePicker, h("a", {
      "class": "".concat(prefixCls, "-prev-month-btn"),
      attrs: {
        role: "button",
        title: locale.previousMonth
      },
      on: {
        "click": this.previousMonth
      }
    })), this.monthYearElement(showTimePicker), showIf(enableNext && !showTimePicker, h("a", {
      "class": "".concat(prefixCls, "-next-month-btn"),
      on: {
        "click": this.nextMonth
      },
      attrs: {
        title: locale.nextMonth
      }
    })), showIf(enableNext && !showTimePicker, h("a", {
      "class": "".concat(prefixCls, "-next-year-btn"),
      on: {
        "click": this.nextYear
      },
      attrs: {
        title: locale.nextYear
      }
    }))]), panel]);
  }
};
/* harmony default export */ var calendar_CalendarHeader = (CalendarHeader);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/calendar/TodayButton.jsx


function TodayButton_noop() {}

/* harmony default export */ var TodayButton = ({
  functional: true,
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props,
        _context$listeners = context.listeners,
        listeners = _context$listeners === void 0 ? {} : _context$listeners;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        value = props.value,
        timePicker = props.timePicker,
        disabled = props.disabled,
        disabledDate = props.disabledDate,
        text = props.text;
    var _listeners$today = listeners.today,
        today = _listeners$today === void 0 ? TodayButton_noop : _listeners$today;
    var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
    var disabledToday = disabledDate && !util_isAllowedDate(getTodayTime(value), disabledDate);
    var isDisabled = disabledToday || disabled;
    var disabledTodayClass = isDisabled ? "".concat(prefixCls, "-today-btn-disabled") : '';
    return h("a", {
      "class": "".concat(prefixCls, "-today-btn ").concat(disabledTodayClass),
      attrs: {
        role: "button",
        title: getTodayTimeStr(value)
      },
      on: {
        "click": isDisabled ? TodayButton_noop : today
      }
    }, [localeNow]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/calendar/OkButton.jsx
function OkButton_noop() {}

/* harmony default export */ var OkButton = ({
  functional: true,
  render: function render(createElement, context) {
    var h = arguments[0];
    var props = context.props,
        _context$listeners = context.listeners,
        listeners = _context$listeners === void 0 ? {} : _context$listeners;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        okDisabled = props.okDisabled;
    var _listeners$ok = listeners.ok,
        ok = _listeners$ok === void 0 ? OkButton_noop : _listeners$ok;
    var className = "".concat(prefixCls, "-ok-btn");

    if (okDisabled) {
      className += " ".concat(prefixCls, "-ok-btn-disabled");
    }

    return h("a", {
      "class": className,
      attrs: {
        role: "button"
      },
      on: {
        "click": okDisabled ? OkButton_noop : ok
      }
    }, [locale.ok]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/calendar/TimePickerButton.jsx
function TimePickerButton_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TimePickerButton_noop() {}

/* harmony default export */ var TimePickerButton = ({
  functional: true,
  render: function render(h, context) {
    var _className;

    var props = context.props,
        _context$listeners = context.listeners,
        listeners = _context$listeners === void 0 ? {} : _context$listeners;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        showTimePicker = props.showTimePicker,
        timePickerDisabled = props.timePickerDisabled;
    var _listeners$closeTimeP = listeners.closeTimePicker,
        closeTimePicker = _listeners$closeTimeP === void 0 ? TimePickerButton_noop : _listeners$closeTimeP,
        _listeners$openTimePi = listeners.openTimePicker,
        openTimePicker = _listeners$openTimePi === void 0 ? TimePickerButton_noop : _listeners$openTimePi;
    var className = (_className = {}, TimePickerButton_defineProperty(_className, "".concat(prefixCls, "-time-picker-btn"), true), TimePickerButton_defineProperty(_className, "".concat(prefixCls, "-time-picker-btn-disabled"), timePickerDisabled), _className);
    var onClick = TimePickerButton_noop;

    if (!timePickerDisabled) {
      onClick = showTimePicker ? closeTimePicker : openTimePicker;
    }

    return h("a", {
      "class": className,
      attrs: {
        role: "button"
      },
      on: {
        "click": onClick
      }
    }, [showTimePicker ? locale.dateSelect : locale.timeSelect]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/calendar/CalendarFooter.jsx




function CalendarFooter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CalendarFooter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CalendarFooter_ownKeys(Object(source), true).forEach(function (key) { CalendarFooter_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CalendarFooter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CalendarFooter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var CalendarFooter = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    prefixCls: vue_types["a" /* default */].string,
    showDateInput: vue_types["a" /* default */].bool,
    disabledTime: vue_types["a" /* default */].any,
    timePicker: vue_types["a" /* default */].any,
    selectedValue: vue_types["a" /* default */].any,
    showOk: vue_types["a" /* default */].bool,
    // onSelect: PropTypes.func,
    value: vue_types["a" /* default */].object,
    renderFooter: vue_types["a" /* default */].func,
    defaultValue: vue_types["a" /* default */].object,
    locale: vue_types["a" /* default */].object,
    showToday: vue_types["a" /* default */].bool,
    disabledDate: vue_types["a" /* default */].func,
    showTimePicker: vue_types["a" /* default */].bool,
    okDisabled: vue_types["a" /* default */].bool,
    mode: vue_types["a" /* default */].string
  },
  methods: {
    onSelect: function onSelect(value) {
      this.__emit('select', value);
    },
    getRootDOMNode: function getRootDOMNode() {
      return this.$el;
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var value = props.value,
        prefixCls = props.prefixCls,
        showOk = props.showOk,
        timePicker = props.timePicker,
        renderFooter = props.renderFooter,
        showToday = props.showToday,
        mode = props.mode;
    var footerEl = null;
    var extraFooter = renderFooter && renderFooter(mode);

    if (showToday || timePicker || extraFooter) {
      var _cls;

      var btnProps = {
        props: CalendarFooter_objectSpread(CalendarFooter_objectSpread({}, props), {}, {
          value: value
        }),
        on: Object(props_util["getListeners"])(this)
      };
      var nowEl = null;

      if (showToday) {
        nowEl = h(TodayButton, babel_helper_vue_jsx_merge_props_default()([{
          key: "todayButton"
        }, btnProps]));
      }

      delete btnProps.props.value;
      var okBtn = null;

      if (showOk === true || showOk !== false && !!timePicker) {
        okBtn = h(OkButton, babel_helper_vue_jsx_merge_props_default()([{
          key: "okButton"
        }, btnProps]));
      }

      var timePickerBtn = null;

      if (timePicker) {
        timePickerBtn = h(TimePickerButton, babel_helper_vue_jsx_merge_props_default()([{
          key: "timePickerButton"
        }, btnProps]));
      }

      var footerBtn;

      if (nowEl || timePickerBtn || okBtn || extraFooter) {
        footerBtn = h("span", {
          "class": "".concat(prefixCls, "-footer-btn")
        }, [extraFooter, nowEl]);
      }

      var cls = (_cls = {}, CalendarFooter_defineProperty(_cls, "".concat(prefixCls, "-footer"), true), CalendarFooter_defineProperty(_cls, "".concat(prefixCls, "-footer-show-ok"), !!okBtn), _cls);
      footerEl = h("div", {
        "class": cls
      }, [footerBtn]);
    }

    return footerEl;
  }
};
/* harmony default export */ var calendar_CalendarFooter = (CalendarFooter);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/mixin/CalendarMixin.js
function CalendarMixin_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function CalendarMixin_noop() {}

function getNowByCurrentStateValue(value) {
  var ret;

  if (value) {
    ret = getTodayTime(value);
  } else {
    ret = external_moment_default()();
  }

  return ret;
}

function isMoment(value) {
  if (Array.isArray(value)) {
    return value.length === 0 || value.findIndex(function (val) {
      return val === undefined || external_moment_default.a.isMoment(val);
    }) !== -1;
  } else {
    return value === undefined || external_moment_default.a.isMoment(value);
  }
}

var MomentType = vue_types["a" /* default */].custom(isMoment);
var CalendarMixin = {
  mixins: [BaseMixin["a" /* default */]],
  name: 'CalendarMixinWrapper',
  props: {
    value: MomentType,
    defaultValue: MomentType
  },
  data: function data() {
    var props = this.$props;
    var sValue = props.value || props.defaultValue || getNowByCurrentStateValue();
    return {
      sValue: sValue,
      sSelectedValue: props.selectedValue || props.defaultSelectedValue
    };
  },
  watch: {
    value: function value(val) {
      var sValue = val || this.defaultValue || getNowByCurrentStateValue(this.sValue);
      this.setState({
        sValue: sValue
      });
    },
    selectedValue: function selectedValue(val) {
      this.setState({
        sSelectedValue: val
      });
    }
  },
  methods: {
    onSelect: function onSelect(value, cause) {
      if (value) {
        this.setValue(value);
      }

      this.setSelectedValue(value, cause);
    },
    renderRoot: function renderRoot(newProps) {
      var _className;

      var h = this.$createElement;
      var props = this.$props;
      var prefixCls = props.prefixCls;
      var className = (_className = {}, CalendarMixin_defineProperty(_className, prefixCls, 1), CalendarMixin_defineProperty(_className, "".concat(prefixCls, "-hidden"), !props.visible), CalendarMixin_defineProperty(_className, newProps.class, !!newProps.class), _className);
      return h("div", {
        ref: "rootInstance",
        "class": className,
        attrs: {
          tabIndex: "0"
        },
        on: {
          "keydown": this.onKeyDown || CalendarMixin_noop,
          "blur": this.onBlur || CalendarMixin_noop
        }
      }, [newProps.children]);
    },
    setSelectedValue: function setSelectedValue(selectedValue, cause) {
      // if (this.isAllowedDate(selectedValue)) {
      if (!Object(props_util["hasProp"])(this, 'selectedValue')) {
        this.setState({
          sSelectedValue: selectedValue
        });
      }

      this.__emit('select', selectedValue, cause); // }

    },
    setValue: function setValue(value) {
      var originalValue = this.sValue;

      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }

      if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
        this.__emit('change', value);
      }
    },
    isAllowedDate: function isAllowedDate(value) {
      var disabledDate = this.disabledDate;
      var disabledTime = this.disabledTime;
      return util_isAllowedDate(value, disabledDate, disabledTime);
    }
  }
};
/* harmony default export */ var mixin_CalendarMixin = (CalendarMixin);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/mixin/CommonMixin.js
/* harmony default export */ var CommonMixin = ({
  methods: {
    getFormat: function getFormat() {
      var format = this.format;
      var locale = this.locale,
          timePicker = this.timePicker;

      if (!format) {
        if (timePicker) {
          format = locale.dateTimeFormat;
        } else {
          format = locale.dateFormat;
        }
      }

      return format;
    },
    focus: function focus() {
      if (this.focusElement) {
        this.focusElement.focus();
      } else if (this.$refs.rootInstance) {
        this.$refs.rootInstance.focus();
      }
    },
    saveFocusElement: function saveFocusElement(focusElement) {
      this.focusElement = focusElement;
    }
  }
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/date/DateInput.jsx







var cachedSelectionStart;
var cachedSelectionEnd;
var dateInputInstance;
var DateInput = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    prefixCls: vue_types["a" /* default */].string,
    timePicker: vue_types["a" /* default */].object,
    value: vue_types["a" /* default */].object,
    disabledTime: vue_types["a" /* default */].any,
    format: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string), vue_types["a" /* default */].func]),
    locale: vue_types["a" /* default */].object,
    disabledDate: vue_types["a" /* default */].func,
    // onChange: PropTypes.func,
    // onClear: PropTypes.func,
    placeholder: vue_types["a" /* default */].string,
    // onSelect: PropTypes.func,
    selectedValue: vue_types["a" /* default */].object,
    clearIcon: vue_types["a" /* default */].any,
    inputMode: vue_types["a" /* default */].string,
    inputReadOnly: vue_types["a" /* default */].bool
  },
  data: function data() {
    var selectedValue = this.selectedValue;
    return {
      str: formatDate(selectedValue, this.format),
      invalid: false,
      hasFocus: false
    };
  },
  watch: {
    selectedValue: function selectedValue() {
      this.setState();
    },
    format: function format() {
      this.setState();
    }
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      if (dateInputInstance && _this.$data.hasFocus && !_this.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
        dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
      }
    });
  },
  getInstance: function getInstance() {
    return dateInputInstance;
  },
  methods: {
    getDerivedStateFromProps: function getDerivedStateFromProps(nextProps, state) {
      var newState = {};

      if (dateInputInstance) {
        cachedSelectionStart = dateInputInstance.selectionStart;
        cachedSelectionEnd = dateInputInstance.selectionEnd;
      } // when popup show, click body will call this, bug!


      var selectedValue = nextProps.selectedValue;

      if (!state.hasFocus) {
        newState = {
          str: formatDate(selectedValue, this.format),
          invalid: false
        };
      }

      return newState;
    },
    onClear: function onClear() {
      this.setState({
        str: ''
      });

      this.__emit('clear', null);
    },
    onInputChange: function onInputChange(e) {
      var _e$target = e.target,
          str = _e$target.value,
          composing = _e$target.composing;
      var _this$str = this.str,
          oldStr = _this$str === void 0 ? '' : _this$str;
      if (e.isComposing || composing || oldStr === str) return;
      var _this$$props = this.$props,
          disabledDate = _this$$props.disabledDate,
          format = _this$$props.format,
          selectedValue = _this$$props.selectedValue; // 没有内容，合法并直接退出

      if (!str) {
        this.__emit('change', null);

        this.setState({
          invalid: false,
          str: str
        });
        return;
      } // 不合法直接退出


      var parsed = external_moment_default()(str, format, true);

      if (!parsed.isValid()) {
        this.setState({
          invalid: true,
          str: str
        });
        return;
      }

      var value = this.value.clone();
      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());

      if (!value || disabledDate && disabledDate(value)) {
        this.setState({
          invalid: true,
          str: str
        });
        return;
      }

      if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
        this.setState({
          invalid: false,
          str: str
        });

        this.__emit('change', value);
      }
    },
    onFocus: function onFocus() {
      this.setState({
        hasFocus: true
      });
    },
    onBlur: function onBlur() {
      this.setState(function (prevState, prevProps) {
        return {
          hasFocus: false,
          str: formatDate(prevProps.value, prevProps.format)
        };
      });
    },
    onKeyDown: function onKeyDown(event) {
      var keyCode = event.keyCode;
      var _this$$props2 = this.$props,
          value = _this$$props2.value,
          disabledDate = _this$$props2.disabledDate;

      if (keyCode === key_code["a" /* default */].ENTER) {
        var validateDate = !disabledDate || !disabledDate(value);

        if (validateDate) {
          this.__emit('select', value.clone());
        }

        event.preventDefault();
      }
    },
    getRootDOMNode: function getRootDOMNode() {
      return this.$el;
    },
    focus: function focus() {
      if (dateInputInstance) {
        dateInputInstance.focus();
      }
    },
    saveDateInput: function saveDateInput(dateInput) {
      dateInputInstance = dateInput;
    }
  },
  render: function render() {
    var h = arguments[0];
    var invalid = this.invalid,
        str = this.str,
        locale = this.locale,
        prefixCls = this.prefixCls,
        placeholder = this.placeholder,
        disabled = this.disabled,
        showClear = this.showClear,
        inputMode = this.inputMode,
        inputReadOnly = this.inputReadOnly;
    var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
    var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
    return h("div", {
      "class": "".concat(prefixCls, "-input-wrap")
    }, [h("div", {
      "class": "".concat(prefixCls, "-date-input-wrap")
    }, [h("input", babel_helper_vue_jsx_merge_props_default()([{
      directives: [{
        name: 'meg-ref',
        value: this.saveDateInput
      }, {
        name: 'ant-input'
      }]
    }, {
      "class": "".concat(prefixCls, "-input ").concat(invalidClass),
      domProps: {
        "value": str
      },
      attrs: {
        disabled: disabled,
        placeholder: placeholder,
        inputMode: inputMode,
        readOnly: inputReadOnly
      },
      on: {
        "input": this.onInputChange,
        "keydown": this.onKeyDown,
        "focus": this.onFocus,
        "blur": this.onBlur
      }
    }]))]), showClear ? h("a", {
      attrs: {
        role: "button",
        title: locale.clear
      },
      on: {
        "click": this.onClear
      }
    }, [clearIcon || h("span", {
      "class": "".concat(prefixCls, "-clear-btn")
    })]) : null]);
  }
};
/* harmony default export */ var date_DateInput = (DateInput);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/util/toTime.js
function goStartMonth(time) {
  return time.clone().startOf('month');
}
function goEndMonth(time) {
  return time.clone().endOf('month');
}
function toTime_goTime(time, direction, unit) {
  return time.clone().add(direction, unit);
}
function includesTime() {
  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var time = arguments.length > 1 ? arguments[1] : undefined;
  var unit = arguments.length > 2 ? arguments[2] : undefined;
  return timeList.some(function (t) {
    return t.isSame(time, unit);
  });
}
// CONCATENATED MODULE: ./src/base/vc-calendar/src/Calendar.jsx
function Calendar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Calendar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Calendar_ownKeys(Object(source), true).forEach(function (key) { Calendar_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Calendar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Calendar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















var Calendar_getMomentObjectIfValid = function getMomentObjectIfValid(date) {
  if (external_moment_default.a.isMoment(date) && date.isValid()) {
    return date;
  }

  return false;
};

var Calendar = {
  name: 'Calendar',
  props: {
    locale: vue_types["a" /* default */].object,
    format: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string), vue_types["a" /* default */].func]),
    visible: vue_types["a" /* default */].bool.def(true),
    prefixCls: vue_types["a" /* default */].string.def('rc-calendar'),
    // prefixCls: PropTypes.string,
    defaultValue: vue_types["a" /* default */].object,
    value: vue_types["a" /* default */].object,
    selectedValue: vue_types["a" /* default */].object,
    defaultSelectedValue: vue_types["a" /* default */].object,
    mode: vue_types["a" /* default */].oneOf(['time', 'date', 'month', 'year', 'decade']),
    // locale: PropTypes.object,
    showDateInput: vue_types["a" /* default */].bool.def(true),
    showWeekNumber: vue_types["a" /* default */].bool,
    showToday: vue_types["a" /* default */].bool.def(true),
    showOk: vue_types["a" /* default */].bool,
    // onSelect: PropTypes.func,
    // onOk: PropTypes.func,
    // onKeyDown: PropTypes.func,
    timePicker: vue_types["a" /* default */].any,
    dateInputPlaceholder: vue_types["a" /* default */].any,
    // onClear: PropTypes.func,
    // onChange: PropTypes.func,
    // onPanelChange: PropTypes.func,
    disabledDate: vue_types["a" /* default */].func,
    disabledTime: vue_types["a" /* default */].any,
    dateRender: vue_types["a" /* default */].func,
    renderFooter: vue_types["a" /* default */].func.def(function () {
      return null;
    }),
    renderSidebar: vue_types["a" /* default */].func.def(function () {
      return null;
    }),
    clearIcon: vue_types["a" /* default */].any,
    focusablePanel: vue_types["a" /* default */].bool.def(true),
    inputMode: vue_types["a" /* default */].string,
    inputReadOnly: vue_types["a" /* default */].bool
  },
  mixins: [BaseMixin["a" /* default */], CommonMixin, mixin_CalendarMixin],
  data: function data() {
    var props = this.$props;
    return {
      sMode: this.mode || 'date',
      sValue: Calendar_getMomentObjectIfValid(props.value) || Calendar_getMomentObjectIfValid(props.defaultValue) || external_moment_default()(),
      sSelectedValue: props.selectedValue || props.defaultSelectedValue
    };
  },
  watch: {
    mode: function mode(val) {
      this.setState({
        sMode: val
      });
    },
    value: function value(val) {
      this.setState({
        sValue: Calendar_getMomentObjectIfValid(val) || Calendar_getMomentObjectIfValid(this.defaultValue) || getNowByCurrentStateValue(this.sValue)
      });
    },
    selectedValue: function selectedValue(val) {
      this.setState({
        sSelectedValue: val
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.saveFocusElement(date_DateInput.getInstance());

      if (_this.timePicker && _this.$refs.calendar && _this.$refs.calendarWrapper && _this.$refs.timePickerWrapper) {
        _this.$refs.calendar.style.width = _this.$refs.calendarWrapper.getBoundingClientRect().width + _this.$refs.timePickerWrapper.getBoundingClientRect().width + 'px';
      }
    });
  },
  methods: {
    onPanelChange: function onPanelChange(value, mode) {
      var sValue = this.sValue;

      if (!Object(props_util["hasProp"])(this, 'mode')) {
        this.setState({
          sMode: mode
        });
      }

      this.__emit('panelChange', value || sValue, mode);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.target.nodeName.toLowerCase() === 'input') {
        return undefined;
      }

      var keyCode = event.keyCode; // mac

      var ctrlKey = event.ctrlKey || event.metaKey;
      var disabledDate = this.disabledDate,
          value = this.sValue;

      switch (keyCode) {
        case key_code["a" /* default */].DOWN:
          this.goTime(1, 'weeks');
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].UP:
          this.goTime(-1, 'weeks');
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].LEFT:
          if (ctrlKey) {
            this.goTime(-1, 'years');
          } else {
            this.goTime(-1, 'days');
          }

          event.preventDefault();
          return 1;

        case key_code["a" /* default */].RIGHT:
          if (ctrlKey) {
            this.goTime(1, 'years');
          } else {
            this.goTime(1, 'days');
          }

          event.preventDefault();
          return 1;

        case key_code["a" /* default */].HOME:
          this.setValue(goStartMonth(value));
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].END:
          this.setValue(goEndMonth(value));
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].PAGE_DOWN:
          this.goTime(1, 'month');
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].PAGE_UP:
          this.goTime(-1, 'month');
          event.preventDefault();
          return 1;

        case key_code["a" /* default */].ENTER:
          if (!disabledDate || !disabledDate(value)) {
            this.onSelect(value, {
              source: 'keyboard'
            });
          }

          event.preventDefault();
          return 1;

        default:
          this.__emit('keydown', event);

          return 1;
      }
    },
    onClear: function onClear() {
      this.onSelect(null);

      this.__emit('clear');
    },
    onOk: function onOk() {
      var sSelectedValue = this.sSelectedValue;

      if (this.isAllowedDate(sSelectedValue)) {
        this.__emit('ok', sSelectedValue);
      }
    },
    onDateInputChange: function onDateInputChange(value) {
      this.onSelect(value, {
        source: 'dateInput'
      });
    },
    onDateInputSelect: function onDateInputSelect(value) {
      this.onSelect(value, {
        source: 'dateInputSelect'
      });
    },
    onDateTableSelect: function onDateTableSelect(value) {
      var timePicker = this.timePicker,
          sSelectedValue = this.sSelectedValue;

      if (!sSelectedValue && timePicker) {
        var timePickerProps = Object(props_util["getOptionProps"])(timePicker);
        var timePickerDefaultValue = timePickerProps.defaultValue;

        if (timePickerDefaultValue) {
          syncTime(timePickerDefaultValue, value);
        }
      }

      this.onSelect(value);
    },
    onToday: function onToday() {
      var sValue = this.sValue;
      var now = getTodayTime(sValue);
      this.onSelect(now, {
        source: 'todayButton'
      });
    },
    onBlur: function onBlur(event) {
      var _this2 = this;

      setTimeout(function () {
        var dateInput = date_DateInput.getInstance();
        var rootInstance = _this2.rootInstance;

        if (!rootInstance || rootInstance.contains(document.activeElement) || dateInput && dateInput.contains(document.activeElement)) {
          // focused element is still part of Calendar
          return;
        }

        _this2.$emit('blur', event);
      }, 0);
    },
    getRootDOMNode: function getRootDOMNode() {
      return this.$el;
    },
    openTimePicker: function openTimePicker() {
      this.onPanelChange(null, 'time');
    },
    closeTimePicker: function closeTimePicker() {
      this.onPanelChange(null, 'date');
    },
    goTime: function goTime(direction, unit) {
      this.setValue(toTime_goTime(this.sValue, direction, unit));
    },
    renderTimepicker: function renderTimepicker(locale) {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          disabledDate = this.disabledDate,
          dateInputPlaceholder = this.dateInputPlaceholder,
          timePicker = this.timePicker,
          disabledTime = this.disabledTime,
          showDateInput = this.showDateInput,
          sValue = this.sValue,
          sSelectedValue = this.sSelectedValue,
          sMode = this.sMode,
          renderFooter = this.renderFooter,
          inputMode = this.inputMode,
          inputReadOnly = this.inputReadOnly,
          monthCellRender = this.monthCellRender,
          monthCellContentRender = this.monthCellContentRender,
          props = this.$props;
      var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
      var showTimePicker = sMode === 'time';
      var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? getTimeConfig(sSelectedValue, disabledTime) : null;
      var timePickerEle = null;

      if (timePicker) {
        // if (timePicker && showTimePicker) { // 原来的代码
        var timePickerOriginProps = Object(props_util["getOptionProps"])(timePicker);
        var timePickerProps = {
          props: Calendar_objectSpread(Calendar_objectSpread(Calendar_objectSpread({
            showHour: true,
            showSecond: true,
            showMinute: true
          }, timePickerOriginProps), disabledTimeConfig), {}, {
            value: sSelectedValue,
            disabledTime: disabledTime
          }),
          on: {
            change: this.onDateInputChange
          }
        };

        if (timePickerOriginProps.defaultValue !== undefined) {
          timePickerProps.props.defaultOpenValue = timePickerOriginProps.defaultValue;
        }

        timePickerEle = Object(vnode["a" /* cloneElement */])(timePicker, timePickerProps);
      } // const dateInputElement = showDateInput ? (
      //   <DateInput
      //     format={this.getFormat()}
      //     key="date-input"
      //     value={sValue}
      //     locale={locale}
      //     placeholder={dateInputPlaceholder}
      //     showClear
      //     disabledTime={disabledTime}
      //     disabledDate={disabledDate}
      //     onClear={this.onClear}
      //     prefixCls={prefixCls}
      //     selectedValue={sSelectedValue}
      //     onChange={this.onDateInputChange}
      //     clearIcon={clearIcon}
      //     onSelect={this.onDateInputSelect}
      //     inputMode={inputMode}
      //     inputReadOnly={inputReadOnly}
      //   />
      // ) : null;


      var children = [];

      if (props.renderSidebar) {
        children.push(props.renderSidebar());
      }

      children.push(h("div", {
        "class": "".concat(prefixCls, "-panel"),
        key: "panel"
      }, [h("div", {
        ref: "calendar",
        attrs: {
          tabIndex: props.focusablePanel ? 0 : undefined
        },
        "class": "".concat(prefixCls, "-date").concat(timePicker ? '-time' : '', "-panel")
      }, [h("div", {
        ref: "calendarWrapper"
      }, [h(calendar_CalendarHeader, {
        attrs: {
          locale: locale,
          mode: sMode,
          value: sValue,
          renderFooter: renderFooter,
          showTimePicker: showTimePicker,
          prefixCls: prefixCls,
          monthCellRender: monthCellRender,
          monthCellContentRender: monthCellContentRender
        },
        on: {
          "valueChange": this.setValue,
          "panelChange": this.onPanelChange
        }
      }), " ", h("div", {
        "class": "".concat(prefixCls, "-body")
      }, [h(DateTable, {
        attrs: {
          locale: locale,
          value: sValue,
          selectedValue: sSelectedValue,
          prefixCls: prefixCls,
          dateRender: props.dateRender,
          disabledDate: disabledDate,
          showWeekNumber: props.showWeekNumber
        },
        on: {
          "select": this.onDateTableSelect
        }
      })]), h(calendar_CalendarFooter, {
        attrs: {
          showOk: props.showOk,
          mode: sMode,
          renderFooter: props.renderFooter,
          locale: locale,
          prefixCls: prefixCls,
          showToday: props.showToday,
          disabledTime: disabledTime,
          showTimePicker: showTimePicker,
          showDateInput: props.showDateInput,
          timePicker: timePicker,
          selectedValue: sSelectedValue,
          timePickerDisabled: !sSelectedValue,
          value: sValue,
          disabledDate: disabledDate,
          okDisabled: props.showOk !== false && (!sSelectedValue || !this.isAllowedDate(sSelectedValue))
        },
        on: {
          "ok": this.onOk,
          "select": this.onSelect,
          "today": this.onToday,
          "openTimePicker": this.openTimePicker,
          "closeTimePicker": this.closeTimePicker
        }
      })]), h("div", {
        ref: "timePickerWrapper"
      }, [timePicker ? h("div", {
        "class": "".concat(prefixCls, "-time-picker")
      }, [h("div", {
        "class": "".concat(prefixCls, "-time-picker-panel")
      }, [timePickerEle])]) : null])])]));
      return this.renderRoot({
        children: children,
        class: props.showWeekNumber ? "".concat(prefixCls, "-week-number") : ''
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(LocaleReceiver["a" /* default */], {
      attrs: {
        componentName: "TimePicker"
      },
      scopedSlots: {
        default: this.renderTimepicker
      }
    });
  }
};
/* harmony default export */ var src_Calendar = (Calendar);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/index.js

/* harmony default export */ var src = (src_Calendar);
// CONCATENATED MODULE: ./src/base/vc-calendar/index.js
// based on rc-calendar 9.15.10



external_vue_default.a.use(vue_ref_default.a, {
  name: 'meg-ref'
});
/* harmony default export */ var vc_calendar = (src);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/locale/zh_CN.js
/* harmony default export */ var locale_zh_CN = ({
  today: '今天',
  now: '此刻',
  backToToday: '返回今天',
  ok: '确定',
  timeSelect: '选择时间',
  dateSelect: '选择日期',
  weekSelect: '选择周',
  clear: '清除',
  month: '月',
  year: '年',
  previousMonth: '上个月 (翻页上键)',
  nextMonth: '下个月 (翻页下键)',
  monthSelect: '选择月份',
  yearSelect: '选择年份',
  decadeSelect: '选择年代',
  yearFormat: 'YYYY年',
  dayFormat: 'D日',
  dateFormat: 'YYYY年M月D日',
  dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
  previousYear: '上一年 (Control键加左方向键)',
  nextYear: '下一年 (Control键加右方向键)',
  previousDecade: '上一年代',
  nextDecade: '下一年代',
  previousCentury: '上一世纪',
  nextCentury: '下一世纪'
});
// CONCATENATED MODULE: ./src/base/vc-calendar/src/MonthCalendar.jsx









var MonthCalendar = {
  name: 'MonthCalendar',
  props: {
    locale: vue_types["a" /* default */].object.def(locale_zh_CN),
    format: vue_types["a" /* default */].string,
    visible: vue_types["a" /* default */].bool.def(true),
    prefixCls: vue_types["a" /* default */].string.def('rc-calendar'),
    monthCellRender: vue_types["a" /* default */].func,
    value: vue_types["a" /* default */].object,
    defaultValue: vue_types["a" /* default */].object,
    selectedValue: vue_types["a" /* default */].object,
    defaultSelectedValue: vue_types["a" /* default */].object,
    disabledDate: vue_types["a" /* default */].func,
    monthCellContentRender: vue_types["a" /* default */].func,
    renderFooter: vue_types["a" /* default */].func.def(function () {
      return null;
    }),
    renderSidebar: vue_types["a" /* default */].func.def(function () {
      return null;
    })
  },
  mixins: [BaseMixin["a" /* default */], CommonMixin, mixin_CalendarMixin],
  data: function data() {
    var props = this.$props;
    return {
      mode: 'month',
      sValue: props.value || props.defaultValue || external_moment_default()(),
      sSelectedValue: props.selectedValue || props.defaultSelectedValue
    };
  },
  methods: {
    onKeyDown: function onKeyDown(event) {
      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var stateValue = this.sValue;
      var disabledDate = this.disabledDate;
      var value = stateValue;

      switch (keyCode) {
        case key_code["a" /* default */].DOWN:
          value = stateValue.clone();
          value.add(3, 'months');
          break;

        case key_code["a" /* default */].UP:
          value = stateValue.clone();
          value.add(-3, 'months');
          break;

        case key_code["a" /* default */].LEFT:
          value = stateValue.clone();

          if (ctrlKey) {
            value.add(-1, 'years');
          } else {
            value.add(-1, 'months');
          }

          break;

        case key_code["a" /* default */].RIGHT:
          value = stateValue.clone();

          if (ctrlKey) {
            value.add(1, 'years');
          } else {
            value.add(1, 'months');
          }

          break;

        case key_code["a" /* default */].ENTER:
          if (!disabledDate || !disabledDate(stateValue)) {
            this.onSelect(stateValue);
          }

          event.preventDefault();
          return 1;

        default:
          return undefined;
      }

      if (value !== stateValue) {
        this.setValue(value);
        event.preventDefault();
        return 1;
      }
    },
    handlePanelChange: function handlePanelChange(_, mode) {
      if (mode !== 'date') {
        this.setState({
          mode: mode
        });
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var mode = this.mode,
        value = this.sValue,
        props = this.$props,
        $scopedSlots = this.$scopedSlots;
    var prefixCls = props.prefixCls,
        locale = props.locale,
        disabledDate = props.disabledDate;
    var monthCellRender = this.monthCellRender || $scopedSlots.monthCellRender;
    var monthCellContentRender = this.monthCellContentRender || $scopedSlots.monthCellContentRender;
    var renderFooter = this.renderFooter || $scopedSlots.renderFooter;
    var children = h("div", {
      "class": "".concat(prefixCls, "-month-calendar-content")
    }, [h("div", {
      "class": "".concat(prefixCls, "-month-header-wrap")
    }, [h(calendar_CalendarHeader, {
      attrs: {
        prefixCls: prefixCls,
        mode: mode,
        value: value,
        locale: locale,
        disabledMonth: disabledDate,
        monthCellRender: monthCellRender,
        monthCellContentRender: monthCellContentRender
      },
      on: {
        "monthSelect": this.onSelect,
        "valueChange": this.setValue,
        "panelChange": this.handlePanelChange
      }
    })]), h(calendar_CalendarFooter, {
      attrs: {
        prefixCls: prefixCls,
        renderFooter: renderFooter
      }
    })]);
    return this.renderRoot({
      class: "".concat(props.prefixCls, "-month-calendar"),
      children: children
    });
  }
};
/* harmony default export */ var src_MonthCalendar = (MonthCalendar);
// EXTERNAL MODULE: ./node_modules/lodash/omit.js
var omit = __webpack_require__(212);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);

// EXTERNAL MODULE: ./src/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(57);

// CONCATENATED MODULE: ./src/base/vc-calendar/src/picker/placements.js
var placements_autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements_targetOffset = [0, -40];
var placements_placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: placements_targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: placements_targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: placements_targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: placements_autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: placements_targetOffset
  }
};
/* harmony default export */ var picker_placements = (placements_placements);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/Picker.jsx










var Picker_TimeType = {
  validator: function validator(value) {
    if (Array.isArray(value)) {
      return value.length === 0 || value.findIndex(function (val) {
        return !isNil_default()(val) && !external_moment_default.a.isMoment(val);
      }) === -1;
    } else {
      return isNil_default()(value) || external_moment_default.a.isMoment(value);
    }
  }
};
var Picker_Picker = {
  name: 'Picker',
  props: {
    animation: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].func, vue_types["a" /* default */].string]),
    disabled: vue_types["a" /* default */].bool,
    transitionName: vue_types["a" /* default */].string,
    format: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].array, vue_types["a" /* default */].func]),
    // onChange: PropTypes.func,
    // onOpenChange: PropTypes.func,
    children: vue_types["a" /* default */].func,
    getCalendarContainer: vue_types["a" /* default */].func,
    calendar: vue_types["a" /* default */].any,
    open: vue_types["a" /* default */].bool,
    defaultOpen: vue_types["a" /* default */].bool.def(false),
    prefixCls: vue_types["a" /* default */].string.def('rc-calendar-picker'),
    placement: vue_types["a" /* default */].any.def('bottomLeft'),
    value: Picker_TimeType,
    defaultValue: Picker_TimeType,
    align: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    dropdownClassName: vue_types["a" /* default */].string,
    dateRender: vue_types["a" /* default */].func
  },
  mixins: [BaseMixin["a" /* default */]],
  data: function data() {
    var props = this.$props;
    var open;

    if (Object(props_util["hasProp"])(this, 'open')) {
      open = props.open;
    } else {
      open = props.defaultOpen;
    }

    var value = props.value || props.defaultValue;
    return {
      sOpen: open,
      sValue: value
    };
  },
  watch: {
    value: function value(val) {
      this.setState({
        sValue: val
      });
    },
    open: function open(val) {
      this.setState({
        sOpen: val
      });
    }
  },
  mounted: function mounted() {
    this.preSOpen = this.sOpen;
  },
  updated: function updated() {
    if (!this.preSOpen && this.sOpen) {
      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
      this.focusTimeout = setTimeout(this.focusCalendar, 0);
    }

    this.preSOpen = this.sOpen;
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.focusTimeout);
  },
  methods: {
    onCalendarKeyDown: function onCalendarKeyDown(event) {
      if (event.keyCode === key_code["a" /* default */].ESC) {
        event.stopPropagation();
        this.closeCalendar(this.focus);
      }
    },
    onCalendarSelect: function onCalendarSelect(value) {
      var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var props = this.$props;

      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }

      var calendarProps = Object(props_util["getOptionProps"])(props.calendar);

      if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !calendarProps.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
        this.closeCalendar(this.focus);
      }

      this.__emit('change', value);
    },
    onKeyDown: function onKeyDown(event) {
      if (!this.sOpen && (event.keyCode === key_code["a" /* default */].DOWN || event.keyCode === key_code["a" /* default */].ENTER)) {
        this.openCalendar();
        event.preventDefault();
      }
    },
    onCalendarOk: function onCalendarOk() {
      this.closeCalendar(this.focus);
    },
    onCalendarClear: function onCalendarClear() {
      this.closeCalendar(this.focus);
    },
    onCalendarBlur: function onCalendarBlur() {
      this.setOpen(false);
    },
    onVisibleChange: function onVisibleChange(open) {
      this.setOpen(open);
    },
    getCalendarElement: function getCalendarElement() {
      var props = this.$props;
      var calendarProps = Object(props_util["getOptionProps"])(props.calendar);
      var calendarEvents = Object(props_util["getEvents"])(props.calendar);
      var value = this.sValue;
      var defaultValue = value;
      var extraProps = {
        ref: 'calendarInstance',
        props: {
          defaultValue: defaultValue || calendarProps.defaultValue,
          selectedValue: value
        },
        on: {
          keydown: this.onCalendarKeyDown,
          ok: Object(createChainedFunction["a" /* default */])(calendarEvents.ok, this.onCalendarOk),
          select: Object(createChainedFunction["a" /* default */])(calendarEvents.select, this.onCalendarSelect),
          clear: Object(createChainedFunction["a" /* default */])(calendarEvents.clear, this.onCalendarClear),
          blur: Object(createChainedFunction["a" /* default */])(calendarEvents.blur, this.onCalendarBlur)
        }
      };
      return Object(vnode["a" /* cloneElement */])(props.calendar, extraProps);
    },
    setOpen: function setOpen(open, callback) {
      if (this.sOpen !== open) {
        if (!Object(props_util["hasProp"])(this, 'open')) {
          this.setState({
            sOpen: open
          }, callback);
        }

        this.__emit('openChange', open);
      }
    },
    openCalendar: function openCalendar(callback) {
      this.setOpen(true, callback);
    },
    closeCalendar: function closeCalendar(callback) {
      this.setOpen(false, callback);
    },
    focus: function focus() {
      if (!this.sOpen) {
        this.$el.focus();
      }
    },
    focusCalendar: function focusCalendar() {
      if (this.sOpen && this.calendarInstance && this.calendarInstance.componentInstance) {
        this.calendarInstance.componentInstance.focus();
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var style = Object(props_util["getStyle"])(this);
    var prefixCls = props.prefixCls,
        placement = props.placement,
        getCalendarContainer = props.getCalendarContainer,
        align = props.align,
        animation = props.animation,
        disabled = props.disabled,
        dropdownClassName = props.dropdownClassName,
        transitionName = props.transitionName;
    var sValue = this.sValue,
        sOpen = this.sOpen;
    var children = this.$scopedSlots.default;
    var childrenState = {
      value: sValue,
      open: sOpen
    };

    if (this.sOpen || !this.calendarInstance) {
      this.calendarInstance = this.getCalendarElement();
    }

    return h(vc_trigger["a" /* default */], {
      attrs: {
        popupAlign: align,
        builtinPlacements: picker_placements,
        popupPlacement: placement,
        action: disabled && !sOpen ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getCalendarContainer,
        popupStyle: style,
        popupAnimation: animation,
        popupTransitionName: transitionName,
        popupVisible: sOpen,
        prefixCls: prefixCls,
        popupClassName: dropdownClassName
      },
      on: {
        "popupVisibleChange": this.onVisibleChange
      }
    }, [h("template", {
      slot: "popup"
    }, [this.calendarInstance]), Object(vnode["a" /* cloneElement */])(children(childrenState, props), {
      on: {
        keydown: this.onKeyDown
      }
    })]);
  }
};
/* harmony default export */ var src_Picker = (Picker_Picker);
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/utils.js
function utils_formatDate(value, format) {
  if (!value) {
    return '';
  }

  if (Array.isArray(format)) {
    format = format[0];
  }

  if (typeof format === 'function') {
    var result = format(value);

    if (typeof result === 'string') {
      return result;
    } else {
      throw new Error('The function of format does not return a string');
    }
  }

  return value.format(format);
}
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/createPicker.jsx
function createPicker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function createPicker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { createPicker_ownKeys(Object(source), true).forEach(function (key) { createPicker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { createPicker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function createPicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





 // import Icon from '../icon';






 // export const PickerProps = {
//   value?: moment.Moment;
//   prefixCls: string;
// }

function createPicker_noop() {}

function createPicker(TheCalendar, props) {
  return {
    props: Object(props_util["initDefaultProps"])(props, {
      allowClear: true,
      showToday: true
    }),
    mixins: [BaseMixin["a" /* default */]],
    model: {
      prop: 'value',
      event: 'change'
    },
    inject: {
      configProvider: {
        default: function _default() {
          return config_provider["ConfigConsumerProps"];
        }
      }
    },
    data: function data() {
      var value = this.value || this.defaultValue;

      if (value && !Object(interopDefault["a" /* default */])(external_moment_).isMoment(value)) {
        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be a moment object');
      }

      return {
        sValue: value,
        showDate: value,
        _open: !!this.open
      };
    },
    watch: {
      open: function open(val) {
        var props = Object(props_util["getOptionProps"])(this);
        var state = {};
        state._open = val;

        if ('value' in props && !val && props.value !== this.showDate) {
          state.showDate = props.value;
        }

        this.setState(state);
      },
      value: function value(val) {
        var state = {};
        state.sValue = val;

        if (val !== this.sValue) {
          state.showDate = val;
        }

        this.setState(state);
      },
      _open: function _open(val, oldVal) {
        var _this = this;

        this.$nextTick(function () {
          if (!Object(props_util["hasProp"])(_this, 'open') && oldVal && !val) {
            _this.focus();
          }
        });
      }
    },
    methods: {
      clearSelection: function clearSelection(e) {
        e.preventDefault();
        e.stopPropagation();
        this.handleChange(null);
      },
      handleChange: function handleChange(value) {
        if (!Object(props_util["hasProp"])(this, 'value')) {
          this.setState({
            sValue: value,
            showDate: value
          });
        }

        this.$emit('change', value, utils_formatDate(value, this.format));
      },
      handleCalendarChange: function handleCalendarChange(value) {
        this.setState({
          showDate: value
        });
      },
      handleOpenChange: function handleOpenChange(open) {
        var props = Object(props_util["getOptionProps"])(this);

        if (!('open' in props)) {
          this.setState({
            _open: open
          });
        }

        this.$emit('openChange', open);
      },
      focus: function focus() {
        this.$refs.input.focus();
      },
      blur: function blur() {
        this.$refs.input.blur();
      },
      renderFooter: function renderFooter() {
        var h = this.$createElement;
        var $scopedSlots = this.$scopedSlots,
            $slots = this.$slots,
            prefixCls = this._prefixCls;
        var renderExtraFooter = this.renderExtraFooter || $scopedSlots.renderExtraFooter || $slots.renderExtraFooter;
        return renderExtraFooter ? h("div", {
          "class": "".concat(prefixCls, "-footer-extra")
        }, [typeof renderExtraFooter === 'function' ? renderExtraFooter.apply(void 0, arguments) : renderExtraFooter]) : null;
      },
      onMouseEnter: function onMouseEnter(e) {
        this.$emit('mouseenter', e);
      },
      onMouseLeave: function onMouseLeave(e) {
        this.$emit('mouseleave', e);
      }
    },
    render: function render() {
      var _classNames,
          _this2 = this,
          _classNames2;

      var h = arguments[0];
      var $scopedSlots = this.$scopedSlots;
      var _this$$data = this.$data,
          value = _this$$data.sValue,
          showDate = _this$$data.showDate,
          open = _this$$data._open;
      var suffixIcon = Object(props_util["getComponentFromProp"])(this, 'suffixIcon');
      suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;
      var listeners = Object(props_util["getListeners"])(this);
      var _listeners$panelChang = listeners.panelChange,
          panelChange = _listeners$panelChang === void 0 ? createPicker_noop : _listeners$panelChang,
          _listeners$focus = listeners.focus,
          focus = _listeners$focus === void 0 ? createPicker_noop : _listeners$focus,
          _listeners$blur = listeners.blur,
          blur = _listeners$blur === void 0 ? createPicker_noop : _listeners$blur,
          _listeners$ok = listeners.ok,
          ok = _listeners$ok === void 0 ? createPicker_noop : _listeners$ok;
      var props = Object(props_util["getOptionProps"])(this);
      var customizePrefixCls = props.prefixCls,
          locale = props.locale,
          localeCode = props.localeCode,
          inputReadOnly = props.inputReadOnly;
      var getPrefixCls = this.configProvider.getPrefixCls;
      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
      this._prefixCls = prefixCls;
      var dateRender = props.dateRender || $scopedSlots.dateRender;
      var monthCellContentRender = props.monthCellContentRender || $scopedSlots.monthCellContentRender;
      var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
      var disabledTime = props.showTime ? props.disabledTime : null;
      var calendarClassName = external_classnames_default()((_classNames = {}, createPicker_defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), createPicker_defineProperty(_classNames, "".concat(prefixCls, "-month"), src_MonthCalendar === TheCalendar), _classNames));

      if (value && localeCode) {
        value.locale(localeCode);
      }

      var pickerProps = {
        props: {},
        on: {}
      };
      var calendarProps = {
        props: {},
        on: {}
      };
      var pickerStyle = {};

      if (props.showTime) {
        // fix https://github.com/ant-design/ant-design/issues/1902
        calendarProps.on.select = this.handleChange; // pickerStyle.minWidth = '195px';
      } else {
        pickerProps.on.change = this.handleChange;
      }

      if ('mode' in props) {
        calendarProps.props.mode = props.mode;
      }

      var theCalendarProps = Object(props_util["mergeProps"])(calendarProps, {
        props: {
          disabledDate: props.disabledDate,
          disabledTime: disabledTime,
          locale: locale.lang,
          timePicker: props.timePicker,
          defaultValue: props.defaultPickerValue || Object(interopDefault["a" /* default */])(external_moment_)(),
          dateInputPlaceholder: placeholder,
          prefixCls: prefixCls,
          dateRender: dateRender,
          format: props.format,
          showToday: props.showToday,
          monthCellContentRender: monthCellContentRender,
          renderFooter: this.renderFooter,
          value: showDate,
          inputReadOnly: inputReadOnly
        },
        on: {
          ok: ok,
          panelChange: panelChange,
          change: this.handleCalendarChange
        },
        class: calendarClassName,
        scopedSlots: $scopedSlots
      });
      var calendar = h(TheCalendar, theCalendarProps); // 清除icon

      var clearIcon = !props.disabled && props.allowClear && value ? h("span", {
        "class": "".concat(prefixCls, "-picker-clear"),
        on: {
          "click": this.clearSelection
        }
      }, [h("meg-icon", {
        attrs: createPicker_defineProperty({
          original: true,
          name: "megui-fill-close-circle",
          width: "12px",
          height: "12px"
        }, "original", true),
        "class": "".concat(prefixCls, "-clear-icon")
      })]) : null;
      var inputIcon = suffixIcon && (Object(props_util["isValidElement"])(suffixIcon) ? Object(vnode["a" /* cloneElement */])(suffixIcon, {
        class: "".concat(prefixCls, "-picker-icon")
      }) : h("span", {
        "class": "".concat(prefixCls, "-picker-icon")
      }, [suffixIcon])) || h("span", {
        attrs: {
          type: "calendar"
        },
        "class": "".concat(prefixCls, "-picker-icon")
      }, [h("meg-icon", {
        attrs: {
          name: "date",
          width: "12px",
          height: "12px"
        }
      })]);

      var input = function input(_ref) {
        var inputValue = _ref.value;
        return h("div", [h("meg-input", {
          ref: "input",
          attrs: {
            disabled: props.disabled,
            readOnly: true,
            value: utils_formatDate(inputValue, _this2.format),
            placeholder: placeholder,
            tabIndex: props.tabIndex,
            name: _this2.name
          },
          on: {
            "focus": focus,
            "blur": blur
          },
          "class": props.pickerInputClass
        }), clearIcon, inputIcon]);
      };

      var vcDatePickerProps = {
        props: createPicker_objectSpread(createPicker_objectSpread(createPicker_objectSpread({}, props), pickerProps.props), {}, {
          calendar: calendar,
          value: value,
          prefixCls: "".concat(prefixCls, "-picker-container")
        }),
        on: createPicker_objectSpread(createPicker_objectSpread(createPicker_objectSpread({}, omit_default()(listeners, 'change')), pickerProps.on), {}, {
          open: open,
          openChange: this.handleOpenChange
        }),
        style: props.popupStyle,
        scopedSlots: createPicker_objectSpread({
          default: input
        }, $scopedSlots)
      };
      var wrapperClass = external_classnames_default()((_classNames2 = {}, createPicker_defineProperty(_classNames2, "".concat(props.pickerClass), true), createPicker_defineProperty(_classNames2, "has-value", !!value), createPicker_defineProperty(_classNames2, "disabled-wrapper", props.disabled), createPicker_defineProperty(_classNames2, "opened", open), _classNames2));
      return h("span", {
        "class": wrapperClass,
        style: pickerStyle // tabIndex={props.disabled ? -1 : 0}
        // onFocus={focus}
        // onBlur={blur}
        ,
        on: {
          "mouseenter": this.onMouseEnter,
          "mouseleave": this.onMouseLeave
        }
      }, [h(src_Picker, vcDatePickerProps)]);
    }
  };
}
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/locale/zh_CN.js
function zh_CN_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function zh_CN_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { zh_CN_ownKeys(Object(source), true).forEach(function (key) { zh_CN_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { zh_CN_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function zh_CN_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var locale_zh_CN_locale = {
  lang: zh_CN_objectSpread({
    placeholder: '请选择日期',
    rangePlaceholder: ['开始日期', '结束日期']
  }, locale_zh_CN),
  timePickerLocale: zh_CN_objectSpread({}, zh_CN)
}; // should add whitespace between char in Button

locale_zh_CN_locale.lang.ok = '确 定'; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

/* harmony default export */ var date_picker_locale_zh_CN = (locale_zh_CN_locale);
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/wrapPicker.jsx
function wrapPicker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function wrapPicker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { wrapPicker_ownKeys(Object(source), true).forEach(function (key) { wrapPicker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { wrapPicker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function wrapPicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var DEFAULT_FORMAT = {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  week: 'gggg-wo',
  month: 'YYYY-MM'
};
var LOCALE_FORMAT_MAPPING = {
  date: 'dateFormat',
  dateTime: 'dateTimeFormat',
  week: 'weekFormat',
  month: 'monthFormat'
};

function getColumns(_ref) {
  var showHour = _ref.showHour,
      showMinute = _ref.showMinute,
      showSecond = _ref.showSecond,
      use12Hours = _ref.use12Hours;
  var column = 0;

  if (showHour) {
    column += 1;
  }

  if (showMinute) {
    column += 1;
  }

  if (showSecond) {
    column += 1;
  }

  if (use12Hours) {
    column += 1;
  }

  return column;
}

function wrapPicker(Picker, props, pickerType) {
  return {
    name: Picker.name,
    props: Object(props_util["initDefaultProps"])(props, {
      transitionName: 'slide-up',
      popupStyle: {},
      locale: {},
      valueFormat: 'x' // 设置绑定值的格式默认是时间戳

    }),
    model: {
      prop: 'value',
      event: 'change'
    },
    inject: {
      configProvider: {
        default: function _default() {
          return config_provider["ConfigConsumerProps"];
        }
      }
    },
    provide: function provide() {
      return {
        savePopupRef: this.savePopupRef
      };
    },
    mounted: function mounted() {
      var _this = this;

      var autoFocus = this.autoFocus,
          disabled = this.disabled,
          value = this.value,
          defaultValue = this.defaultValue,
          valueFormat = this.valueFormat; // console.log('defaultValue======', defaultValue)

      checkValidate('DatePicker', defaultValue, 'defaultValue', valueFormat);
      checkValidate('DatePicker', value, 'value', valueFormat);

      if (autoFocus && !disabled) {
        this.$nextTick(function () {
          _this.focus();
        });
      }
    },
    watch: {
      value: function value(val) {
        checkValidate('DatePicker', val, 'value', this.valueFormat);
      }
    },
    methods: {
      getDefaultLocale: function getDefaultLocale() {
        var result = wrapPicker_objectSpread(wrapPicker_objectSpread({}, date_picker_locale_zh_CN), this.locale);

        result.lang = wrapPicker_objectSpread(wrapPicker_objectSpread({}, result.lang), (this.locale || {}).lang);
        return result;
      },
      savePopupRef: function savePopupRef(ref) {
        this.popupRef = ref;
      },
      handleOpenChange: function handleOpenChange(open) {
        this.$emit('openChange', open);
      },
      handleFocus: function handleFocus(e) {
        this.$emit('focus', e);
      },
      handleBlur: function handleBlur(e) {
        this.$emit('blur', e);
      },
      handleMouseEnter: function handleMouseEnter(e) {
        this.$emit('mouseenter', e);
      },
      handleMouseLeave: function handleMouseLeave(e) {
        this.$emit('mouseleave', e);
      },
      handleChange: function handleChange(date, dateString) {
        this.$emit('change', this.valueFormat ? moment_util_momentToString(date, this.valueFormat) : date, dateString);
      },
      handleOk: function handleOk(val) {
        this.$emit('ok', this.valueFormat ? moment_util_momentToString(val, this.valueFormat) : val);
      },
      handleCalendarChange: function handleCalendarChange(date, dateString) {
        this.$emit('calendarChange', this.valueFormat ? moment_util_momentToString(date, this.valueFormat) : date, dateString);
      },
      focus: function focus() {
        this.$refs.picker.focus();
      },
      blur: function blur() {
        this.$refs.picker.blur();
      },
      transformValue: function transformValue(props) {
        if ('value' in props) {
          props.value = moment_util_stringToMoment(props.value, this.valueFormat);
        }

        if ('defaultValue' in props) {
          props.defaultValue = moment_util_stringToMoment(props.defaultValue, this.valueFormat);
        }

        if ('defaultPickerValue' in props) {
          props.defaultPickerValue = moment_util_stringToMoment(props.defaultPickerValue, this.valueFormat);
        }
      },
      renderPicker: function renderPicker(locale, localeCode) {
        var _classNames2,
            _this2 = this;

        var h = this.$createElement;
        var props = Object(props_util["getOptionProps"])(this);
        this.transformValue(props);
        var customizePrefixCls = props.prefixCls,
            customizeInputPrefixCls = props.inputPrefixCls,
            getCalendarContainer = props.getCalendarContainer,
            size = props.size,
            showTime = props.showTime,
            disabled = props.disabled,
            format = props.format;
        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
        var _this$configProvider = this.configProvider,
            getPrefixCls = _this$configProvider.getPrefixCls,
            getContextPopupContainer = _this$configProvider.getPopupContainer;
        var getPopupContainer = getCalendarContainer || getContextPopupContainer;
        var prefixCls = getPrefixCls('calendar', customizePrefixCls);
        var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
        var pickerClass = external_classnames_default()("".concat(prefixCls, "-picker"), wrapPicker_defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
        var pickerInputClass = external_classnames_default()("".concat(prefixCls, "-picker-input"), (_classNames2 = {}, wrapPicker_defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), wrapPicker_defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), wrapPicker_defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
        var timeFormat = showTime && showTime.format || 'HH:mm:ss';

        var vcTimePickerProps = wrapPicker_objectSpread(wrapPicker_objectSpread({}, generateShowHourMinuteSecond(timeFormat)), {}, {
          format: timeFormat,
          use12Hours: showTime && showTime.use12Hours
        });

        var columns = getColumns(vcTimePickerProps);
        var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
        var timePickerPanelProps = {
          props: wrapPicker_objectSpread(wrapPicker_objectSpread(wrapPicker_objectSpread({}, vcTimePickerProps), showTime), {}, {
            prefixCls: "".concat(prefixCls, "-time-picker"),
            placeholder: locale.timePickerLocale.placeholder,
            transitionName: 'slide-up'
          }),
          class: timePickerCls,
          on: {
            esc: function esc() {}
          }
        };
        var timePicker = showTime ? h(vc_time_picker_Panel, timePickerPanelProps) : null;
        var pickerProps = {
          props: wrapPicker_objectSpread(wrapPicker_objectSpread({}, props), {}, {
            getCalendarContainer: getPopupContainer,
            format: mergedFormat,
            pickerClass: pickerClass,
            pickerInputClass: pickerInputClass,
            locale: locale,
            localeCode: localeCode,
            timePicker: timePicker
          }),
          on: wrapPicker_objectSpread(wrapPicker_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
            openChange: this.handleOpenChange,
            focus: this.handleFocus,
            blur: this.handleBlur,
            mouseenter: this.handleMouseEnter,
            mouseleave: this.handleMouseLeave,
            change: this.handleChange,
            ok: this.handleOk,
            calendarChange: this.handleCalendarChange
          }),
          ref: 'picker',
          scopedSlots: this.$scopedSlots || {}
        };
        return h(Picker, pickerProps, [this.$slots && Object.keys(this.$slots).map(function (key) {
          return h("template", {
            slot: key,
            key: key
          }, [_this2.$slots[key]]);
        })]);
      }
    },
    render: function render() {
      var h = arguments[0];
      return h(LocaleReceiver["a" /* default */], {
        attrs: {
          componentName: "DatePicker",
          defaultLocale: this.getDefaultLocale
        },
        scopedSlots: {
          default: this.renderPicker
        }
      });
    }
  };
}
// CONCATENATED MODULE: ./src/base/vc-calendar/src/range-calendar/CalendarPart.jsx
function CalendarPart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CalendarPart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CalendarPart_ownKeys(Object(source), true).forEach(function (key) { CalendarPart_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CalendarPart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function CalendarPart_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










function CalendarPart_noop() {}

var CalendarPart = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    prefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].any,
    hoverValue: vue_types["a" /* default */].any,
    selectedValue: vue_types["a" /* default */].any,
    direction: vue_types["a" /* default */].any,
    locale: vue_types["a" /* default */].any,
    showDateInput: vue_types["a" /* default */].bool,
    showTimePicker: vue_types["a" /* default */].bool,
    showWeekNumber: vue_types["a" /* default */].bool,
    format: vue_types["a" /* default */].any,
    placeholder: vue_types["a" /* default */].any,
    disabledDate: vue_types["a" /* default */].any,
    timePicker: vue_types["a" /* default */].any,
    disabledTime: vue_types["a" /* default */].any,
    disabledMonth: vue_types["a" /* default */].any,
    mode: vue_types["a" /* default */].any,
    // onInputSelect: PropTypes.func,
    timePickerDisabledTime: vue_types["a" /* default */].object,
    enableNext: vue_types["a" /* default */].any,
    enablePrev: vue_types["a" /* default */].any,
    clearIcon: vue_types["a" /* default */].any,
    dateRender: vue_types["a" /* default */].func,
    inputMode: vue_types["a" /* default */].string,
    inputReadOnly: vue_types["a" /* default */].bool
  },
  render: function render() {
    var h = arguments[0];
    var props = this.$props;
    var prefixCls = props.prefixCls,
        value = props.value,
        hoverValue = props.hoverValue,
        selectedValue = props.selectedValue,
        mode = props.mode,
        direction = props.direction,
        locale = props.locale,
        format = props.format,
        placeholder = props.placeholder,
        disabledDate = props.disabledDate,
        timePicker = props.timePicker,
        disabledTime = props.disabledTime,
        timePickerDisabledTime = props.timePickerDisabledTime,
        showTimePicker = props.showTimePicker,
        enablePrev = props.enablePrev,
        enableNext = props.enableNext,
        disabledMonth = props.disabledMonth,
        showDateInput = props.showDateInput,
        dateRender = props.dateRender,
        showWeekNumber = props.showWeekNumber,
        showClear = props.showClear,
        inputMode = props.inputMode,
        inputReadOnly = props.inputReadOnly;
    var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');

    var _getListeners = Object(props_util["getListeners"])(this),
        _getListeners$inputCh = _getListeners.inputChange,
        inputChange = _getListeners$inputCh === void 0 ? CalendarPart_noop : _getListeners$inputCh,
        _getListeners$inputSe = _getListeners.inputSelect,
        inputSelect = _getListeners$inputSe === void 0 ? CalendarPart_noop : _getListeners$inputSe,
        _getListeners$valueCh = _getListeners.valueChange,
        valueChange = _getListeners$valueCh === void 0 ? CalendarPart_noop : _getListeners$valueCh,
        _getListeners$panelCh = _getListeners.panelChange,
        panelChange = _getListeners$panelCh === void 0 ? CalendarPart_noop : _getListeners$panelCh,
        _getListeners$select = _getListeners.select,
        select = _getListeners$select === void 0 ? CalendarPart_noop : _getListeners$select,
        _getListeners$dayHove = _getListeners.dayHover,
        dayHover = _getListeners$dayHove === void 0 ? CalendarPart_noop : _getListeners$dayHove;

    var shouldShowTimePicker = showTimePicker && timePicker;
    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? getTimeConfig(selectedValue, disabledTime) : null;
    var rangeClassName = "".concat(prefixCls, "-range");
    var newProps = {
      locale: locale,
      value: value,
      prefixCls: prefixCls,
      showTimePicker: showTimePicker
    };
    var index = direction === 'left' ? 0 : 1;
    var timePickerEle = null;

    if (shouldShowTimePicker) {
      var timePickerProps = Object(props_util["getOptionProps"])(timePicker);
      timePickerEle = Object(vnode["a" /* cloneElement */])(timePicker, {
        props: CalendarPart_objectSpread(CalendarPart_objectSpread(CalendarPart_objectSpread(CalendarPart_objectSpread({
          showHour: true,
          showMinute: true,
          showSecond: true
        }, timePickerProps), disabledTimeConfig), timePickerDisabledTime), {}, {
          defaultOpenValue: value,
          value: selectedValue[index]
        }),
        on: {
          change: inputChange
        }
      });
    }

    var dateInputElement = showDateInput && h(date_DateInput, {
      attrs: {
        format: format,
        locale: locale,
        prefixCls: prefixCls,
        timePicker: timePicker,
        disabledDate: disabledDate,
        placeholder: placeholder,
        disabledTime: disabledTime,
        value: value,
        showClear: showClear || false,
        selectedValue: selectedValue[index],
        clearIcon: clearIcon,
        inputMode: inputMode,
        inputReadOnly: inputReadOnly
      },
      on: {
        "change": inputChange,
        "select": inputSelect
      }
    });
    var headerProps = {
      props: CalendarPart_objectSpread(CalendarPart_objectSpread({}, newProps), {}, {
        mode: mode,
        enableNext: enableNext,
        enablePrev: enablePrev,
        disabledMonth: disabledMonth
      }),
      on: {
        valueChange: valueChange,
        panelChange: panelChange
      }
    };
    var tableProps = {
      props: CalendarPart_objectSpread(CalendarPart_objectSpread({}, newProps), {}, {
        hoverValue: hoverValue,
        selectedValue: selectedValue,
        dateRender: dateRender,
        disabledDate: disabledDate,
        showWeekNumber: showWeekNumber
      }),
      on: {
        select: select,
        dayHover: dayHover
      }
    };
    return h("div", {
      "class": "".concat(rangeClassName, "-part ").concat(rangeClassName, "-").concat(direction)
    }, [h("div", {
      style: {
        outline: 'none'
      }
    }, [h(calendar_CalendarHeader, headerProps), showTimePicker ? h("div", {
      "class": "".concat(prefixCls, "-time-picker")
    }, [h("div", {
      "class": "".concat(prefixCls, "-time-picker-panel")
    }, [timePickerEle])]) : null, h("div", {
      "class": "".concat(prefixCls, "-body")
    }, [h(DateTable, tableProps)])])]);
  }
};
/* harmony default export */ var range_calendar_CalendarPart = (CalendarPart);
// CONCATENATED MODULE: ./src/base/vc-calendar/src/RangeCalendar.jsx




function RangeCalendar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }















function RangeCalendar_noop() {}

function isEmptyArray(arr) {
  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
    return !i;
  }));
}

function isArraysEqual(a, b) {
  if (a === b) return true;

  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }

  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
}

function getValueFromSelectedValue(selectedValue) {
  var _selectedValue = _slicedToArray(selectedValue, 2),
      start = _selectedValue[0],
      end = _selectedValue[1];

  if (end && (start === undefined || start === null)) {
    start = end.clone().subtract(1, 'month');
  }

  if (start && (end === undefined || end === null)) {
    end = start.clone().add(1, 'month');
  }

  return [start, end];
}

function normalizeAnchor(props, init) {
  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
  var value = props.value || init && props.defaultValue;
  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [external_moment_default()(), external_moment_default()().add(1, 'months')];
}

function RangeCalendar_generateOptions(length, extraOptionGen) {
  var arr = extraOptionGen ? extraOptionGen().concat() : [];

  for (var value = 0; value < length; value++) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }

  return arr;
}

function onInputSelect(direction, value, cause) {
  if (!value) {
    return;
  }

  var originalValue = this.sSelectedValue;
  var selectedValue = originalValue.concat();
  var index = direction === 'left' ? 0 : 1;
  selectedValue[index] = value;

  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
    selectedValue[1 - index] = this.sShowTimePicker ? selectedValue[index] : undefined;
  }

  this.__emit('inputSelect', selectedValue);

  this.fireSelectValueChange(selectedValue, null, cause || {
    source: 'dateInput'
  });
}

var RangeCalendar = {
  props: {
    locale: vue_types["a" /* default */].object.def(locale_zh_CN),
    visible: vue_types["a" /* default */].bool.def(true),
    prefixCls: vue_types["a" /* default */].string.def('rc-calendar'),
    dateInputPlaceholder: vue_types["a" /* default */].any,
    seperator: vue_types["a" /* default */].string.def('~'),
    defaultValue: vue_types["a" /* default */].any,
    value: vue_types["a" /* default */].any,
    hoverValue: vue_types["a" /* default */].any,
    mode: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOf(['time', 'date', 'month', 'year', 'decade'])),
    showDateInput: vue_types["a" /* default */].bool.def(true),
    timePicker: vue_types["a" /* default */].any,
    showOk: vue_types["a" /* default */].bool,
    showToday: vue_types["a" /* default */].bool.def(true),
    defaultSelectedValue: vue_types["a" /* default */].array.def([]),
    selectedValue: vue_types["a" /* default */].array,
    showClear: vue_types["a" /* default */].bool,
    showWeekNumber: vue_types["a" /* default */].bool,
    // locale: PropTypes.object,
    // onChange: PropTypes.func,
    // onSelect: PropTypes.func,
    // onValueChange: PropTypes.func,
    // onHoverChange: PropTypes.func,
    // onPanelChange: PropTypes.func,
    format: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].string), vue_types["a" /* default */].func]),
    // onClear: PropTypes.func,
    type: vue_types["a" /* default */].any.def('both'),
    disabledDate: vue_types["a" /* default */].func,
    disabledTime: vue_types["a" /* default */].func.def(RangeCalendar_noop),
    renderFooter: vue_types["a" /* default */].func.def(function () {
      return null;
    }),
    renderSidebar: vue_types["a" /* default */].func.def(function () {
      return null;
    }),
    dateRender: vue_types["a" /* default */].func,
    clearIcon: vue_types["a" /* default */].any,
    inputReadOnly: vue_types["a" /* default */].bool
  },
  mixins: [BaseMixin["a" /* default */], CommonMixin],
  data: function data() {
    var props = this.$props;
    var selectedValue = props.selectedValue || props.defaultSelectedValue;
    var value = normalizeAnchor(props, 1);
    return {
      sSelectedValue: selectedValue,
      prevSelectedValue: selectedValue,
      firstSelectedValue: null,
      sHoverValue: props.hoverValue || [],
      sValue: value,
      sShowTimePicker: false,
      sMode: props.mode || ['date', 'date'],
      sPanelTriggerSource: '' // Trigger by which picker panel: 'start' & 'end'

    };
  },
  watch: {
    value: function value() {
      var newState = {};
      newState.sValue = normalizeAnchor(this.$props, 0);
      this.setState(newState);
    },
    hoverValue: function hoverValue(val) {
      if (!isArraysEqual(this.sHoverValue, val)) {
        this.setState({
          sHoverValue: val
        });
      }
    },
    selectedValue: function selectedValue(val) {
      var newState = {};
      newState.sSelectedValue = val;
      newState.prevSelectedValue = val;
      this.setState(newState);
    },
    mode: function mode(val) {
      if (!isArraysEqual(this.sMode, val)) {
        this.setState({
          sMode: val
        });
      }
    }
  },
  methods: {
    onDatePanelEnter: function onDatePanelEnter() {
      if (this.hasSelectedValue()) {
        this.fireHoverValueChange(this.sSelectedValue.concat());
      }
    },
    onDatePanelLeave: function onDatePanelLeave() {
      if (this.hasSelectedValue()) {
        this.fireHoverValueChange([]);
      }
    },
    onSelect: function onSelect(value) {
      var type = this.type,
          sSelectedValue = this.sSelectedValue,
          prevSelectedValue = this.prevSelectedValue,
          firstSelectedValue = this.firstSelectedValue;
      var nextSelectedValue;

      if (type === 'both') {
        if (!firstSelectedValue) {
          syncTime(prevSelectedValue[0], value);
          nextSelectedValue = [value];
        } else if (this.compare(firstSelectedValue, value) < 0) {
          syncTime(prevSelectedValue[1], value);
          nextSelectedValue = [firstSelectedValue, value];
        } else {
          syncTime(prevSelectedValue[0], value);
          syncTime(prevSelectedValue[1], firstSelectedValue);
          nextSelectedValue = [value, firstSelectedValue];
        }
      } else if (type === 'start') {
        syncTime(prevSelectedValue[0], value);
        var endValue = sSelectedValue[1];
        nextSelectedValue = endValue && this.compare(endValue, value) > 0 ? [value, endValue] : [value];
      } else {
        // type === 'end'
        var startValue = sSelectedValue[0];

        if (startValue && this.compare(startValue, value) <= 0) {
          syncTime(prevSelectedValue[1], value);
          nextSelectedValue = [startValue, value];
        } else {
          syncTime(prevSelectedValue[0], value);
          nextSelectedValue = [value];
        }
      }

      this.fireSelectValueChange(nextSelectedValue);
    },
    onKeyDown: function onKeyDown(event) {
      var _this = this;

      if (event.target.nodeName.toLowerCase() === 'input') {
        return;
      }

      var keyCode = event.keyCode;
      var ctrlKey = event.ctrlKey || event.metaKey;
      var _this$$data = this.$data,
          selectedValue = _this$$data.sSelectedValue,
          hoverValue = _this$$data.sHoverValue,
          firstSelectedValue = _this$$data.firstSelectedValue,
          value = _this$$data.sValue;
      var disabledDate = this.$props.disabledDate; // Update last time of the picker

      var updateHoverPoint = function updateHoverPoint(func) {
        // Change hover to make focus in UI
        var currentHoverTime;
        var nextHoverTime;
        var nextHoverValue;

        if (!firstSelectedValue) {
          currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || external_moment_default()();
          nextHoverTime = func(currentHoverTime);
          nextHoverValue = [nextHoverTime];

          _this.fireHoverValueChange(nextHoverValue);
        } else {
          if (hoverValue.length === 1) {
            currentHoverTime = hoverValue[0].clone();
            nextHoverTime = func(currentHoverTime);
            nextHoverValue = _this.onDayHover(nextHoverTime);
          } else {
            currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
            nextHoverTime = func(currentHoverTime);
            nextHoverValue = _this.onDayHover(nextHoverTime);
          }
        } // Find origin hover time on value index


        if (nextHoverValue.length >= 2) {
          var miss = nextHoverValue.some(function (ht) {
            return !includesTime(value, ht, 'month');
          });

          if (miss) {
            var newValue = nextHoverValue.slice().sort(function (t1, t2) {
              return t1.valueOf() - t2.valueOf();
            });

            if (newValue[0].isSame(newValue[1], 'month')) {
              newValue[1] = newValue[0].clone().add(1, 'month');
            }

            _this.fireValueChange(newValue);
          }
        } else if (nextHoverValue.length === 1) {
          // If only one value, let's keep the origin panel
          var oriValueIndex = value.findIndex(function (time) {
            return time.isSame(currentHoverTime, 'month');
          });
          if (oriValueIndex === -1) oriValueIndex = 0;

          if (value.every(function (time) {
            return !time.isSame(nextHoverTime, 'month');
          })) {
            var _newValue = value.slice();

            _newValue[oriValueIndex] = nextHoverTime.clone();

            _this.fireValueChange(_newValue);
          }
        }

        event.preventDefault();
        return nextHoverTime;
      };

      switch (keyCode) {
        case key_code["a" /* default */].DOWN:
          updateHoverPoint(function (time) {
            return toTime_goTime(time, 1, 'weeks');
          });
          return;

        case key_code["a" /* default */].UP:
          updateHoverPoint(function (time) {
            return toTime_goTime(time, -1, 'weeks');
          });
          return;

        case key_code["a" /* default */].LEFT:
          if (ctrlKey) {
            updateHoverPoint(function (time) {
              return toTime_goTime(time, -1, 'years');
            });
          } else {
            updateHoverPoint(function (time) {
              return toTime_goTime(time, -1, 'days');
            });
          }

          return;

        case key_code["a" /* default */].RIGHT:
          if (ctrlKey) {
            updateHoverPoint(function (time) {
              return toTime_goTime(time, 1, 'years');
            });
          } else {
            updateHoverPoint(function (time) {
              return toTime_goTime(time, 1, 'days');
            });
          }

          return;

        case key_code["a" /* default */].HOME:
          updateHoverPoint(function (time) {
            return goStartMonth(time);
          });
          return;

        case key_code["a" /* default */].END:
          updateHoverPoint(function (time) {
            return goEndMonth(time);
          });
          return;

        case key_code["a" /* default */].PAGE_DOWN:
          updateHoverPoint(function (time) {
            return toTime_goTime(time, 1, 'month');
          });
          return;

        case key_code["a" /* default */].PAGE_UP:
          updateHoverPoint(function (time) {
            return toTime_goTime(time, -1, 'month');
          });
          return;

        case key_code["a" /* default */].ENTER:
          {
            var lastValue;

            if (hoverValue.length === 0) {
              lastValue = updateHoverPoint(function (time) {
                return time;
              });
            } else if (hoverValue.length === 1) {
              lastValue = hoverValue[0];
            } else {
              lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
            }

            if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
              this.onSelect(lastValue);
            }

            event.preventDefault();
            return;
          }

        default:
          this.__emit('keydown', event);

      }
    },
    onDayHover: function onDayHover(value) {
      var hoverValue = [];
      var sSelectedValue = this.sSelectedValue,
          firstSelectedValue = this.firstSelectedValue,
          type = this.type;

      if (type === 'start' && sSelectedValue[1]) {
        hoverValue = this.compare(value, sSelectedValue[1]) < 0 ? [value, sSelectedValue[1]] : [value];
      } else if (type === 'end' && sSelectedValue[0]) {
        hoverValue = this.compare(value, sSelectedValue[0]) > 0 ? [sSelectedValue[0], value] : [];
      } else {
        if (!firstSelectedValue) {
          if (this.sHoverValue.length) {
            this.setState({
              sHoverValue: []
            });
          }

          return hoverValue;
        }

        hoverValue = this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
      }

      this.fireHoverValueChange(hoverValue);
      return hoverValue;
    },
    onToday: function onToday() {
      var startValue = getTodayTime(this.sValue[0]);
      var endValue = startValue.clone().add(1, 'months');
      this.setState({
        sValue: [startValue, endValue]
      });
    },
    onOpenTimePicker: function onOpenTimePicker() {
      this.setState({
        sShowTimePicker: true
      });
    },
    onCloseTimePicker: function onCloseTimePicker() {
      this.setState({
        sShowTimePicker: false
      });
    },
    onOk: function onOk() {
      var sSelectedValue = this.sSelectedValue;

      if (this.isAllowedDateAndTime(sSelectedValue)) {
        this.__emit('ok', sSelectedValue);
      }
    },
    onStartInputChange: function onStartInputChange() {
      for (var _len = arguments.length, oargs = new Array(_len), _key = 0; _key < _len; _key++) {
        oargs[_key] = arguments[_key];
      }

      var args = ['left'].concat(oargs);
      return onInputSelect.apply(this, args);
    },
    onEndInputChange: function onEndInputChange() {
      for (var _len2 = arguments.length, oargs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        oargs[_key2] = arguments[_key2];
      }

      var args = ['right'].concat(oargs);
      return onInputSelect.apply(this, args);
    },
    onStartInputSelect: function onStartInputSelect(value) {
      var args = ['left', value, {
        source: 'dateInputSelect'
      }];
      return onInputSelect.apply(this, args);
    },
    onEndInputSelect: function onEndInputSelect(value) {
      var args = ['right', value, {
        source: 'dateInputSelect'
      }];
      return onInputSelect.apply(this, args);
    },
    onStartValueChange: function onStartValueChange(leftValue) {
      var value = _toConsumableArray(this.sValue);

      value[0] = leftValue;
      return this.fireValueChange(value);
    },
    onEndValueChange: function onEndValueChange(rightValue) {
      var value = _toConsumableArray(this.sValue);

      value[1] = rightValue;
      return this.fireValueChange(value);
    },
    onStartPanelChange: function onStartPanelChange(value, mode) {
      var sMode = this.sMode,
          sValue = this.sValue;
      var newMode = [mode, sMode[1]];
      var newValue = [value || sValue[0], sValue[1]];

      this.__emit('panelChange', newValue, newMode);

      var newState = {
        sPanelTriggerSource: 'start'
      };

      if (!Object(props_util["hasProp"])(this, 'mode')) {
        newState.sMode = newMode;
      }

      this.setState(newState);
    },
    onEndPanelChange: function onEndPanelChange(value, mode) {
      var sMode = this.sMode,
          sValue = this.sValue;
      var newMode = [sMode[0], mode];
      var newValue = [sValue[0], value || sValue[1]];

      this.__emit('panelChange', newValue, newMode);

      var newState = {
        sPanelTriggerSource: 'end'
      };

      if (!Object(props_util["hasProp"])(this, 'mode')) {
        newState.sMode = newMode;
      }

      this.setState(newState);
    },
    getStartValue: function getStartValue() {
      var _this$$data2 = this.$data,
          selectedValue = _this$$data2.sSelectedValue,
          showTimePicker = _this$$data2.sShowTimePicker,
          value = _this$$data2.sValue,
          mode = _this$$data2.sMode,
          panelTriggerSource = _this$$data2.sPanelTriggerSource;
      var startValue = value[0]; // keep selectedTime when select date

      if (selectedValue[0] && this.$props.timePicker) {
        startValue = startValue.clone();
        syncTime(selectedValue[0], startValue);
      }

      if (showTimePicker && selectedValue[0]) {
        startValue = selectedValue[0];
      } // Adjust month if date not align


      if (panelTriggerSource === 'end' && mode[0] === 'date' && mode[1] === 'date' && startValue.isSame(value[1], 'month')) {
        startValue = startValue.clone().subtract(1, 'month');
      }

      return startValue;
    },
    getEndValue: function getEndValue() {
      var _this$$data3 = this.$data,
          selectedValue = _this$$data3.sSelectedValue,
          showTimePicker = _this$$data3.sShowTimePicker,
          value = _this$$data3.sValue,
          mode = _this$$data3.sMode,
          panelTriggerSource = _this$$data3.sPanelTriggerSource;
      var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month'); // keep selectedTime when select date

      if (selectedValue[1] && this.$props.timePicker) {
        syncTime(selectedValue[1], endValue);
      }

      if (showTimePicker) {
        endValue = selectedValue[1] ? selectedValue[1] : this.getStartValue();
      } // Adjust month if date not align


      if (!showTimePicker && panelTriggerSource !== 'end' && mode[0] === 'date' && mode[1] === 'date' && endValue.isSame(value[0], 'month')) {
        endValue = endValue.clone().add(1, 'month');
      }

      return endValue;
    },
    // get disabled hours for second picker
    getEndDisableTime: function getEndDisableTime() {
      var sSelectedValue = this.sSelectedValue,
          sValue = this.sValue,
          disabledTime = this.disabledTime;
      var userSettingDisabledTime = disabledTime(sSelectedValue, 'end') || {};
      var startValue = sSelectedValue && sSelectedValue[0] || sValue[0].clone(); // if startTime and endTime is same day..
      // the second time picker will not able to pick time before first time picker

      if (!sSelectedValue[1] || startValue.isSame(sSelectedValue[1], 'day')) {
        var hours = startValue.hour();
        var minutes = startValue.minute();
        var second = startValue.second();
        var _disabledHours = userSettingDisabledTime.disabledHours,
            _disabledMinutes = userSettingDisabledTime.disabledMinutes,
            _disabledSeconds = userSettingDisabledTime.disabledSeconds;
        var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
        var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
        _disabledHours = RangeCalendar_generateOptions(hours, _disabledHours);
        _disabledMinutes = RangeCalendar_generateOptions(minutes, _disabledMinutes);
        _disabledSeconds = RangeCalendar_generateOptions(second, _disabledSeconds);
        return {
          disabledHours: function disabledHours() {
            return _disabledHours;
          },
          disabledMinutes: function disabledMinutes(hour) {
            if (hour === hours) {
              return _disabledMinutes;
            }

            return oldDisabledMinutes;
          },
          disabledSeconds: function disabledSeconds(hour, minute) {
            if (hour === hours && minute === minutes) {
              return _disabledSeconds;
            }

            return olddisabledSeconds;
          }
        };
      }

      return userSettingDisabledTime;
    },
    isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
      return util_isAllowedDate(selectedValue[0], this.disabledDate, this.disabledStartTime) && util_isAllowedDate(selectedValue[1], this.disabledDate, this.disabledEndTime);
    },
    isMonthYearPanelShow: function isMonthYearPanelShow(mode) {
      return ['month', 'year', 'decade'].indexOf(mode) > -1;
    },
    hasSelectedValue: function hasSelectedValue() {
      var sSelectedValue = this.sSelectedValue;
      return !!sSelectedValue[1] && !!sSelectedValue[0];
    },
    compare: function compare(v1, v2) {
      if (this.timePicker) {
        return v1.diff(v2);
      } //   不是timePicker，需要替换成天


      return external_moment_default()(v1.format('YYYY-MM-DD')).diff(v2, 'days');
    },
    fireSelectValueChange: function fireSelectValueChange(selectedValue, direct, cause) {
      var timePicker = this.timePicker,
          prevSelectedValue = this.prevSelectedValue;

      if (timePicker) {
        var timePickerProps = Object(props_util["getOptionProps"])(timePicker);

        if (timePickerProps.defaultValue) {
          var timePickerDefaultValue = timePickerProps.defaultValue;

          if (!prevSelectedValue[0] && selectedValue[0]) {
            syncTime(timePickerDefaultValue[0], selectedValue[0]);
          }

          if (!prevSelectedValue[1] && selectedValue[1]) {
            syncTime(timePickerDefaultValue[1], selectedValue[1]);
          }
        }
      } // 尚未选择过时间，直接输入的话


      if (!this.sSelectedValue[0] || !this.sSelectedValue[1]) {
        var startValue = selectedValue[0] || external_moment_default()();
        var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
        this.setState({
          sSelectedValue: selectedValue,
          sValue: selectedValue && selectedValue.length === 2 ? getValueFromSelectedValue([startValue, endValue]) : this.sValue
        });
      }

      if (selectedValue[0] && !selectedValue[1]) {
        this.setState({
          firstSelectedValue: selectedValue[0]
        });
        this.fireHoverValueChange(selectedValue.concat());
      }

      this.__emit('change', selectedValue);

      if (direct || selectedValue[0] && selectedValue[1]) {
        this.setState({
          prevSelectedValue: selectedValue,
          firstSelectedValue: null
        });
        this.fireHoverValueChange([]);

        this.__emit('select', selectedValue, cause);
      }

      if (!Object(props_util["hasProp"])(this, 'selectedValue')) {
        this.setState({
          sSelectedValue: selectedValue
        });
      }
    },
    fireValueChange: function fireValueChange(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          sValue: value
        });
      }

      this.__emit('valueChange', value);
    },
    fireHoverValueChange: function fireHoverValueChange(hoverValue) {
      if (!Object(props_util["hasProp"])(this, 'hoverValue')) {
        this.setState({
          sHoverValue: hoverValue
        });
      }

      this.__emit('hoverChange', hoverValue);
    },
    clear: function clear() {
      this.fireSelectValueChange([], true);

      this.__emit('clear');
    },
    disabledStartTime: function disabledStartTime(time) {
      return this.disabledTime(time, 'start');
    },
    disabledEndTime: function disabledEndTime(time) {
      return this.disabledTime(time, 'end');
    },
    disabledStartMonth: function disabledStartMonth(month) {
      var sValue = this.sValue;
      return month.isAfter(sValue[1], 'month');
    },
    disabledEndMonth: function disabledEndMonth(month) {
      var sValue = this.sValue;
      return month.isBefore(sValue[0], 'month');
    }
  },
  render: function render() {
    var _className, _cls;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var prefixCls = props.prefixCls,
        dateInputPlaceholder = props.dateInputPlaceholder,
        timePicker = props.timePicker,
        showOk = props.showOk,
        locale = props.locale,
        showClear = props.showClear,
        showToday = props.showToday,
        type = props.type,
        seperator = props.seperator;
    var clearIcon = Object(props_util["getComponentFromProp"])(this, 'clearIcon');
    var sHoverValue = this.sHoverValue,
        sSelectedValue = this.sSelectedValue,
        mode = this.sMode,
        sShowTimePicker = this.sShowTimePicker,
        sValue = this.sValue;
    var className = (_className = {}, RangeCalendar_defineProperty(_className, prefixCls, 1), RangeCalendar_defineProperty(_className, "".concat(prefixCls, "-hidden"), !props.visible), RangeCalendar_defineProperty(_className, "".concat(prefixCls, "-range"), 1), RangeCalendar_defineProperty(_className, "".concat(prefixCls, "-show-time-picker"), sShowTimePicker), RangeCalendar_defineProperty(_className, "".concat(prefixCls, "-week-number"), props.showWeekNumber), _className);
    var baseProps = {
      props: props,
      on: Object(props_util["getListeners"])(this)
    };
    var newProps = {
      props: {
        selectedValue: sSelectedValue
      },
      on: {
        select: this.onSelect,
        dayHover: type === 'start' && sSelectedValue[1] || type === 'end' && sSelectedValue[0] || !!sHoverValue.length ? this.onDayHover : RangeCalendar_noop
      }
    };
    var placeholder1;
    var placeholder2;

    if (dateInputPlaceholder) {
      if (Array.isArray(dateInputPlaceholder)) {
        var _dateInputPlaceholder = _slicedToArray(dateInputPlaceholder, 2);

        placeholder1 = _dateInputPlaceholder[0];
        placeholder2 = _dateInputPlaceholder[1];
      } else {
        placeholder1 = placeholder2 = dateInputPlaceholder;
      }
    }

    var showOkButton = showOk === true || showOk !== false && !!timePicker;
    var cls = (_cls = {}, RangeCalendar_defineProperty(_cls, "".concat(prefixCls, "-header"), true), RangeCalendar_defineProperty(_cls, "".concat(prefixCls, "-range-header"), true), _cls);
    var startValue = this.getStartValue();
    var endValue = this.getEndValue();
    var todayTime = getTodayTime(startValue);
    var thisMonth = todayTime.month();
    var thisYear = todayTime.year();
    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
    var nextMonthOfStart = startValue.clone().add(1, 'months');
    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();
    var leftPartProps = Object(props_util["mergeProps"])(baseProps, newProps, {
      props: {
        hoverValue: sHoverValue,
        direction: 'left',
        disabledTime: this.disabledStartTime,
        disabledMonth: this.disabledStartMonth,
        format: this.getFormat(),
        value: startValue,
        mode: mode[0],
        placeholder: placeholder1,
        showDateInput: this.showDateInput,
        timePicker: timePicker,
        showTimePicker: sShowTimePicker || mode[0] === 'time',
        enablePrev: true,
        enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
        clearIcon: clearIcon
      },
      on: {
        inputChange: this.onStartInputChange,
        inputSelect: this.onStartInputSelect,
        valueChange: this.onStartValueChange,
        panelChange: this.onStartPanelChange
      }
    });
    var rightPartProps = Object(props_util["mergeProps"])(baseProps, newProps, {
      props: {
        hoverValue: sHoverValue,
        direction: 'right',
        format: this.getFormat(),
        timePickerDisabledTime: this.getEndDisableTime(),
        placeholder: placeholder2,
        value: endValue,
        mode: mode[1],
        showDateInput: this.showDateInput,
        timePicker: timePicker,
        showTimePicker: sShowTimePicker || mode[1] === 'time',
        disabledTime: this.disabledEndTime,
        disabledMonth: this.disabledEndMonth,
        enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
        enableNext: true,
        clearIcon: clearIcon
      },
      on: {
        inputChange: this.onEndInputChange,
        inputSelect: this.onEndInputSelect,
        valueChange: this.onEndValueChange,
        panelChange: this.onEndPanelChange
      }
    });
    var TodayButtonNode = null;

    if (showToday) {
      var todayButtonProps = Object(props_util["mergeProps"])(baseProps, {
        props: {
          disabled: isTodayInView,
          value: sValue[0],
          text: locale.backToToday
        },
        on: {
          today: this.onToday
        }
      });
      TodayButtonNode = h(TodayButton, babel_helper_vue_jsx_merge_props_default()([{
        key: "todayButton"
      }, todayButtonProps]));
    }

    var TimePickerButtonNode = null;

    if (props.timePicker) {
      var timePickerButtonProps = Object(props_util["mergeProps"])(baseProps, {
        props: {
          showTimePicker: sShowTimePicker || mode[0] === 'time' && mode[1] === 'time',
          timePickerDisabled: !this.hasSelectedValue() || sHoverValue.length
        },
        on: {
          openTimePicker: this.onOpenTimePicker,
          closeTimePicker: this.onCloseTimePicker
        }
      });
      TimePickerButtonNode = h(TimePickerButton, babel_helper_vue_jsx_merge_props_default()([{
        key: "timePickerButton"
      }, timePickerButtonProps]));
    }

    var OkButtonNode = null;

    if (showOkButton) {
      var okButtonProps = Object(props_util["mergeProps"])(baseProps, {
        props: {
          okDisabled: !this.isAllowedDateAndTime(sSelectedValue) || !this.hasSelectedValue() || sHoverValue.length
        },
        on: {
          ok: this.onOk
        }
      });
      OkButtonNode = h(OkButton, babel_helper_vue_jsx_merge_props_default()([{
        key: "okButtonNode"
      }, okButtonProps]));
    }

    var extraFooter = this.renderFooter(mode);
    return h("div", {
      ref: "rootInstance",
      "class": className,
      attrs: {
        tabIndex: "0"
      },
      on: {
        "keydown": this.onKeyDown
      }
    }, [props.renderSidebar(), h("div", {
      "class": cls
    }, [showToday || props.timePicker || extraFooter ? h("div", {
      "class": "".concat(prefixCls, "-header-btn")
    }, [extraFooter, " "]) : null]), h("div", {
      "class": "".concat(prefixCls, "-panel")
    }, [showClear && sSelectedValue[0] && sSelectedValue[1] ? h("a", {
      attrs: {
        role: "button",
        title: locale.clear
      },
      on: {
        "click": this.clear
      }
    }, [clearIcon || h("span", {
      "class": "".concat(prefixCls, "-clear-btn")
    })]) : null, h("div", {
      "class": "".concat(prefixCls, "-date-panel"),
      on: {
        "mouseleave": type !== 'both' ? this.onDatePanelLeave : RangeCalendar_noop,
        "mouseenter": type !== 'both' ? this.onDatePanelEnter : RangeCalendar_noop
      }
    }, [h(range_calendar_CalendarPart, leftPartProps), h(range_calendar_CalendarPart, rightPartProps)])])]);
  }
};
/* harmony default export */ var src_RangeCalendar = (RangeCalendar);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(18);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);

// CONCATENATED MODULE: ./src/components/timePicker/date-picker/interface.jsx
function interface_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function interface_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { interface_ownKeys(Object(source), true).forEach(function (key) { interface_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { interface_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function interface_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { TimePickerProps } from '../time-picker'


var interface_PickerProps = function PickerProps() {
  return {
    name: vue_types["a" /* default */].string,
    transitionName: vue_types["a" /* default */].string,
    prefixCls: vue_types["a" /* default */].string,
    inputPrefixCls: vue_types["a" /* default */].string,
    format: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].array, vue_types["a" /* default */].func]),
    disabled: vue_types["a" /* default */].bool,
    allowClear: vue_types["a" /* default */].bool,
    suffixIcon: vue_types["a" /* default */].any,
    popupStyle: vue_types["a" /* default */].object,
    dropdownClassName: vue_types["a" /* default */].string,
    locale: vue_types["a" /* default */].any,
    localeCode: vue_types["a" /* default */].string,
    size: vue_types["a" /* default */].oneOf(['large', 'small', 'default']),
    getCalendarContainer: vue_types["a" /* default */].func,
    open: vue_types["a" /* default */].bool,
    // onOpenChange: PropTypes.(status: bool) => void,
    disabledDate: vue_types["a" /* default */].func,
    showToday: vue_types["a" /* default */].bool,
    dateRender: vue_types["a" /* default */].any,
    // (current: moment.Moment, today: moment.Moment) => React.ReactNode,
    pickerClass: vue_types["a" /* default */].string,
    pickerInputClass: vue_types["a" /* default */].string,
    timePicker: vue_types["a" /* default */].any,
    autoFocus: vue_types["a" /* default */].bool,
    tagPrefixCls: vue_types["a" /* default */].string,
    tabIndex: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number]),
    align: vue_types["a" /* default */].object.def(function () {
      return {};
    }),
    inputReadOnly: vue_types["a" /* default */].bool,
    valueFormat: vue_types["a" /* default */].string
  };
};
var interface_SinglePickerProps = function SinglePickerProps() {
  return {
    value: TimeType,
    defaultValue: TimeType,
    defaultPickerValue: TimeType,
    renderExtraFooter: vue_types["a" /* default */].any,
    placeholder: vue_types["a" /* default */].string // onChange?: (date: moment.Moment, dateString: string) => void;

  };
};
var interface_DatePickerProps = function DatePickerProps() {
  return interface_objectSpread(interface_objectSpread(interface_objectSpread({}, interface_PickerProps()), interface_SinglePickerProps()), {}, {
    showTime: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].object, vue_types["a" /* default */].bool]),
    open: vue_types["a" /* default */].bool,
    disabledTime: vue_types["a" /* default */].func,
    // onOpenChange?: (status: bool) => void;
    // onOk?: (selectedTime: moment.Moment) => void;
    mode: vue_types["a" /* default */].oneOf(['time', 'date', 'month', 'year'])
  });
};
var interface_MonthPickerProps = function MonthPickerProps() {
  return interface_objectSpread(interface_objectSpread(interface_objectSpread({}, interface_PickerProps()), interface_SinglePickerProps()), {}, {
    placeholder: vue_types["a" /* default */].string,
    monthCellContentRender: vue_types["a" /* default */].func
  });
}; // export const RangePickerPresetRange = PropTypes.oneOfType([TimesType, PropTypes.func])

var interface_RangePickerProps = function RangePickerProps() {
  return interface_objectSpread(interface_objectSpread({}, interface_PickerProps()), {}, {
    tagPrefixCls: vue_types["a" /* default */].string,
    value: vue_types["a" /* default */].any,
    defaultValue: TimesType,
    defaultPickerValue: TimesType,
    timePicker: vue_types["a" /* default */].any,
    // onChange?: (dates: TimesType, dateStrings: [string, string]) => void;
    // onCalendarChange?: (dates: TimesType, dateStrings: [string, string]) => void;
    // onOk?: (selectedTime: moment.Moment) => void;
    showTime: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].object, vue_types["a" /* default */].bool]),
    ranges: vue_types["a" /* default */].object,
    placeholder: vue_types["a" /* default */].arrayOf(String),
    mode: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].arrayOf(String)]),
    separator: vue_types["a" /* default */].any,
    disabledTime: vue_types["a" /* default */].func,
    showToday: vue_types["a" /* default */].bool,
    renderExtraFooter: vue_types["a" /* default */].any // onPanelChange?: (value?: TimesType, mode?: string | string[]) => void;

  });
};
var interface_WeekPickerProps = function WeekPickerProps() {
  return interface_objectSpread(interface_objectSpread(interface_objectSpread({}, interface_PickerProps()), interface_SinglePickerProps()), {}, {
    placeholder: vue_types["a" /* default */].string
  });
}; // export interface DatePickerDecorator extends React.ClassicComponentClass<DatePickerProps> {
//   RangePicker: React.ClassicComponentClass<RangePickerProps>;
//   MonthPicker: React.ClassicComponentClass<MonthPickerProps>;
//   WeekPicker: React.ClassicComponentClass<WeexPickerProps>;
// }
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/RangePicker.jsx
function RangePicker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function RangePicker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { RangePicker_ownKeys(Object(source), true).forEach(function (key) { RangePicker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { RangePicker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function RangePicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function RangePicker_slicedToArray(arr, i) { return RangePicker_arrayWithHoles(arr) || RangePicker_iterableToArrayLimit(arr, i) || RangePicker_unsupportedIterableToArray(arr, i) || RangePicker_nonIterableRest(); }

function RangePicker_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RangePicker_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RangePicker_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RangePicker_arrayLikeToArray(o, minLen); }

function RangePicker_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function RangePicker_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function RangePicker_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * 日期范围选择器
 */













function RangePicker_noop() {}

function getShowDateFromValue(value, mode) {
  var _value = RangePicker_slicedToArray(value, 2),
      start = _value[0],
      end = _value[1]; // value could be an empty array, then we should not reset showDate


  if (!start && !end) {
    return;
  }

  if (mode && mode[0] === 'month') {
    return [start, end];
  }

  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
  return [start, newEnd];
}

function pickerValueAdapter(value) {
  if (!value) {
    return;
  }

  if (Array.isArray(value)) {
    return value;
  }

  return [value, value.clone().add(1, 'month')];
}

function RangePicker_isEmptyArray(arr) {
  if (Array.isArray(arr)) {
    return arr.length === 0 || arr.every(function (i) {
      return !i;
    });
  }

  return false;
}

function fixLocale(value, localeCode) {
  if (!localeCode) {
    return;
  }

  if (!value || value.length === 0) {
    return;
  }

  var _value2 = RangePicker_slicedToArray(value, 2),
      start = _value2[0],
      end = _value2[1];

  if (start) {
    start.locale(localeCode);
  }

  if (end) {
    end.locale(localeCode);
  }
}

/* harmony default export */ var RangePicker = ({
  name: 'MegDateRangePicker',
  mixins: [BaseMixin["a" /* default */]],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: Object(props_util["initDefaultProps"])(interface_RangePickerProps(), {
    allowClear: true,
    showToday: false,
    separator: '→'
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var value = this.value || this.defaultValue || [];

    var _value3 = RangePicker_slicedToArray(value, 2),
        start = _value3[0],
        end = _value3[1];

    if (start && !Object(interopDefault["a" /* default */])(external_moment_).isMoment(start) || end && !Object(interopDefault["a" /* default */])(external_moment_).isMoment(end)) {
      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
    }

    var pickerValue = !value || RangePicker_isEmptyArray(value) ? this.defaultPickerValue : value;
    return {
      sValue: value,
      sShowDate: pickerValueAdapter(pickerValue || Object(interopDefault["a" /* default */])(external_moment_)()),
      sOpen: this.open,
      sHoverValue: []
    };
  },
  watch: {
    value: function value(val) {
      var value = val || [];
      var state = {
        sValue: value
      };

      if (!shallowequal_default()(val, this.sValue)) {
        state = RangePicker_objectSpread(RangePicker_objectSpread({}, state), {}, {
          sShowDate: getShowDateFromValue(value, this.mode) || this.sShowDate
        });
      }

      this.setState(state);
    },
    open: function open(val) {
      var state = {
        sOpen: val
      };
      this.setState(state);
    },
    sOpen: function sOpen(val, oldVal) {
      var _this = this;

      this.$nextTick(function () {
        if (!Object(props_util["hasProp"])(_this, 'open') && oldVal && !val) {
          _this.focus();
        }
      });
    }
  },
  methods: {
    setValue: function setValue(value, hidePanel) {
      this.handleChange(value);

      if ((hidePanel || !this.showTime) && !Object(props_util["hasProp"])(this, 'open')) {
        this.setState({
          sOpen: false
        });
      }
    },
    clearSelection: function clearSelection(e) {
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        sValue: []
      });
      this.handleChange([]);
    },
    clearHoverValue: function clearHoverValue() {
      this.setState({
        sHoverValue: []
      });
    },
    handleChange: function handleChange(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState(function (_ref) {
          var sShowDate = _ref.sShowDate;
          return {
            sValue: value,
            sShowDate: getShowDateFromValue(value) || sShowDate
          };
        });
      }

      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
        value[1] = undefined;
      }

      var _value4 = RangePicker_slicedToArray(value, 2),
          start = _value4[0],
          end = _value4[1];

      this.$emit('change', value, [utils_formatDate(start, this.format), utils_formatDate(end, this.format)]);
    },
    handleOpenChange: function handleOpenChange(open) {
      if (!Object(props_util["hasProp"])(this, 'open')) {
        this.setState({
          sOpen: open
        });
      }

      if (open === false) {
        this.clearHoverValue();
      }

      this.$emit('openChange', open);
    },
    handleShowDateChange: function handleShowDateChange(showDate) {
      this.setState({
        sShowDate: showDate
      });
    },
    handleHoverChange: function handleHoverChange(hoverValue) {
      this.setState({
        sHoverValue: hoverValue
      });
    },
    handleRangeMouseLeave: function handleRangeMouseLeave() {
      if (this.sOpen) {
        this.clearHoverValue();
      }
    },
    handleCalendarInputSelect: function handleCalendarInputSelect(value) {
      var _value5 = RangePicker_slicedToArray(value, 1),
          start = _value5[0];

      if (!start) {
        return;
      }

      this.setState(function (_ref2) {
        var sShowDate = _ref2.sShowDate;
        return {
          sValue: value,
          sShowDate: getShowDateFromValue(value) || sShowDate
        };
      });
    },
    handleRangeClick: function handleRangeClick(value) {
      if (typeof value === 'function') {
        value = value();
      } // 外部的快捷选项传时间戳


      var arr = value.map(function (item) {
        return external_moment_(+item);
      });
      value = moment_util_stringToMoment(arr, 'x');
      this.setValue(value, true);
      this.$emit('ok', value);
      this.$emit('openChange', false);
    },
    onMouseEnter: function onMouseEnter(e) {
      this.$emit('mouseenter', e);
    },
    onMouseLeave: function onMouseLeave(e) {
      this.$emit('mouseleave', e);
    },
    focus: function focus() {
      this.$refs.picker.focus();
    },
    blur: function blur() {
      this.$refs.picker.blur();
    },
    renderFooter: function renderFooter() {
      var _this2 = this;

      var h = this.$createElement;
      var ranges = this.ranges,
          $scopedSlots = this.$scopedSlots,
          $slots = this.$slots;
      var prefixCls = this._prefixCls,
          tagPrefixCls = this._tagPrefixCls;
      var renderExtraFooter = this.renderExtraFooter || $scopedSlots.renderExtraFooter || $slots.renderExtraFooter;

      if (!ranges && !renderExtraFooter) {
        return null;
      }

      var customFooter = renderExtraFooter ? h("div", {
        "class": "".concat(prefixCls, "-footer-extra"),
        key: "extra"
      }, [typeof renderExtraFooter === 'function' ? renderExtraFooter() : renderExtraFooter]) : null;
      var operations = ranges && Object.keys(ranges).map(function (range) {
        var value = ranges[range];
        var hoverValue = typeof value === 'function' ? value.call(_this2) : value;
        return h("div", {
          key: range,
          "class": "".concat(prefixCls, "-range-quick-selector-item"),
          on: {
            "click": function click() {
              return _this2.handleRangeClick(value);
            },
            "mouseenter": function mouseenter() {
              return _this2.setState({
                sHoverValue: hoverValue
              });
            },
            "mouseleave": _this2.handleRangeMouseLeave
          }
        }, [range]);
      });
      var rangeNode = operations && operations.length > 0 ? h("div", {
        "class": "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
        key: "range"
      }, [operations]) : null;
      return [rangeNode, customFooter];
    }
  },
  render: function render() {
    var _classNames,
        _this3 = this;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var suffixIcon = Object(props_util["getComponentFromProp"])(this, 'suffixIcon');
    suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;
    var value = this.sValue,
        showDate = this.sShowDate,
        hoverValue = this.sHoverValue,
        open = this.sOpen,
        $scopedSlots = this.$scopedSlots;
    var listeners = Object(props_util["getListeners"])(this);
    var _listeners$calendarCh = listeners.calendarChange,
        calendarChange = _listeners$calendarCh === void 0 ? RangePicker_noop : _listeners$calendarCh,
        _listeners$ok = listeners.ok,
        ok = _listeners$ok === void 0 ? RangePicker_noop : _listeners$ok,
        _listeners$focus = listeners.focus,
        focus = _listeners$focus === void 0 ? RangePicker_noop : _listeners$focus,
        _listeners$blur = listeners.blur,
        blur = _listeners$blur === void 0 ? RangePicker_noop : _listeners$blur,
        _listeners$panelChang = listeners.panelChange,
        panelChange = _listeners$panelChang === void 0 ? RangePicker_noop : _listeners$panelChang;
    var customizePrefixCls = props.prefixCls,
        customizeTagPrefixCls = props.tagPrefixCls,
        popupStyle = props.popupStyle,
        disabledDate = props.disabledDate,
        disabledTime = props.disabledTime,
        showTime = props.showTime,
        showToday = props.showToday,
        ranges = props.ranges,
        locale = props.locale,
        localeCode = props.localeCode,
        format = props.format,
        separator = props.separator,
        inputReadOnly = props.inputReadOnly;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('calendar', customizePrefixCls);
    var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls);
    this._prefixCls = prefixCls;
    this._tagPrefixCls = tagPrefixCls;
    var dateRender = props.dateRender || $scopedSlots.dateRender;
    fixLocale(value, localeCode);
    fixLocale(showDate, localeCode);
    var calendarClassName = external_classnames_default()((_classNames = {}, RangePicker_defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), RangePicker_defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange

    var pickerChangeHandler = {
      on: {
        change: this.handleChange
      }
    };
    var calendarProps = {
      on: {
        ok: this.handleChange
      },
      props: {}
    };

    if (props.timePicker) {
      pickerChangeHandler.on.change = function (changedValue) {
        return _this3.handleChange(changedValue);
      };
    } else {
      calendarProps = {
        on: {},
        props: {}
      };
    }

    if ('mode' in props) {
      calendarProps.props.mode = props.mode;
    }

    var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
    var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
    var rangeCalendarProps = Object(props_util["mergeProps"])(calendarProps, {
      props: {
        separator: separator,
        format: format,
        prefixCls: prefixCls,
        renderFooter: this.renderFooter,
        timePicker: props.timePicker,
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
        locale: locale.lang,
        dateRender: dateRender,
        value: showDate,
        hoverValue: hoverValue,
        showToday: showToday,
        inputReadOnly: inputReadOnly
      },
      on: {
        change: calendarChange,
        ok: ok,
        valueChange: this.handleShowDateChange,
        hoverChange: this.handleHoverChange,
        panelChange: panelChange,
        inputSelect: this.handleCalendarInputSelect
      },
      class: calendarClassName,
      scopedSlots: $scopedSlots
    });
    var calendar = h(src_RangeCalendar, rangeCalendarProps); // default width for showTime

    var pickerStyle = {};

    if (props.showTime) {
      pickerStyle.width = '350px';
    }

    var _value6 = RangePicker_slicedToArray(value, 2),
        startValue = _value6[0],
        endValue = _value6[1];

    var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? h("span", {
      "class": "".concat(prefixCls, "-picker-clear"),
      on: {
        "click": this.clearSelection
      }
    }, [h("meg-icon", {
      attrs: {
        original: true,
        name: "megui-fill-close-circle",
        width: "12px",
        height: "12px"
      },
      "class": "".concat(prefixCls, "-clear-icon")
    })]) : null;
    var inputIcon = h("span", {
      "class": "".concat(prefixCls, "-picker-icon")
    }, [h("meg-icon", {
      attrs: {
        original: true,
        name: "date",
        width: "12px",
        height: "12px"
      }
    })]);

    var input = function input(_ref3) {
      var inputValue = _ref3.value;

      var _inputValue = RangePicker_slicedToArray(inputValue, 2),
          start = _inputValue[0],
          end = _inputValue[1];

      return h("span", {
        "class": props.pickerInputClass
      }, [h("meg-input", {
        attrs: {
          disabled: props.disabled,
          readOnly: true,
          value: utils_formatDate(start, props.format),
          placeholder: startPlaceholder,
          tabIndex: -1
        },
        "class": "".concat(prefixCls, "-picker-input-item")
      }), h("span", {
        "class": "".concat(prefixCls, "-range-picker-separator")
      }, [" ", separator, " "]), h("meg-input", {
        attrs: {
          disabled: props.disabled,
          readOnly: true,
          value: utils_formatDate(end, props.format),
          placeholder: endPlaceholder,
          tabIndex: -1
        },
        "class": "".concat(prefixCls, "-picker-input-item")
      }), clearIcon, inputIcon]);
    };

    var vcDatePickerProps = Object(props_util["mergeProps"])({
      props: props,
      on: listeners
    }, pickerChangeHandler, {
      props: {
        calendar: calendar,
        value: value,
        open: open,
        prefixCls: "".concat(prefixCls, "-picker-container")
      },
      on: {
        openChange: this.handleOpenChange
      },
      style: popupStyle,
      scopedSlots: RangePicker_objectSpread({
        default: input
      }, $scopedSlots)
    });
    return h("span", {
      ref: "picker",
      "class": "".concat(props.pickerClass, " range ").concat(startValue && endValue ? 'has-value' : '', " ").concat(props.disabled ? 'disabled-wrapper' : '', " ").concat(open ? 'opened' : ''),
      style: pickerStyle,
      attrs: {
        tabIndex: props.disabled ? -1 : 0
      },
      on: {
        "focus": focus,
        "blur": blur,
        "mouseenter": this.onMouseEnter,
        "mouseleave": this.onMouseLeave
      }
    }, [h(src_Picker, vcDatePickerProps)]);
  }
});
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/InputIcon.jsx
// import Icon from '../icon';


/* harmony default export */ var InputIcon = ({
  functional: true,
  render: function render(h, context) {
    var props = context.props;
    var suffixIcon = props.suffixIcon,
        prefixCls = props.prefixCls;
    return (suffixIcon && Object(props_util["isValidElement"])(suffixIcon) ? Object(vnode["a" /* cloneElement */])(suffixIcon, {
      class: "".concat(prefixCls, "-picker-icon")
    }) : h("span", {
      "class": "".concat(prefixCls, "-picker-icon")
    }, [suffixIcon])) || h("span", {
      attrs: {
        type: "calendar"
      },
      "class": "".concat(prefixCls, "-picker-icon")
    }) // 原本是icon组件
    ;
  }
});
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/WeekPicker.jsx
function WeekPicker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function WeekPicker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { WeekPicker_ownKeys(Object(source), true).forEach(function (key) { WeekPicker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { WeekPicker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function WeekPicker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



 // import Icon from '../icon';








function formatValue(value, format) {
  return value && value.format(format) || '';
}

function WeekPicker_noop() {}

/* harmony default export */ var WeekPicker = ({
  // static defaultProps = {
  //   format: 'YYYY-wo',
  //   allowClear: true,
  // };
  // private input: any;
  name: 'MegWeekPicker',
  mixins: [BaseMixin["a" /* default */]],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: Object(props_util["initDefaultProps"])(interface_WeekPickerProps(), {
    format: 'gggg-wo',
    allowClear: true
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var value = this.value || this.defaultValue;

    if (value && !Object(interopDefault["a" /* default */])(external_moment_).isMoment(value)) {
      throw new Error('The value/defaultValue of WeekPicker or MonthPicker must be a moment object');
    }

    return {
      new_value: value,
      new_open: this.open
    };
  },
  watch: {
    value: function value(val) {
      var state = {
        new_value: val
      };
      this.setState(state);
      this.prevState = WeekPicker_objectSpread(WeekPicker_objectSpread({}, this.$data), state);
    },
    open: function open(val) {
      var state = {
        new_open: val
      };
      this.setState(state);
      this.prevState = WeekPicker_objectSpread(WeekPicker_objectSpread({}, this.$data), state);
    },
    new_open: function new_open(val, oldVal) {
      var _this = this;

      this.$nextTick(function () {
        if (!Object(props_util["hasProp"])(_this, 'open') && oldVal && !val) {
          _this.focus();
        }
      });
    }
  },
  mounted: function mounted() {
    this.prevState = WeekPicker_objectSpread({}, this.$data);
  },
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      if (!Object(props_util["hasProp"])(_this2, 'open') && _this2.prevState.new_open && !_this2.new_open) {
        _this2.focus();
      }
    });
  },
  methods: {
    weekDateRender: function weekDateRender(current) {
      var h = this.$createElement;
      var selectedValue = this.$data.new_value;
      var prefixCls = this._prefixCls,
          $scopedSlots = this.$scopedSlots;
      var dateRender = this.dateRender || $scopedSlots.dateRender;
      var dateNode = dateRender ? dateRender(current) : current.date();

      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
        return h("div", {
          "class": "".concat(prefixCls, "-selected-day")
        }, [h("div", {
          "class": "".concat(prefixCls, "-date")
        }, [dateNode])]);
      }

      return h("div", {
        "class": "".concat(prefixCls, "-date")
      }, [dateNode]);
    },
    handleChange: function handleChange(value) {
      if (!Object(props_util["hasProp"])(this, 'value')) {
        this.setState({
          new_value: value
        });
      }

      this.$emit('change', value, formatValue(value, this.format));
    },
    handleOpenChange: function handleOpenChange(open) {
      if (!Object(props_util["hasProp"])(this, 'open')) {
        this.setState({
          new_open: open
        });
      }

      this.$emit('openChange', open);
    },
    clearSelection: function clearSelection(e) {
      e.preventDefault();
      e.stopPropagation();
      this.handleChange(null);
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    renderFooter: function renderFooter() {
      var h = this.$createElement;
      var prefixCls = this._prefixCls,
          $scopedSlots = this.$scopedSlots;
      var renderExtraFooter = this.renderExtraFooter || $scopedSlots.renderExtraFooter;
      return renderExtraFooter ? h("div", {
        "class": "".concat(prefixCls, "-footer-extra")
      }, [renderExtraFooter.apply(void 0, arguments)]) : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var suffixIcon = Object(props_util["getComponentFromProp"])(this, 'suffixIcon');
    suffixIcon = Array.isArray(suffixIcon) ? suffixIcon[0] : suffixIcon;
    var customizePrefixCls = this.prefixCls,
        disabled = this.disabled,
        pickerClass = this.pickerClass,
        popupStyle = this.popupStyle,
        pickerInputClass = this.pickerInputClass,
        format = this.format,
        allowClear = this.allowClear,
        locale = this.locale,
        localeCode = this.localeCode,
        disabledDate = this.disabledDate,
        defaultPickerValue = this.defaultPickerValue,
        $data = this.$data,
        $scopedSlots = this.$scopedSlots;
    var listeners = Object(props_util["getListeners"])(this);
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('calendar', customizePrefixCls);
    this._prefixCls = prefixCls;
    var pickerValue = $data.new_value,
        open = $data.new_open;
    var _listeners$focus = listeners.focus,
        focus = _listeners$focus === void 0 ? WeekPicker_noop : _listeners$focus,
        _listeners$blur = listeners.blur,
        blur = _listeners$blur === void 0 ? WeekPicker_noop : _listeners$blur;

    if (pickerValue && localeCode) {
      pickerValue.locale(localeCode);
    }

    var placeholder = Object(props_util["hasProp"])(this, 'placeholder') ? this.placeholder : locale.lang.placeholder;
    var weekDateRender = this.dateRender || $scopedSlots.dateRender || this.weekDateRender;
    var calendar = h(vc_calendar, {
      attrs: {
        showWeekNumber: true,
        dateRender: weekDateRender,
        prefixCls: prefixCls,
        format: format,
        locale: locale.lang,
        showDateInput: false,
        showToday: false,
        disabledDate: disabledDate,
        renderFooter: this.renderFooter,
        defaultValue: defaultPickerValue
      }
    });
    var clearIcon = !disabled && allowClear && $data.new_value ? h("span", {
      "class": "".concat(prefixCls, "-picker-clear"),
      on: {
        "click": this.clearSelection
      }
    }, [h("meg-icon", {
      attrs: {
        original: true,
        name: "megui-fill-close-circle",
        width: "12px",
        height: "12px"
      },
      "class": "".concat(prefixCls, "-clear-icon")
    })]) : null;
    var inputIcon = h(InputIcon, {
      attrs: {
        suffixIcon: suffixIcon,
        prefixCls: prefixCls
      }
    });

    var input = function input(_ref) {
      var value = _ref.value;
      return h("span", {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [h("meg-input", {
        ref: "input",
        attrs: {
          disabled: disabled,
          readOnly: true,
          value: value && value.format(format) || '',
          placeholder: placeholder
        },
        "class": pickerInputClass,
        on: {
          "focus": focus,
          "blur": blur
        }
      }), clearIcon, inputIcon]);
    };

    var vcDatePickerProps = {
      props: WeekPicker_objectSpread(WeekPicker_objectSpread({}, props), {}, {
        calendar: calendar,
        prefixCls: "".concat(prefixCls, "-picker-container"),
        value: pickerValue,
        open: open
      }),
      on: WeekPicker_objectSpread(WeekPicker_objectSpread({}, listeners), {}, {
        change: this.handleChange,
        openChange: this.handleOpenChange
      }),
      style: popupStyle,
      scopedSlots: WeekPicker_objectSpread({
        default: input
      }, $scopedSlots)
    };
    return h("span", {
      "class": [pickerClass, this.new_open ? 'opened' : '']
    }, [h(src_Picker, vcDatePickerProps)]);
  }
});
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/date-time-range.jsx
function date_time_range_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 日期时间范围选择器
 */






var DateTimeRangePicker = {
  name: 'MegDateTimeRangePicker',
  model: {
    props: 'value',
    event: 'change'
  },
  props: Object(props_util["initDefaultProps"])(interface_RangePickerProps(), {
    value: [undefined, undefined],
    placeholder: ['开始时间', '结束时间']
  }),
  data: function data() {
    return {
      startStamp: this.value[0],
      endStamp: this.value[1],
      startOpen: false,
      endOpen: false
    };
  },
  computed: {
    checkOpen: function checkOpen() {
      return this.startOpen || this.endOpen;
    }
  },
  inject: {
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  watch: {
    value: function value(val) {
      this.startStamp = val[0];
      this.endStamp = val[1];
    }
  },
  methods: {
    moment: external_moment_default.a,
    changeTime: function changeTime(val, type) {
      if (type === 'startTime') {
        this.startStamp = Number(val);
      } else {
        this.endStamp = Number(val);
      }

      this.$emit('change', [this.startStamp, this.endStamp]);
    },
    renderIcon: function renderIcon(prefixCls) {
      var _this = this,
          _attrs;

      var h = this.$createElement;
      return h("div", {
        "class": "".concat(prefixCls, "-range-icon")
      }, [!!(this.startStamp && this.endStamp) && h("div", {
        "class": "".concat(prefixCls, "-range-icon-clear")
      }, [h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-fill-close-circle",
          width: "12px",
          height: "12px"
        },
        on: {
          "click": function click() {
            _this.changeTime('', 'startTime');

            _this.changeTime('', 'endTime');
          }
        }
      })]), h("div", {
        "class": "".concat(prefixCls, "-range-icon-default")
      }, [h("meg-icon", {
        attrs: (_attrs = {
          original: true,
          name: "time"
        }, date_time_range_defineProperty(_attrs, "original", true), date_time_range_defineProperty(_attrs, "width", "12px"), date_time_range_defineProperty(_attrs, "height", "12px"), _attrs)
      })])]);
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    props = Object(es["a" /* default */])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
    var _props = props,
        customizePrefixCls = _props.prefixCls,
        getCalendarContainer = _props.getCalendarContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('date-time-picker', customizePrefixCls);
    return h("div", {
      "class": "".concat(prefixCls, "-range ").concat(this.startStamp && this.endStamp ? 'has-value' : '', " ").concat(this.disabled ? 'disabled-wrapper' : '', " ").concat(this.checkOpen ? 'opened' : '')
    }, [h(date_picker, {
      attrs: {
        showTime: true,
        disabled: this.disabled,
        placeholder: this.placeholder[0],
        value: this.startStamp ? this.startStamp : '' // defaultValue={this.startStamp ? this.moment(this.startStamp, 'YYYY-MM-DD HH:mm:ss') : ''}
        ,
        format: "YYYY-MM-DD HH:mm:ss",
        allowClear: false,
        getCalendarContainer: getCalendarContainer,
        align: props.align,
        placement: props.placement
      },
      on: {
        "change": function change(val) {
          return _this2.changeTime(val, 'startTime');
        },
        "openChange": function openChange(open) {
          _this2.startOpen = open;
        }
      },
      "class": "meg-calendar-picker-left"
    }), h("span", {
      "class": "".concat(prefixCls, "-range-picker-separator")
    }, ["\u2192"]), h(date_picker, {
      attrs: {
        showTime: true,
        disabled: this.disabled,
        placeholder: this.placeholder[1],
        value: this.endStamp ? this.endStamp : '' // defaultValue={this.endStamp ? this.moment(this.endStamp, 'YYYY-MM-DD HH:mm:ss') : ''}
        ,
        format: "YYYY-MM-DD HH:mm:ss",
        allowClear: false,
        getCalendarContainer: getCalendarContainer,
        align: props.align,
        placement: props.placement
      },
      on: {
        "change": function change(val) {
          return _this2.changeTime(val, 'endTime');
        },
        "openChange": function openChange(open) {
          _this2.endOpen = open;
        }
      },
      "class": "meg-calendar-picker-right"
    }), this.renderIcon(prefixCls)]);
  }
};
/* harmony default export */ var date_time_range = (DateTimeRangePicker);
// CONCATENATED MODULE: ./src/components/timePicker/date-picker/index.jsx
function date_picker_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function date_picker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { date_picker_ownKeys(Object(source), true).forEach(function (key) { date_picker_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { date_picker_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function date_picker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







 // import Base from '../base';

 // import './style/index.scss';

var DatePicker = wrapPicker(date_picker_objectSpread(date_picker_objectSpread({}, createPicker(vc_calendar, interface_DatePickerProps())), {}, {
  name: 'MegDatePicker'
}), interface_DatePickerProps(), 'date');
var MonthPicker = wrapPicker(date_picker_objectSpread(date_picker_objectSpread({}, createPicker(src_MonthCalendar, interface_MonthPickerProps())), {}, {
  name: 'MegMonthPicker'
}), interface_MonthPickerProps(), 'month');
Object.assign(DatePicker, {
  RangePicker: wrapPicker(RangePicker, interface_RangePickerProps(), 'date'),
  MonthPicker: MonthPicker,
  WeekPicker: wrapPicker(WeekPicker, interface_WeekPickerProps(), 'week')
});
/* istanbul ignore next */

DatePicker.install = function (Vue) {
  // Vue.use(Base);
  Vue.component(DatePicker.name, DatePicker);
  Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker);
  Vue.component(DatePicker.MonthPicker.name, DatePicker.MonthPicker);
  Vue.component(DatePicker.WeekPicker.name, DatePicker.WeekPicker);
  Vue.component(date_time_range.name, date_time_range);
};

/* harmony default export */ var date_picker = (DatePicker);
// CONCATENATED MODULE: ./src/components/timePicker/index.jsx


/* harmony default export */ var components_timePicker = __webpack_exports__["default"] = ({
  MegTimePicker: time_picker,
  MegDatePicker: date_picker
});

/***/ })

}]);